/*
 * @license
 * Broadcast Theme (c) Invisible Themes
 *
 * The contents of this file should not be modified.
 * add any minor changes to assets/custom.js
 *
 */ function applySlider() {
  $(document).ready(function () {
    $(".product_collection_slider").length &&
      $(".product_collection_slider").slick({
        infinite: !1,
        arrows: !0,
        dots: !0,
        prevArrow:
          '<button class="slick-prev slick-arrow"><span></span></button>',
        nextArrow:
          '<button class="slick-next slick-arrow"><span></span></button>',
        slidesPerRow: 1,
        fade: !0,
        responsive: [{ breakpoint: 1e3, settings: { arrows: !1, dots: !0 } }],
      });   
  });

   

function startWatching() {
  const drawerEmpty = document.querySelector('.drawer__body .drawer__empty');
  const customReview = document.querySelector('.drawer__body .custom-review');
 
  if (!drawerEmpty || !customReview) {
    console.warn('Cannot find drawerEmpty or customReview');
    return;
  }
 
  function update() {
    const isHidden = drawerEmpty.classList.contains('is-hidden');
    customReview.style.display = isHidden ? 'block' : 'none';
    console.log(`Update: .drawer__empty is ${isHidden ? 'hidden' : 'visible'}`);
  }
 
  update(); // run once initially
 
  const observer = new MutationObserver(update);
  observer.observe(drawerEmpty, { attributes: true, attributeFilter: ['class'] });
}
 
// Delay start to let the DOM load dynamically
setTimeout(startWatching, 1000);



function startWatching() {
    const drawerEmpty = document.querySelector('.drawer__body .drawer__empty');
    const customReview = document.querySelector('.drawer__body .custom-review');
    const drawerMessage = document.querySelector('.drawer__body .drawer__message');
 
    if (!drawerEmpty || !customReview || !drawerMessage) {
      console.warn('Missing drawerEmpty, customReview, or drawerMessage');
      return;
    }
 
    function update() {
      const isHidden = drawerEmpty.classList.contains('is-hidden');
 
      // original behavior
      customReview.style.display = isHidden ? 'block' : 'none';
 
      // reverse behavior
      drawerMessage.style.display = isHidden ? 'none' : 'block';
 
      console.log(`.drawer__empty is ${isHidden ? 'hidden ' : 'visible '}`);
      console.log(`→ customReview: ${isHidden ? 'shown' : 'hidden'}`);
      console.log(`→ drawerMessage: ${isHidden ? 'hidden' : 'shown'}`);
    }
 
    update(); // run once initially
 
    const observer = new MutationObserver(update);
    observer.observe(drawerEmpty, { attributes: true, attributeFilter: ['class'] });
  }
 
  setTimeout(startWatching, 1000); // delay to let DOM fully load



   
}

!(function (t, e, i, s, r, o, a) {
  "use strict";
  function n(t) {
    t.querySelectorAll(".form-field").forEach((t) => {
      let e = t.querySelector("label"),
        i = t.querySelector("input, textarea");
      e &&
        i &&
        (i.addEventListener("keyup", (t) => {
          "" !== t.target.value
            ? e.classList.add("label--float")
            : e.classList.remove("label--float");
        }),
        i.value && i.value.length && e.classList.add("label--float"));
    });
  }
  (window.theme = window.theme || {}),
    (window.theme.sizes = {
      mobile: 480,
      small: 750,
      large: 990,
      widescreen: 1400,
    }),
    (window.theme.focusable =
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  let l = p();
  function h() {
    let t = {};
    return (
      (t.windowHeight = Math.min(window.screen.height, window.innerHeight)),
      (t.footerHeight = m('[data-section-type*="footer"]')),
      (t.headerHeight = m("[data-header-height]")),
      (t.collectionNavHeight = m("[data-collection-nav]")),
      (t.logoHeight = (function () {
        let t = m("[data-footer-logo]");
        return t > 0 ? t + 20 : 0;
      })()),
      t
    );
  }
  function c() {
    document.addEventListener("theme:resize", u), d();
  }
  function d() {
    let {
      windowHeight: t,
      headerHeight: e,
      logoHeight: i,
      footerHeight: s,
      collectionNavHeight: r,
    } = h();
    document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${r}px`
      ),
      document.documentElement.style.setProperty("--footer-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - i / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - s + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function u() {
    let {
        windowHeight: t,
        headerHeight: e,
        logoHeight: i,
        footerHeight: s,
        collectionNavHeight: r,
      } = h(),
      o = p();
    (o !== l || window.innerWidth > window.theme.sizes.mobile) &&
      (document.documentElement.style.setProperty("--full-height", `${t}px`),
      document.documentElement.style.setProperty(
        "--three-quarters",
        t * (3 / 4) + "px"
      ),
      document.documentElement.style.setProperty(
        "--two-thirds",
        t * (2 / 3) + "px"
      ),
      document.documentElement.style.setProperty("--one-half", t / 2 + "px"),
      document.documentElement.style.setProperty("--one-third", t / 3 + "px"),
      (l = o)),
      document.documentElement.style.setProperty(
        "--collection-nav-height",
        `${r}px`
      ),
      document.documentElement.style.setProperty("--header-height", `${e}px`),
      document.documentElement.style.setProperty("--footer-height", `${s}px`),
      document.documentElement.style.setProperty(
        "--content-full",
        t - e - i / 2 + "px"
      ),
      document.documentElement.style.setProperty(
        "--content-min",
        t - e - s + "px"
      ),
      document.querySelector("[data-tracking-consent].popup-cookies--bottom") &&
        document.documentElement.style.setProperty(
          "--cookie-bar-height",
          `${
            document.querySelector(
              "[data-tracking-consent].popup-cookies--bottom"
            ).offsetHeight
          }px`
        );
  }
  function p() {
    return window.matchMedia("(orientation: portrait)").matches
      ? "portrait"
      : window.matchMedia("(orientation: landscape)").matches
      ? "landscape"
      : void 0;
  }
  function m(t) {
    let e = document.querySelector(t);
    return e ? e.offsetHeight : 0;
  }
  window.initialWindowHeight = Math.min(
    window.screen.height,
    window.innerHeight
  );
  let g = !1,
    f = !1;
  function v() {
    setTimeout(() => {
      if (g) return;
      if (!f) return void v();
      let t = document.querySelectorAll('img[loading="lazy"]');
      t.length && t.forEach((t) => {}), (g = !0);
    }, 3e3);
  }
  function y(t, e) {
    let i;
    return function () {
      if (t) {
        let s = () => t.apply(this, arguments);
        clearTimeout(i), (i = setTimeout(s, e));
      }
    };
  }
  function b() {
    return (
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth
    );
  }
  function S() {
    return (
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight
    );
  }
  function E() {
    return b() >= window.theme.sizes.small;
  }
  function L() {
    return b() < window.theme.sizes.small;
  }
  let w = b(),
    k = S(),
    A = window.pageYOffset,
    T = null,
    C = null,
    q = null,
    x = null,
    _ = 0;
  function P() {
    t.clearQueueScrollLocks(),
      t.enablePageScroll(),
      document.documentElement.removeAttribute("data-scroll-locked");
  }
  let H = (t, e = "", i) => {
    let s = i || document.createElement("div");
    return (
      s.classList.add(e), t.parentNode.insertBefore(s, t), s.appendChild(t)
    );
  };
  function B(t) {
    t.querySelectorAll(".rte table").forEach((t) => {
      H(t, "rte__table-wrapper");
    }),
      t
        .querySelectorAll(
          '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
        )
        .forEach((t) => {
          H(t, "rte__video-wrapper");
        });
  }
  function D(t) {
    let e = t.querySelectorAll("[data-aria-toggle]");
    e.length &&
      e.forEach((t) => {
        t.addEventListener("click", function (t) {
          t.preventDefault();
          let e = t.currentTarget;
          e.setAttribute(
            "aria-expanded",
            "false" == e.getAttribute("aria-expanded") ? "true" : "false"
          );
          let i = e.getAttribute("aria-controls"),
            s = document.querySelector(`#${i}`),
            r = () => {
              s.classList.remove("expanding"),
                s.removeEventListener("transitionend", r);
            },
            o = () => {
              s.classList.add("expanding"),
                s.removeEventListener("transitionstart", o);
            };
          s.addEventListener("transitionstart", o),
            s.addEventListener("transitionend", r),
            s.classList.toggle("expanded");
        });
      });
  }
  let M = "is-loading";
  function I(t, e) {
    e = e || {};
    var i = t.tabIndex;
    (t.tabIndex = -1),
      (t.dataset.tabIndex = i),
      t.focus(),
      void 0 !== e.className && t.classList.add(e.className),
      t.addEventListener("blur", function s(r) {
        r.target.removeEventListener(r.type, s),
          (t.tabIndex = i),
          delete t.dataset.tabIndex,
          void 0 !== e.className && t.classList.remove(e.className);
      });
  }
  function F(t) {
    return Array.prototype.slice
      .call(
        t.querySelectorAll(
          "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled"
        )
      )
      .filter(function (t) {
        var e, i;
        return !(
          !(t.offsetWidth || t.offsetHeight || t.getClientRects().length) ||
          ((e = t),
          "none" === (i = window.getComputedStyle(e)).display ||
            "hidden" === i.visibility)
        );
      });
  }
  var O = {};
  function R() {
    document.removeEventListener("focusin", O.focusin),
      document.removeEventListener("focusout", O.focusout),
      document.removeEventListener("keydown", O.keydown);
  }
  var z = Object.freeze({
    __proto__: null,
    forceFocus: I,
    focusHash: function (t) {
      t = t || {};
      var e = window.location.hash,
        i = document.getElementById(e.slice(1));
      if (i && t.ignore && i.matches(t.ignore)) return !1;
      e && i && I(i, t);
    },
    bindInPageLinks: function (t) {
      return (
        (t = t || {}),
        Array.prototype.slice
          .call(document.querySelectorAll('a[href^="#"]'))
          .filter(function (e) {
            if (
              "#" === e.hash ||
              "" === e.hash ||
              (t.ignore && e.matches(t.ignore)) ||
              ((i = e.hash.substr(1)), null === document.getElementById(i))
            )
              return !1;
            var i,
              s = document.querySelector(e.hash);
            return (
              !!s &&
              (e.addEventListener("click", function () {
                I(s, t);
              }),
              !0)
            );
          })
      );
    },
    focusable: F,
    trapFocus: function (t, e) {
      e = e || {};
      var i = F(t),
        s = e.elementToFocus || t,
        r = i[0],
        o = i[i.length - 1];
      R(),
        (O.focusin = function (e) {
          t !== e.target &&
            !t.contains(e.target) &&
            r &&
            r === e.target &&
            r.focus(),
            (e.target !== t && e.target !== o && e.target !== r) ||
              document.addEventListener("keydown", O.keydown);
        }),
        (O.focusout = function () {
          document.removeEventListener("keydown", O.keydown);
        }),
        (O.keydown = function (e) {
          "Tab" !== e.code ||
            (e.target !== o || e.shiftKey || (e.preventDefault(), r.focus()),
            (e.target === t || e.target === r) &&
              e.shiftKey &&
              (e.preventDefault(), o.focus()));
        }),
        document.addEventListener("focusout", O.focusout),
        document.addEventListener("focusin", O.focusin),
        I(s, e);
    },
    removeTrapFocus: R,
    accessibleLinks: function (t, e) {
      if ("string" != typeof t) throw TypeError(t + " is not a String.");
      if (0 !== (t = document.querySelectorAll(t)).length) {
        (e = e || {}).messages = e.messages || {};
        var i,
          s,
          r,
          o = {
            newWindow: e.messages.newWindow || "Opens in a new window.",
            external: e.messages.external || "Opens external website.",
            newWindowExternal:
              e.messages.newWindowExternal ||
              "Opens external website in a new window.",
          },
          a = e.prefix || "a11y",
          n = {
            newWindow: a + "-new-window-message",
            external: a + "-external-message",
            newWindowExternal: a + "-new-window-external-message",
          };
        t.forEach(function (t) {
          var e,
            i = t.getAttribute("target"),
            s = t.getAttribute("rel"),
            r = (e = t).hostname !== window.location.hostname,
            o = "_blank" === i,
            a = null === s || -1 === s.indexOf("noopener");
          o &&
            a &&
            t.setAttribute("rel", null === s ? "noopener" : s + " noopener"),
            r && o
              ? t.setAttribute("aria-describedby", n.newWindowExternal)
              : r
              ? t.setAttribute("aria-describedby", n.external)
              : o && t.setAttribute("aria-describedby", n.newWindow);
        }),
          (i = o),
          (s = document.createElement("ul")),
          (r = Object.keys(i).reduce(function (t, e) {
            return t + "<li id=" + n[e] + ">" + i[e] + "</li>";
          }, "")),
          s.setAttribute("hidden", !0),
          (s.innerHTML = r),
          document.body.appendChild(s);
      }
    },
  });
  let N = 'input[type="search"]',
    W = "hidden",
    U = class extends HTMLElement {
      toggleResetButton() {
        let t = this.resetButton.classList.contains(W);
        this.input.value.length > 0 && t
          ? this.resetButton.classList.remove(W)
          : 0 !== this.input.value.length ||
            t ||
            this.resetButton.classList.add(W);
      }
      onChange() {
        this.toggleResetButton();
      }
      shouldResetForm() {
        return !document.querySelector('[aria-selected="true"] a');
      }
      onFormReset(t) {
        t.preventDefault(),
          this.shouldResetForm() &&
            ((this.input.value = ""),
            this.toggleResetButton(),
            t.target.querySelector(N).focus());
      }
      constructor() {
        super(),
          (this.input = this.querySelector(N)),
          (this.resetButton = this.querySelector('button[type="reset"]')),
          this.input &&
            (this.input.form.addEventListener(
              "reset",
              this.onFormReset.bind(this)
            ),
            this.input.addEventListener(
              "input",
              y((t) => {
                this.onChange(t);
              }, 300).bind(this)
            ));
      }
    };
  customElements.define("header-search-form", U);
  let V = '[aria-selected="true"]',
    j = '[aria-selected="true"] a',
    X = class extends U {
      connectedCallback() {
        this.input.addEventListener("focus", this.onFocus.bind(this)),
          this.input.form.addEventListener(
            "submit",
            this.onFormSubmit.bind(this)
          ),
          this.addEventListener("focusout", this.onFocusOut.bind(this)),
          this.addEventListener("keyup", this.onKeyup.bind(this)),
          this.addEventListener("keydown", this.onKeydown.bind(this));
      }
      getQuery() {
        return this.input.value.trim();
      }
      onChange() {
        var t;
        super.onChange();
        let e = this.getQuery();
        (this.searchTerm && e.startsWith(this.searchTerm)) ||
          null ===
            (t = this.querySelector("[data-search-results-groups-wrapper]")) ||
          void 0 === t ||
          t.remove(),
          this.updateSearchForTerm(this.searchTerm, e),
          (this.searchTerm = e),
          this.searchTerm.length
            ? this.getSearchResults(this.searchTerm)
            : this.reset();
      }
      onFormSubmit(t) {
        (this.getQuery().length && !this.querySelector(j)) ||
          t.preventDefault();
      }
      onFormReset(t) {
        super.onFormReset(t),
          super.shouldResetForm() &&
            ((this.searchTerm = ""),
            this.abortController.abort(),
            (this.abortController = new AbortController()),
            this.closeResults(!0));
      }
      shouldResetForm() {
        return !document.querySelector(j);
      }
      onFocus() {
        let t = this.getQuery();
        t.length &&
          (this.searchTerm !== t
            ? this.onChange()
            : "true" === this.getAttribute("results")
            ? this.open()
            : this.getSearchResults(this.searchTerm));
      }
      onFocusOut() {
        setTimeout(() => {
          this.contains(document.activeElement) || this.close();
        });
      }
      onKeyup(t) {
        switch (
          (this.getQuery().length || this.close(!0), t.preventDefault(), t.code)
        ) {
          case "ArrowUp":
            this.switchOption("up");
            break;
          case "ArrowDown":
            this.switchOption("down");
            break;
          case "Enter":
            this.selectOption();
        }
      }
      onKeydown(t) {
        ("ArrowUp" !== t.code && "ArrowDown" !== t.code) || t.preventDefault();
      }
      updateSearchForTerm(t, e) {
        let i = this.querySelector("[data-predictive-search-search-for-text]"),
          s = null == i ? void 0 : i.innerText;
        if (s) {
          var r;
          if (
            (null === (r = s.match(RegExp(t, "g"))) || void 0 === r
              ? void 0
              : r.length) > 1
          )
            return;
          let o = s.replace(t, e);
          i.innerText = o;
        }
      }
      switchOption(t) {
        if (!this.getAttribute("open")) return;
        let e = "up" === t,
          i = this.querySelector(V),
          s = Array.from(this.querySelectorAll('[role="option"]')).filter(
            (t) => null !== t.offsetParent
          ),
          r = 0;
        if (e && !i) return;
        let o = -1,
          a = 0;
        for (; -1 === o && a <= s.length; ) s[a] === i && (o = a), a++;
        if (
          ((this.statusElement.textContent = ""),
          !e && i
            ? (r = o === s.length - 1 ? 0 : o + 1)
            : e && (r = 0 === o ? s.length - 1 : o - 1),
          r === o)
        )
          return;
        let n = s[r];
        n.setAttribute("aria-selected", !0),
          i && i.setAttribute("aria-selected", !1),
          this.input.setAttribute("aria-activedescendant", n.id);
      }
      selectOption() {
        let t = this.querySelector(
          '[aria-selected="true"] a, button[aria-selected="true"]'
        );
        t && t.click();
      }
      getSearchResults(t) {
        let e = t.replace(" ", "-").toLowerCase();
        this.setLiveRegionLoadingState(),
          this.cachedResults[e]
            ? this.renderSearchResults(this.cachedResults[e])
            : fetch(
                `${theme.routes.predictive_search_url}?q=${encodeURIComponent(
                  t
                )}&section_id=predictive-search`,
                { signal: this.abortController.signal }
              )
                .then((t) => {
                  if (!t.ok) {
                    var e = Error(t.status);
                    throw (this.close(), e);
                  }
                  return t.text();
                })
                .then((t) => {
                  let i = new DOMParser()
                    .parseFromString(t, "text/html")
                    .querySelector(
                      "#shopify-section-predictive-search"
                    ).innerHTML;
                  this.allPredictiveSearchInstances.forEach((t) => {
                    t.cachedResults[e] = i;
                  }),
                    this.renderSearchResults(i);
                })
                .catch((t) => {
                  if (20 !== (null == t ? void 0 : t.code))
                    throw (this.close(), t);
                });
      }
      setLiveRegionLoadingState() {
        (this.statusElement =
          this.statusElement ||
          this.querySelector("[data-predictive-search-status]")),
          (this.loadingText =
            this.loadingText || this.getAttribute("data-loading-text")),
          this.setLiveRegionText(this.loadingText),
          this.setAttribute("loading", !0);
      }
      setLiveRegionText(t) {
        this.statusElement.setAttribute("aria-hidden", "false"),
          (this.statusElement.textContent = t),
          setTimeout(() => {
            this.statusElement.setAttribute("aria-hidden", "true");
          }, 1e3);
      }
      renderSearchResults(t) {
        (this.predictiveSearchResults.innerHTML = t),
          this.setAttribute("results", !0),
          this.setLiveRegionResults(),
          this.open();
      }
      setLiveRegionResults() {
        this.removeAttribute("loading"),
          this.setLiveRegionText(
            this.querySelector(
              "[data-predictive-search-live-region-count-value]"
            ).textContent
          );
      }
      open() {
        this.setAttribute("open", !0),
          this.input.setAttribute("aria-expanded", !0),
          (this.isOpen = !0);
      }
      close(t = !1) {
        this.closeResults(t), (this.isOpen = !1);
      }
      closeResults(t = !1) {
        var e;
        t && ((this.input.value = ""), this.removeAttribute("results"));
        let i = this.querySelector(V);
        i && i.setAttribute("aria-selected", !1),
          this.input.setAttribute("aria-activedescendant", ""),
          this.removeAttribute("loading"),
          this.removeAttribute("open"),
          this.input.setAttribute("aria-expanded", !1),
          (this.resultsMaxHeight = !1),
          null === (e = this.predictiveSearchResults) ||
            void 0 === e ||
            e.removeAttribute("style");
      }
      reset() {
        (this.predictiveSearchResults.innerHTML = ""),
          (this.input.val = ""),
          this.a11y.removeTrapFocus(),
          this.popularSearches &&
            (this.input.dispatchEvent(new Event("blur", { bubbles: !1 })),
            this.a11y.trapFocus(this.searchPopdown, {
              elementToFocus: this.input,
            }));
      }
      constructor() {
        var t;
        super(),
          (this.a11y = z),
          (this.abortController = new AbortController()),
          (this.allPredictiveSearchInstances =
            document.querySelectorAll("predictive-search")),
          (this.cachedResults = {}),
          (this.input = this.querySelector('input[type="search"]')),
          (this.isOpen = !1),
          (this.predictiveSearchResults = this.querySelector(
            "[data-predictive-search-results]"
          )),
          (this.searchPopdown = this.closest("[data-popdown]")),
          (this.popularSearches =
            null === (t = this.searchPopdown) || void 0 === t
              ? void 0
              : t.querySelector("[data-popular-searches]")),
          (this.searchTerm = "");
      }
    },
    Q = "[data-popout-toggle]",
    J = "[data-popout-option]",
    Y = "popout-list--visible",
    G = "is-active",
    K = "select-popout--top",
    Z = "aria-expanded",
    tt = "aria-current",
    te = "data-value",
    ti = "data-popout-toggle-text",
    ts = class extends HTMLElement {
      connectedCallback() {
        (this.popoutList = this.querySelector("[data-popout-list]")),
          (this.popoutToggle = this.querySelector(Q)),
          (this.popoutToggleText = this.querySelector(
            "[data-popout-toggle-text]"
          )),
          (this.popoutInput = this.querySelector("[data-popout-input]")),
          (this.popoutOptions = this.querySelectorAll(J)),
          (this.productGrid = this.popoutList.closest(
            "[data-product-grid-item]"
          )),
          (this.fireSubmitEvent = this.hasAttribute("submit")),
          (this.popupToggleFocusoutEvent = (t) =>
            this.onPopupToggleFocusout(t)),
          (this.popupListFocusoutEvent = (t) => this.onPopupListFocusout(t)),
          (this.popupToggleClickEvent = (t) => this.onPopupToggleClick(t)),
          (this.keyUpEvent = (t) => this.onKeyUp(t)),
          (this.bodyClickEvent = (t) => this.onBodyClick(t)),
          this._connectOptions(),
          this._connectToggle(),
          this._onFocusOut(),
          this.popupListMaxWidth();
      }
      onPopupToggleClick(t) {
        let e = "true" === t.currentTarget.getAttribute(Z);
        if (this.productGrid) {
          let i = this.productGrid.querySelector("[data-product-image]");
          i && i.classList.toggle("is-visible", !e),
            (this.popoutList.style.maxHeight = `${Math.abs(
              this.popoutToggle.getBoundingClientRect().bottom -
                this.productGrid.getBoundingClientRect().bottom
            )}px`);
        }
        t.currentTarget.setAttribute(Z, !e),
          this.popoutList.classList.toggle(Y),
          this.popupListMaxWidth(),
          this.toggleListPosition(),
          document.body.addEventListener("click", this.bodyClickEvent);
      }
      onPopupToggleFocusout(t) {
        this.contains(t.relatedTarget) || this._hideList();
      }
      onPopupListFocusout(t) {
        let e = t.currentTarget.contains(t.relatedTarget);
        this.popoutList.classList.contains(Y) && !e && this._hideList();
      }
      toggleListPosition() {
        let t = "true" === this.querySelector(Q).getAttribute(Z),
          e = window.innerHeight,
          i = this.popoutList.getBoundingClientRect().bottom,
          s = () => {
            this.classList.remove(K),
              this.popoutList.removeEventListener("transitionend", s);
          };
        t
          ? e < i && this.classList.add(K)
          : this.popoutList.addEventListener("transitionend", s);
      }
      popupListMaxWidth() {
        this.popoutList.style.maxWidth = `${parseInt(
          document.body.clientWidth -
            this.popoutList.getBoundingClientRect().left
        )}px`;
      }
      popupOptionsClick(t) {
        if ("#" === t.target.closest(J).attributes.href.value) {
          t.preventDefault();
          let e = "";
          if (
            (t.currentTarget.getAttribute(te) &&
              (e = t.currentTarget.getAttribute(te)),
            (this.popoutInput.value = e),
            this.fireSubmitEvent)
          )
            this._submitForm(e);
          else {
            let i = t.currentTarget.parentElement,
              s = this.popoutList.querySelector(`.${G}`),
              r = this.popoutList.querySelector(`[${tt}]`);
            this.popoutInput.dispatchEvent(new Event("change")),
              s && (s.classList.remove(G), i.classList.add(G)),
              "quantity" != this.popoutInput.name ||
                i.nextSibling ||
                this.classList.add(G),
              r &&
                r.hasAttribute(`${tt}`) &&
                (r.removeAttribute(`${tt}`),
                t.currentTarget.setAttribute(`${tt}`, "true")),
              "" !== e &&
                ((this.popoutToggleText.textContent = e),
                this.popoutToggleText.hasAttribute(ti) &&
                  "" !== this.popoutToggleText.getAttribute(ti) &&
                  this.popoutToggleText.setAttribute(ti, e)),
              this.onPopupToggleFocusout(t),
              this.onPopupListFocusout(t);
          }
        }
      }
      onKeyUp(t) {
        "Escape" === t.code && (this._hideList(), this.popoutToggle.focus());
      }
      onBodyClick(t) {
        let e = this.contains(t.target);
        this.popoutList.classList.contains(Y) && !e && this._hideList();
      }
      _connectToggle() {
        this.popoutToggle.addEventListener("click", this.popupToggleClickEvent);
      }
      _connectOptions() {
        this.popoutOptions.length &&
          this.popoutOptions.forEach((t) => {
            t.addEventListener("click", (t) => this.popupOptionsClick(t));
          });
      }
      _onFocusOut() {
        this.addEventListener("keyup", this.keyUpEvent),
          this.popoutToggle.addEventListener(
            "focusout",
            this.popupToggleFocusoutEvent
          ),
          this.popoutList.addEventListener(
            "focusout",
            this.popupListFocusoutEvent
          );
      }
      _submitForm() {
        let t = this.closest("form");
        t && t.submit();
      }
      _hideList() {
        this.popoutList.classList.remove(Y),
          this.popoutToggle.setAttribute(Z, !1),
          this.toggleListPosition(),
          document.body.removeEventListener("click", this.bodyClickEvent);
      }
      constructor() {
        super();
      }
    },
    tr = class extends HTMLElement {
      connectedCallback() {
        (this.input = this.querySelector("input")),
          (this.changeEvent = new Event("change", { bubbles: !0 })),
          (this.buttonClickEvent = this.onButtonClick.bind(this)),
          this.querySelectorAll("button").forEach((t) =>
            t.addEventListener("click", this.buttonClickEvent)
          );
      }
      onButtonClick(t) {
        t.preventDefault();
        let e = this.input.value,
          i =
            "BUTTON" == t.target.nodeName
              ? t.target
              : t.target.closest("button");
        "increase" === i.name && this.input.stepUp(),
          "decrease" === i.name && this.input.stepDown(),
          e !== this.input.value && this.input.dispatchEvent(this.changeEvent),
          "updates[]" == this.input.name && this.updateCart();
      }
      updateCart() {
        "" !== this.quantityValue &&
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: !0,
              detail: { id: this.input.dataset.id, quantity: this.input.value },
            })
          );
      }

      constructor() {
        super();
      }
    },
    to = "[data-aos]:not(.aos-animate)",
    ta = "[data-aos-anchor]",
    tn = "aos-animate",
    tl = (t) => {
      for (let e of t)
        if ("childList" === e.type) {
          let i = e.target,
            s = i.querySelectorAll(to),
            r = i.querySelectorAll(ta);
          s.length &&
            s.forEach((t) => {
              th.observe(t);
            }),
            r.length && td(r);
        }
    },
    th = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          t.isIntersecting &&
            (t.target.classList.add(tn), e.unobserve(t.target));
        });
      },
      { root: null, rootMargin: "0px", threshold: [0, 0.1, 0.25, 0.5, 0.75, 1] }
    ),
    tc = new IntersectionObserver(
      (t, e) => {
        t.forEach((t) => {
          if (t.intersectionRatio > 0.1) {
            let i = t.target.querySelectorAll(to);
            i.length &&
              i.forEach((t) => {
                t.classList.add(tn);
              }),
              e.unobserve(t.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: [0.1, 0.25, 0.5, 0.75, 1] }
    );
  function td(t) {
    let e = [];
    t.length &&
      t.forEach((t) => {
        let i = t.dataset.aosAnchor;
        if (i && -1 === e.indexOf(i)) {
          let s = document.querySelector(i);
          s && (tc.observe(s), e.push(i));
        }
      });
  }
  let tu = class extends HTMLElement {
      connectedCallback() {
        this.closest(".shopify-section").addEventListener(
          "mouseover",
          () => {
            this.classList.remove("hidden");
          },
          { once: !0 }
        );
      }
      constructor() {
        super();
      }
    },
    tp = class extends HTMLElement {
      loadContent(t = !0) {
        if ((this.pauseAllMedia(), !this.getAttribute("loaded"))) {
          let e = document.createElement("div"),
            i = this.querySelector(
              "template"
            ).content.firstElementChild.cloneNode(!0);
          e.appendChild(i), this.setAttribute("loaded", !0);
          let s = this.appendChild(
            e.querySelector("video, model-viewer, iframe")
          );
          t && s.focus(),
            "VIDEO" == s.nodeName && s.getAttribute("autoplay") && s.play();
        }
      }
      pauseAllMedia() {
        document.querySelectorAll('[data-host="youtube"]').forEach((t) => {
          t.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        }),
          document.querySelectorAll('[data-host="vimeo"]').forEach((t) => {
            t.contentWindow.postMessage('{"method":"pause"}', "*");
          }),
          document.querySelectorAll("video").forEach((t) => t.pause()),
          document.querySelectorAll("product-model").forEach((t) => {
            t.modelViewerUI && t.modelViewerUI.pause();
          });
      }
      constructor() {
        super();
        let t = this.querySelector("[data-deferred-media-button]");
        null == t || t.addEventListener("click", this.loadContent.bind(this));
      }
    },
    tm;
  (window.requestIdleCallback =
    window.requestIdleCallback ||
    function (t) {
      var e = Date.now();
      return setTimeout(function () {
        t({
          didTimeout: !1,
          timeRemaining: function () {
            return Math.max(0, 50 - (Date.now() - e));
          },
        });
      }, 1);
    }),
    (window.cancelIdleCallback =
      window.cancelIdleCallback ||
      function (t) {
        clearTimeout(t);
      }),
    window.theme.settings.enableAnimations &&
      ((function () {
        let t = document.querySelectorAll(to);
        t.length &&
          t.forEach((t) => {
            th.observe(t);
          });
      })(),
      (function () {
        let t = document.querySelectorAll(ta);
        t.length && td(t);
      })(),
      new MutationObserver(tl).observe(document.body, {
        attributes: !1,
        childList: !0,
        subtree: !0,
      })),
    window.addEventListener(
      "resize",
      y(function () {
        document.dispatchEvent(
          new CustomEvent("theme:resize", { bubbles: !0 })
        ),
          w !== b() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:width", { bubbles: !0 })
            ),
            (w = b())),
          k !== S() &&
            (document.dispatchEvent(
              new CustomEvent("theme:resize:height", { bubbles: !0 })
            ),
            (k = S()));
      }, 50)
    ),
    window.addEventListener(
      "scroll",
      function () {
        tm && window.cancelAnimationFrame(tm),
          (tm = window.requestAnimationFrame(function () {
            !(function () {
              let t = window.pageYOffset;
              t > A
                ? ((C = !0), (T = !1))
                : t < A
                ? ((C = !1), (T = !0))
                : ((T = null), (C = null)),
                (A = t),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll", {
                    detail: { up: T, down: C, position: t },
                    bubbles: !1,
                  })
                ),
                T &&
                  !q &&
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:up", {
                      detail: { position: t },
                      bubbles: !1,
                    })
                  ),
                C &&
                  !x &&
                  document.dispatchEvent(
                    new CustomEvent("theme:scroll:down", {
                      detail: { position: t },
                      bubbles: !1,
                    })
                  ),
                (x = C),
                (q = T);
            })();
          }));
      },
      { passive: !0 }
    ),
    window.addEventListener("theme:scroll:lock", function e(i) {
      setTimeout(() => {
        _ && clearTimeout(_),
          t.disablePageScroll(i.detail, {
            allowTouchMove: (t) => "TEXTAREA" === t.tagName,
          }),
          document.documentElement.setAttribute("data-scroll-locked", "");
      });
    }),
    window.addEventListener("theme:scroll:unlock", function t(e) {
      let i = e.detail;
      i ? (_ = setTimeout(P, i)) : P();
    }),
    "ontouchstart" in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
      ? ((document.documentElement.className =
          document.documentElement.className.replace(
            "no-touch",
            "supports-touch"
          )),
        (window.theme.touch = !0))
      : (window.theme.touch = !1),
    d(),
    document.addEventListener(
      "load",
      (t) => {
        "IMG" == t.target.tagName &&
          t.target.classList.contains(M) &&
          (t.target.classList.remove(M),
          t.target.parentNode.classList.remove(M));
      },
      !0
    ),
    window.addEventListener("DOMContentLoaded", () => {
      c(),
        D(document),
        n(document),
        B(document),
        document.querySelectorAll("img.is-loading").forEach((t) => {
          t.complete &&
            (t.classList.remove(M), t.parentNode.classList.remove(M));
        }),
        document.body.classList.add("is-loaded"),
        window.fastNetworkAndCPU &&
          ((document.onreadystatechange = () => {
            "complete" === document.readyState && ((f = !0), v());
          }),
          requestIdleCallback(v)),
        requestIdleCallback(() => {
          Shopify.visualPreviewMode &&
            document.documentElement.classList.add("preview-mode");
        });
    }),
    document.addEventListener("shopify:section:load", (t) => {
      let e = t.target;
      n(e), B(e), D(document), c();
    }),
    customElements.get("popout-select") ||
      customElements.define("popout-select", ts),
    customElements.get("quantity-counter") ||
      customElements.define("quantity-counter", tr),
    customElements.get("predictive-search") ||
      customElements.define("predictive-search", X),
    customElements.get("deferred-image") ||
      customElements.define("deferred-image", tu),
    customElements.get("deferred-media") ||
      customElements.define("deferred-media", tp);
  let tg = (t, e = !1, i = "block") => {
    t && (e ? t.style.removeProperty("display") : (t.style.display = i));
  };
  Shopify.Products = (function () {
    let t = {
        howManyToShow: 4,
        howManyToStoreInMemory: 10,
        wrapperId: "recently-viewed-products",
        section: null,
        onComplete: null,
      },
      e = [],
      i = null,
      s = null,
      r = new Date(),
      o = new Date();
    o.setTime(r.getTime() + 7776e6);
    let a = {
        configuration: {
          expires: o.toGMTString(),
          path: "/",
          domain: window.location.hostname,
          sameSite: "none",
          secure: !0,
        },
        name: "shopify_recently_viewed",
        write: function (t) {
          let e = t.join(" ");
          document.cookie = `${this.name}=${e}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`;
        },
        read: function () {
          let t = [],
            e = null;
          return (
            -1 !== document.cookie.indexOf("; ") &&
              document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name)) &&
              (e = document.cookie
                .split("; ")
                .find((t) => t.startsWith(this.name))
                .split("=")[1]),
            null !== e && (t = e.split(" ")),
            t
          );
        },
        destroy: function () {
          document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`;
        },
        remove: function (t) {
          let e = this.read(),
            i = e.indexOf(t);
          -1 !== i && (e.splice(i, 1), this.write(e));
        },
      },
      n = (e, i, r, o) => {
        i.length && e < t.howManyToShow
          ? fetch(
              `${window.theme.routes.root}products/${i[0]}?section_id=api-product-grid-item`
            )
              .then((t) => t.text())
              .then((t) => {
                let s = 150 * e,
                  a = 100 * e + 800,
                  l = 50 * e + 800,
                  h = r.id ? `#${r.id}` : "",
                  c = document.createElement("div"),
                  d = t.includes("||itemIndex||")
                    ? t.replaceAll("||itemIndex||", e)
                    : t;
                (d = (d = (d = (d = d.includes("||itemAosDelay||")
                  ? d.replaceAll("||itemAosDelay||", s)
                  : d).includes("||itemAosImageDuration||")
                  ? d.replaceAll("||itemAosImageDuration||", a)
                  : d).includes("||itemAosTextDuration||")
                  ? d.replaceAll("||itemAosTextDuration||", l)
                  : d).includes("||itemAnimationAnchor||")
                  ? d.replaceAll("||itemAnimationAnchor||", h)
                  : d),
                  (c.innerHTML = d),
                  (r.innerHTML +=
                    c.querySelector("[data-api-content]").innerHTML),
                  i.shift(),
                  n(++e, i, r, o);
              })
              .catch(() => {
                a.remove(i[0]), i.shift(), n(e, i, r, o);
              })
          : ((e, i) => {
              tg(e, !0);
              let r = a.read().length;
              if (
                Shopify.recentlyViewed &&
                s &&
                r &&
                r < s &&
                e.children.length
              ) {
                let o = [],
                  n = [],
                  l = 0;
                for (let h in Shopify.recentlyViewed) {
                  l += 1;
                  let c = Shopify.recentlyViewed[h].split(" "),
                    d = parseInt(h.split("_")[1]);
                  (o = [...o, ...c]),
                    (a.read().length !== d &&
                      (l !== Object.keys(Shopify.recentlyViewed).length ||
                        n.length)) ||
                      (n = [...n, ...c]);
                }
                for (let u = 0; u < e.children.length; u++) {
                  let p = e.children[u];
                  o.length && p.classList.remove(...o),
                    n.length && p.classList.add(...n);
                }
              }
              if (t.onComplete)
                try {
                  t.onComplete(e, i);
                } catch (m) {
                  console.log(m);
                }
            })(r, o);
      };
    return {
      showRecentlyViewed: function (r) {
        Object.assign(t, r || {}),
          (e = a.read()),
          (i = document.querySelector(`#${t.wrapperId}`)),
          (s = t.howManyToShow),
          (t.howManyToShow = Math.min(e.length, t.howManyToShow)),
          t.howManyToShow && i && n(0, e, i, t.section);
      },
      getConfig: function () {
        return t;
      },
      clearList: function () {
        a.destroy();
      },
      recordRecentlyViewed: function (e) {
        Object.assign(t, e || {});
        let i = a.read();
        if (-1 !== window.location.pathname.indexOf("/products/")) {
          let s = decodeURIComponent(window.location.pathname)
            .match(
              /\/products\/([a-z0-9\-]|[\u3000-\u303F]|[\u3040-\u309F]|[\u30A0-\u30FF]|[\uFF00-\uFFEF]|[\u4E00-\u9FAF]|[\u2605-\u2606]|[\u2190-\u2195]|[\u203B]|[\w\u0430-\u044f]|[\u0400-\u04FF]|[\u0900-\u097F]|[\u0590-\u05FF\u200f\u200e]|[\u0621-\u064A\u0660-\u0669 ])+/
            )[0]
            .split("/products/")[1];
          t.handle && (s = t.handle);
          let r = i.indexOf(s);
          -1 === r
            ? (i.unshift(s), (i = i.splice(0, t.howManyToStoreInMemory)))
            : (i.splice(r, 1), i.unshift(s)),
            a.write(i);
        }
      },
      hasProducts: a.read().length > 0,
    };
  })();
  let tf = (t, e = [], i = !1) => {
      let s = Object.keys(t)
        .map((s) => {
          let r = t[s];
          if (
            "[object Object]" === Object.prototype.toString.call(r) ||
            Array.isArray(r)
          )
            return (
              Array.isArray(t) ? e.push("") : e.push(s),
              tf(r, e, Array.isArray(r))
            );
          {
            let o = s;
            return (
              e.length > 0 &&
                (o = (i ? e : [...e, s]).reduce(
                  (t, e) => ("" === t ? e : `${t}[${e}]`),
                  ""
                )),
              i ? `${o}[]=${r}` : `${o}=${r}`
            );
          }
        })
        .join("&");
      return e.pop(), s;
    },
    tv = (t) => {
      t && (t.style.display = "none");
    },
    ty = (t, e, i = null) => {
      (t.style.opacity = 0), (t.style.display = e || "block");
      let s = !0;
      !(function e() {
        let r = parseFloat(t.style.opacity);
        (r += 0.1) > 1 || ((t.style.opacity = r), requestAnimationFrame(e)),
          1 === parseInt(r) && s && "function" == typeof i && ((s = !1), i());
      })();
    };
  function tb(t) {
    (this.status = t.status || null),
      (this.headers = t.headers || null),
      (this.json = t.json || null),
      (this.body = t.body || null);
  }
  tb.prototype = Error.prototype;
  let tS = "#address_zip",
    tE = "data-default",
    tL = "center",
    tw = "disabled",
    tk = class extends HTMLElement {
      connectedCallback() {
        let t = document.querySelector("html"),
          i = "en";
        if (
          (t.hasAttribute("lang") &&
            "" !== t.getAttribute("lang") &&
            (i = t.getAttribute("lang")),
          this.fieldsContainer &&
            e.AddressForm(this.fieldsContainer, i, {
              shippingCountriesOnly: !0,
            }),
          this.selectCountry &&
            this.selectCountry.hasAttribute(tE) &&
            this.selectProvince &&
            this.selectProvince.hasAttribute(tE) &&
            this.selectCountry.addEventListener(
              "change",
              this.onCountryChangeEvent
            ),
          this.getRatesButton &&
            (this.getRatesButton.addEventListener(
              "click",
              this.onButtonClickEvent
            ),
            theme.settings.customerLoggedIn &&
              this.getRatesButton.classList.contains("get-rates--trigger")))
        ) {
          let s = document.querySelector(tS);
          s && s.value && this.getRatesButton.dispatchEvent(new Event("click"));
        }
      }
      disconnectedCallback() {
        this.selectCountry &&
          this.selectCountry.hasAttribute(tE) &&
          this.selectProvince &&
          this.selectProvince.hasAttribute(tE) &&
          this.selectCountry.removeEventListener(
            "change",
            this.onCountryChangeEvent
          ),
          this.getRatesButton &&
            this.getRatesButton.removeEventListener(
              "click",
              this.onButtonClickEvent
            );
      }
      onCountryChange() {
        this.selectCountry.removeAttribute(tE),
          this.selectProvince.removeAttribute(tE);
      }
      onButtonClick() {
        for (this.disableButtons(); this.wrapper.firstChild; )
          this.wrapper.removeChild(this.wrapper.firstChild);
        tv(this.wrapper);
        let t = {},
          e = this.selectCountry.value,
          i = this.selectProvince.value,
          s = this.selectCountry.getAttribute(tE);
        "" === e && s && "" !== s && (e = s);
        let r = this.selectProvince.getAttribute(tE);
        "" === i && r && "" !== r && (i = r),
          (t.zip = document.querySelector(tS).value || ""),
          (t.country = e || ""),
          (t.province = i || ""),
          this.getCartShippingRatesForDestination(t);
      }
      formatRate(t) {
        return "0.00" === t
          ? window.theme.strings.free
          : i.formatMoney(t, theme.moneyFormat);
      }
      render(t) {
        if (this.template && this.wrapper) {
          this.wrapper.innerHTML = "";
          let e = "",
            i = "",
            s = `error ${tL}`,
            r = this.template.innerHTML,
            o = /[^[\]]+(?=])/g;
          if (t.rates && t.rates.length) {
            let a = o.exec(r)[0];
            t.rates.forEach((t) => {
              let i = a;
              e += i = (i = i.replace(/\|\|rateName\|\|/, t.name)).replace(
                /\|\|ratePrice\|\|/,
                this.formatRate(t.price)
              );
            });
          }
          if (t.success) {
            s = `success ${tL}`;
            let n = document.createElement("div");
            n.innerHTML = this.template.innerHTML;
            let l = n.querySelector("[data-template-no-shipping]");
            t.rates.length < 1 &&
              l &&
              (i = l.getAttribute("data-template-no-shipping"));
          } else i = t.errorFeedback;
          (r = (r = (r = (r = r.replace(o, "").replace("[]", "")).replace(
            /\|\|ratesList\|\|/g,
            e
          )).replace(/\|\|successClass\|\|/g, s)).replace(
            /\|\|ratesText\|\|/g,
            i
          )),
            (this.wrapper.innerHTML += r),
            ty(this.wrapper);
        }
      }
      enableButtons() {
        this.getRatesButton.removeAttribute("disabled"),
          this.getRatesButton.classList.remove(tw),
          (this.getRatesButton.textContent =
            theme.strings.shippingCalcSubmitButton);
      }
      disableButtons() {
        this.getRatesButton.setAttribute("disabled", "disabled"),
          this.getRatesButton.classList.add(tw),
          (this.getRatesButton.textContent =
            theme.strings.shippingCalcSubmitButtonDisabled);
      }
      getCartShippingRatesForDestination(t) {
        let e = encodeURI(tf({ shipping_address: t })),
          i = `${theme.routes.cart_url}/shipping_rates.json?${e}`;
        fetch(i)
          .then(this.handleErrors)
          .then((t) => t.text())
          .then((e) => {
            let i = JSON.parse(e).shipping_rates;
            this.onCartShippingRatesUpdate(i, t);
          })
          .catch((t) => {
            this.onError(t.json);
          });
      }
      fullMessagesFromErrors(t) {
        let e = [];
        for (let i in t) for (let s of t[i]) e.push(s);
        return e;
      }
      handleErrors(t) {
        return t.ok
          ? t
          : t.json().then(function (e) {
              throw new tb({
                status: t.statusText,
                headers: t.headers,
                json: e,
              });
            });
      }
      onError(t) {
        this.enableButtons();
        let e = "";
        "Error : country is not supported." ==
          (e = t.message
            ? t.message + "(" + t.status + "): " + t.description
            : "Error : " + this.fullMessagesFromErrors(t).join("; ")) &&
          (e = "We do not ship to this destination."),
          this.render({ rates: [], errorFeedback: e, success: !1 });
      }
      onCartShippingRatesUpdate(t, e) {
        this.enableButtons();
        let i = "";
        e.zip && (i += e.zip + ", "),
          e.province && (i += e.province + ", "),
          (i += e.country),
          this.render({ rates: t, address: i, success: !0 });
      }
      constructor() {
        super(),
          (this.getRatesButton = this.querySelector(".get-rates")),
          (this.fieldsContainer = this.querySelector("#address_container")),
          (this.selectCountry = this.querySelector("#address_country")),
          (this.selectProvince = this.querySelector("#address_province")),
          (this.template = this.querySelector(
            "#shipping-calculator-response-template"
          )),
          (this.wrapper = this.querySelector("#wrapper-response")),
          (this.onCountryChangeEvent = () => this.onCountryChange()),
          (this.onButtonClickEvent = () => this.onButtonClick());
      }
    },
    t$ = (t, e) => {
      let i, s;
      return function r(...o) {
        let a = Date.now();
        (s = clearTimeout(s)),
          !i || a - i >= e
            ? (t.apply(null, o), (i = a))
            : (s = setTimeout(r.bind(null, ...o), e - (a - i)));
      };
    },
    tA = "is-animated",
    tT = "is-added",
    tC = "is-disabled",
    tq = "is-hidden",
    tx = "is-hiding",
    t_ = "is-loading",
    tP = "is-open",
    tH = "is-visible",
    tB = "is-expanded",
    t8 = "is-updated",
    tD = "[data-animation]",
    tM = "[data-cart-drawer-close]",
    tI = "[data-item-remove]",
    t9 = "[data-cart-acceptance-checkbox]",
    tF = "[data-cart-total]",
    tO = "[data-cart-errors-container]",
    tR = "[data-form-wrapper]",
    tz = "[data-free-shipping]",
    tN = "[data-item]",
    tW = "[data-quick-add-holder]",
    tU = 'input[name="updates[]"]',
    t0 = "[data-terms-error-message]",
    tV = "data-cart-total",
    tj = "disabled",
    t3 = "data-free-shipping",
    t1 = "data-item-index",
    t2 = "data-item-title",
    tX = "data-quick-add-holder";
  (window.cart = new (class {
    init() {
      (this.cartPage = document.querySelector("[data-cart-page]")),
        (this.cartForm = document.querySelector("[data-cart-form]")),
        (this.cartDrawer = document.querySelector("[data-cart-drawer]")),
        (this.cartDrawerClose = document.querySelector(tM)),
        (this.cartEmpty = document.querySelector("[data-cart-empty]")),
        (this.cartTermsCheckbox = document.querySelector(t9)),
        (this.cartCheckoutButtonWrapper = document.querySelector(
          "[data-cart-checkout-buttons]"
        )),
        (this.cartCheckoutButton = document.querySelector(
          "[data-cart-checkout-button]"
        )),
        (this.buttonHolder = document.querySelector("[data-foot-holder]")),
        (this.itemsHolder = document.querySelector("[data-items-holder]")),
        (this.priceHolder = document.querySelector("[data-cart-price-holder]")),
        (this.items = document.querySelectorAll(tN)),
        (this.cartTotal = document.querySelector(tF)),
        (this.freeShipping = document.querySelectorAll(tz)),
        (this.cartErrorHolder = document.querySelector("[data-cart-errors]")),
        (this.cartCloseErrorMessage = document.querySelector(
          "[data-cart-error-close]"
        )),
        (this.headerWrapper = document.querySelector("[data-header-wrapper]")),
        (this.accessibility = z),
        (this.navDrawer = document.querySelector("[data-drawer]")),
        (this.upsellProductsHolder = document.querySelector(
          "[data-upsell-products]"
        )),
        (this.subtotal = window.theme.subtotal),
        (this.cart = this.cartDrawer || this.cartPage),
        (this.cartAddEvent = this.cartAddEvent.bind(this)),
        (this.addToCart = this.addToCart.bind(this)),
        (this.updateProgress = this.updateProgress.bind(this)),
        document.addEventListener("theme:cart:add", this.cartAddEvent),
        document.addEventListener(
          "theme:announcement:init",
          this.updateProgress
        ),
        (this.skipUpsellProductsArray = []),
        this.skipUpsellProductEvent(),
        this.checkSkippedUpsellProductsFromStorage(),
        this.toggleCartUpsellWidgetVisibility(),
        (this.circumference = 28 * Math.PI),
        (this.freeShippingLimit = this.freeShipping.length
          ? 100 *
            Number(
              this.freeShipping[0].getAttribute("data-free-shipping-limit")
            ) *
            window.Shopify.currency.rate
          : 0),
        this.freeShippingMessageHandle(this.subtotal),
        this.updateProgress(),
        this.cart &&
          ((this.build = this.build.bind(this)),
          (this.updateCart = this.updateCart.bind(this)),
          (this.productAddCallback = this.productAddCallback.bind(this)),
          (this.openCartDrawer = this.openCartDrawer.bind(this)),
          (this.closeCartDrawer = this.closeCartDrawer.bind(this)),
          (this.toggleCartDrawer = this.toggleCartDrawer.bind(this)),
          (this.openCartDrawerOnProductAdded =
            this.openCartDrawerOnProductAdded.bind(this)),
          (this.animateItems = this.animateItems.bind(this)),
          (this.showAnimatedItems = this.showAnimatedItems.bind(this)),
          (this.formSubmitHandler = t$(this.formSubmitHandler.bind(this), 50)),
          this.cartPage && this.showAnimatedItems(),
          (this.hasItemsInCart = this.hasItemsInCart.bind(this)),
          (this.cartCount = this.getCartItemCount()),
          (this.toggleClassesOnContainers =
            this.toggleClassesOnContainers.bind(this)),
          (this.totalItems = this.items.length),
          (this.cartDrawerIsOpen = !1),
          (this.cartDrawerEnabled = theme.settings.cartDrawerEnabled),
          (this.cartUpdateFailed = !1),
          this.cartEvents(),
          this.cartToggleEvents(),
          this.cartRemoveEvents(),
          this.cartUpdateEvents(),
          document.addEventListener("theme:cart:toggle", this.toggleCartDrawer),
          document.addEventListener(
            "theme:quick-add:open",
            this.closeCartDrawer
          ),
          document.addEventListener(
            "theme:product:add",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:add-error",
            this.productAddCallback
          ),
          document.addEventListener(
            "theme:product:added",
            this.openCartDrawerOnProductAdded
          ));
    }
    cartUpdateEvents() {
      (this.items = document.querySelectorAll(tN)),
        this.items.forEach((t) => {
          t.addEventListener("theme:cart:update", (e) => {
            this.updateCart(
              { id: e.detail.id, quantity: e.detail.quantity },
              t
            );
          });
        });
    }
    cartRemoveEvents() {
      document.querySelectorAll(tI).forEach((t) => {
        let e = t.closest(tN);
        t.addEventListener("click", (i) => {
          i.preventDefault(),
            t.classList.contains(tC) ||
              this.updateCart({ id: t.dataset.id, quantity: 0 }, e);
        });
      }),
        console.log("text areaaa............");
          fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
             const footerReview = document.querySelector('.footer-cstm-review');
             if (cart.items.length > 0) {
              footerReview.style.display = 'block';
            } else {
              footerReview.style.display = 'none';
            }
            // cart product IDs ka array bana lo
            const cartProductIds = cart.items.map(item => String(item.product_id));
            let hasWomen = false;
            let hasMen = false;
            cart.items.forEach(item => {
              const imgSrc = item.image?.toLowerCase() || '';
              if (imgSrc.includes('_women')) hasWomen = true;
              if (imgSrc.includes('_men')) hasMen = true;
            });
            console.log("========================="+ hasMen);
             console.log("========================="+ hasWomen);
              const upsellItems = document.querySelectorAll(
                '.mini-cart__recommendations-inner .cart-item-wrapper .available'
              );
              // First: apply gender-based filtering
              upsellItems.forEach(el => {
                const attrValue = el.getAttribute('cstm-attr')?.toLowerCase();
                const productattrVal = el.getAttribute('cstm-prod-id');
                // el.style.display = 'block';
                  // 🔥 ID match check
                if (cartProductIds.includes(String(productattrVal))) {
                  console.log('item matched');
                    el.style.display = 'none';
                }else{
                  el.style.display = 'block';
                }
                if (hasWomen && hasMen) return;

                if (hasWomen && attrValue?.includes('_men')) {
                  el.style.display = 'none';
                }

                if (hasMen && attrValue?.includes('_women')) {
                  el.style.display = 'none';
                }
              });

              // Second: limit visible products to 3
              const visibleItems = Array.from(upsellItems).filter(
                el => el.style.display !== 'none'
              );

              visibleItems.forEach((el, index) => {
                if (index >= 3) {
                  el.style.display = 'none';
                }
              });
          })
      .catch(error => console.error('Cart error:', error));


      $(".cart_drawer__count").load(
        location.href + " .cart_drawer__count>*",
        ""
      );

      this.cartCloseErrorMessage &&
        this.cartCloseErrorMessage.addEventListener("click", (t) => {
          t.preventDefault(), this.cartErrorHolder.classList.remove(tB);
        });
    }
    cartAddEvent(t) {
      let e = "",
        i = t.detail.button;
      if (i.hasAttribute("disabled")) return;
      let s = i.closest("form");
      s.checkValidity()
        ? ((e = new FormData(s)),
          (null !== s && s.querySelector('[type="file"]')) ||
            (t.preventDefault(), this.addToCart(e, i)))
        : s.reportValidity();
    }
    cartEvents() {
      this.cartTermsCheckbox &&
        (this.cartTermsCheckbox.removeEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.removeEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.removeEventListener("submit", this.formSubmitHandler),
        this.cartTermsCheckbox.addEventListener(
          "change",
          this.formSubmitHandler
        ),
        this.cartCheckoutButtonWrapper.addEventListener(
          "click",
          this.formSubmitHandler
        ),
        this.cartForm.addEventListener("submit", this.formSubmitHandler));
    }
    formSubmitHandler() {
      let t = document.querySelector(t9).checked,
        e = document.querySelector(t0);
      if (t)
        e.classList.remove(tB), this.cartCheckoutButton.removeAttribute(tj);
      else {
        if (document.querySelector(t0).length > 0) return;
        (e.innerText = theme.strings.cartAcceptanceError),
          this.cartCheckoutButton.setAttribute(tj, !0),
          e.classList.add(tB);
      }
    }
    formErrorsEvents(t) {
      let e = t.querySelector("[data-close-error]");
      null == e ||
        e.addEventListener("click", (e) => {
          e.preventDefault(), t && t.classList.remove(tH);
        });
    }
    getCart() {
      fetch(theme.routes.cart_url + "?section_id=api-cart-items")
        .then(this.cartErrorsHandler)
        .then((t) => t.text())
        .then((t) => {
          let e = document.createElement("div");
          e.innerHTML = t;
          let i = e.querySelector("[data-api-content]");
          this.build(i);
        })
        .catch((t) => console.log(t));
    }
    addToCart(t, e) {
      this.cart && this.cart.classList.add(t_);
      let i = null == e ? void 0 : e.closest(tW);
      this.cartDrawerEnabled &&
        (e && (e.classList.add(t_), (e.disabled = !0)),
        i && i.classList.add(tH)),
        fetch(theme.routes.cart_add_url, {
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            Accept: "application/javascript",
          },
          body: t,
        })
          .then((t) => t.json())
          .then((t) => {
            if (t.status)
              return (
                this.addToCartError(t, e),
                void (e && (e.classList.remove(t_), (e.disabled = !1)))
              );
            this.cartDrawerEnabled
              ? (e &&
                  (e.classList.remove(t_),
                  e.classList.add(tT),
                  e.dispatchEvent(
                    new CustomEvent("theme:product:add", {
                      detail: { response: t, button: e },
                      bubbles: !0,
                    })
                  )),
                this.getCart())
              : (window.location = theme.routes.cart_url);
          })
          .catch((t) => {
            this.addToCartError(t, e), this.enableCartButtons();
          });
    }
    updateCart(t = {}, e = null) {
      this.cart.classList.add(t_);
      let i = t.quantity;
      null !== e && (i ? e.classList.add(t_) : e.classList.add("is-removed")),
        this.disableCartButtons();
      let s = this.cart.querySelector(`[data-item="${t.id}"]`) || e,
        r = (null == s ? void 0 : s.hasAttribute(t1))
          ? parseInt(s.getAttribute(t1))
          : 0,
        o = (null == s ? void 0 : s.hasAttribute(t2))
          ? s.getAttribute(t2)
          : null;
      0 !== r &&
        fetch(theme.routes.cart_change_url, {
          method: "post",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ line: r, quantity: i }),
        })
          .then((t) => t.text())
          .then((t) => {
            if (JSON.parse(t).errors)
              return (
                (this.cartUpdateFailed = !0),
                this.updateErrorText(o),
                this.toggleErrorMessage(),
                this.resetLineItem(e),
                void this.enableCartButtons()
              );
            this.getCart();
          })
          .catch((t) => {
            console.log(t), this.enableCartButtons();
          });
    }
    resetLineItem(t) {
      let e = t.querySelector(tU),
        i = e.getAttribute("value");
      (e.value = i), t.classList.remove(t_);
    }
    disableCartButtons() {
      let t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${tI}`);
      t.length &&
        t.forEach((t) => {
          t.classList.add(tC), t.blur(), (t.disabled = !0);
        }),
        e.length &&
          e.forEach((t) => {
            t.setAttribute(tj, !0);
          });
    }
    enableCartButtons() {
      let t = this.cart.querySelectorAll("input"),
        e = this.cart.querySelectorAll(`button, ${tI}`);
      t.length &&
        t.forEach((t) => {
          t.classList.remove(tC), (t.disabled = !1);
        }),
        e.length &&
          e.forEach((t) => {
            t.removeAttribute(tj);
          }),
        this.cart.classList.remove(t_);
    }
    updateErrorText(t) {
      this.cartErrorHolder.querySelector("[data-error-message]").innerText = t;
    }
    toggleErrorMessage() {
      this.cartErrorHolder &&
        (this.cartErrorHolder.classList.toggle(tB, this.cartUpdateFailed),
        (this.cartUpdateFailed = !1));
    }
    cartErrorsHandler(t) {
      return t.ok
        ? t
        : t.json().then(function (e) {
            throw new tb({ status: t.statusText, headers: t.headers, json: e });
          });
    }
    addToCartError(t, e) {
      var i;
      if ((this.cartDrawerEnabled && this.closeCartDrawer(), null !== e)) {
        let s =
            e.closest("[data-section-id]") ||
            e.closest(tW) ||
            e.closest("[data-quick-add-modal]"),
          r = null == s ? void 0 : s.querySelector(tO),
          o = e.closest(tW);
        o && o.querySelector(tO) && (r = o.querySelector(tO)),
          r &&
            ((r.innerHTML = `<div class="errors">${t.message}: ${t.description}<button type="button" class="errors__close" data-close-error><svg aria-hidden="true" focusable="false" role="presentation" width="24px" height="24px" stroke-width="1" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color="currentColor" class="icon icon-cancel"><path d="M6.758 17.243L12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path></svg></button></div>`),
            r.classList.add(tH),
            this.formErrorsEvents(r)),
          e.dispatchEvent(
            new CustomEvent("theme:product:add-error", {
              detail: { response: t, button: e },
              bubbles: !0,
            })
          );
      }
      let a = null == e ? void 0 : e.closest(tW);
      a &&
        a.dispatchEvent(
          new CustomEvent("theme:cart:error", {
            bubbles: !0,
            detail: {
              message: t.message,
              description: t.description,
              holder: a,
            },
          })
        ),
        null === (i = this.cart) || void 0 === i || i.classList.remove(t_);
    }
    productAddCallback(t) {
      let e = [],
        i = null,
        s = "theme:product:add-error" == t.type,
        r = t.detail.button,
        o = document.querySelector("[data-add-to-cart-bar]");
      e.push(r),
        (i = r.closest(tW)),
        o && e.push(o),
        e.forEach((t) => {
          t.classList.remove(t_), s || t.classList.add(tT);
        }),
        setTimeout(() => {
          e.forEach((t) => {
            var e, i;
            t.classList.remove(tT),
              (null === (e = t.closest(tR)) || void 0 === e
                ? void 0
                : e.classList.contains("variant--soldout")) ||
                (null === (i = t.closest(tR)) || void 0 === i
                  ? void 0
                  : i.classList.contains("variant--unavailable")) ||
                (t.disabled = !1);
          }),
            null == i || i.classList.remove(tH);
        }, 1e3);
    }
    openCartDrawerOnProductAdded() {
      this.cartDrawerIsOpen ? this.showAnimatedItems() : this.openCartDrawer();
    }
    // openCartDrawer() {
    //   this.cartDrawer &&
    //     ((this.cartDrawerIsOpen = !0),
    //     (this.onBodyClickEvent =
    //       this.onBodyClickEvent || this.onBodyClick.bind(this)),
    //     document.body.addEventListener("click", this.onBodyClickEvent),
    //     document.dispatchEvent(
    //       new CustomEvent("theme:cart:open", { bubbles: !0 })
    //     ),
    //     document.dispatchEvent(
    //       new CustomEvent("theme:scroll:lock", { bubbles: !0 })
    //     ),
    //     this.cartDrawer.classList.add(tP),
    //     this.observeAdditionalCheckoutButtons(),
    //     setTimeout(this.showAnimatedItems),
    //     this.accessibility.trapFocus(this.cartDrawer, {
    //       elementToFocus: this.cartDrawer.querySelector(tM),
    //     }));
    //   console.log("in..........");
    //   $(".cart_drawer__count").load(
    //     location.href + " .cart_drawer__count>*",
    //     ""
    //   );
    //    $('body').addClass('opencart');
    // }
openCartDrawer() {
  if (!this.cartDrawer) return;

  console.log('Cart drawer opening...');
  this.cartDrawerIsOpen = true;
  this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
  document.body.addEventListener("click", this.onBodyClickEvent);

  document.dispatchEvent(new CustomEvent("theme:cart:open", { bubbles: true }));
  document.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: true }));

  this.cartDrawer.classList.add(tP);
  this.observeAdditionalCheckoutButtons();

  setTimeout(() => {
    this.showAnimatedItems();
    $('body').addClass('opencart');

    const $slider = $('.mini-cart__recommendations-list');

    // Destroy slick if already initialized
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('unslick');
    }

    // Initialize slick
    $slider.slick({
      slidesToShow: 3.5,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false
    });

    // Re-init on resize inside drawer
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        if (this.cartDrawerIsOpen) {
          if ($slider.hasClass('slick-initialized')) {
            $slider.slick('unslick');
          }
          $slider.slick({
            slidesToShow: 3.5,
            slidesToScroll: 1,
            infinite: false,
            arrows: false,
            dots: false
          });
        }
      }, 300);
    });

  }, 300);
   $('body').addClass('opencart');
}



    closeCartDrawer() {
      $('body').removeClass('opencart');
      $('body').removeClass('opencart');
      this.cartDrawer &&
        this.cartDrawer.classList.contains(tP) &&
        ((this.cartDrawerIsOpen = !1),
        document.dispatchEvent(
          new CustomEvent("theme:cart:close", { bubbles: !0 })
        ),
        this.resetAnimatedItems(),
        this.itemsHolder.classList.remove(t8),
        this.cartEmpty.classList.remove(t8),
        this.cartErrorHolder.classList.remove(tB),
        this.cartDrawer.querySelectorAll(tD).forEach((t) => {
          let e = () => {
            t.classList.remove(tx), t.removeEventListener("animationend", e);
          };
          t.classList.add(tx), t.addEventListener("animationend", e);
        }),
        this.cartDrawer.classList.remove(tP),
        this.accessibility.removeTrapFocus(),
        document.body.removeEventListener("click", this.onBodyClickEvent),
        document.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
        ));
    }
    toggleCartDrawer() {
      this.cartDrawerIsOpen ? this.closeCartDrawer() : this.openCartDrawer();
    }
    cartToggleEvents() {
      this.cartDrawer &&
        (this.cartDrawerClose.addEventListener("click", (t) => {
          t.preventDefault(), this.closeCartDrawer();
        }),
        this.cartDrawer.addEventListener("keyup", (t) => {
          "Escape" === t.code && this.closeCartDrawer();
        }));
    }
    onBodyClick(t) {
      t.target.hasAttribute("data-drawer-underlay") && this.closeCartDrawer();
    }
    toggleClassesOnContainers() {
      let t = this.hasItemsInCart();
      this.cartEmpty.classList.toggle(tq, t),
        this.buttonHolder.classList.toggle(tq, !t),
        this.itemsHolder.classList.toggle(tq, !t);
    }
    build(t) {
      let e = t.querySelector("[data-api-line-items]"),
        s = t.querySelector("[data-api-upsell-items]"),
        r = Boolean(null === e && null === s),
        o = t.querySelector("[data-api-cart-price]"),
        a = t.querySelector(tF);
      this.priceHolder && o && (this.priceHolder.innerHTML = o.innerHTML),
        r
          ? ((this.itemsHolder.innerHTML = t),
            (this.upsellProductsHolder.innerHTML = ""))
          : ((this.itemsHolder.innerHTML = e.innerHTML),
            (this.upsellProductsHolder.innerHTML = s.innerHTML),
            this.skipUpsellProductEvent(),
            this.checkSkippedUpsellProductsFromStorage(),
            this.toggleCartUpsellWidgetVisibility()),
        (this.newTotalItems =
          e && e.querySelectorAll(tN).length
            ? e.querySelectorAll(tN).length
            : 0),
        (this.subtotal =
          a && a.hasAttribute(tV) ? parseInt(a.getAttribute(tV)) : 0),
        (this.cartCount = this.getCartItemCount()),
        document.dispatchEvent(
          new CustomEvent("theme:cart:change", {
            bubbles: !0,
            detail: { cartCount: this.cartCount },
          })
        ),
        (this.cartTotal.innerHTML =
          0 === this.subtotal
            ? window.theme.strings.free
            : i.formatMoney(this.subtotal, theme.moneyWithCurrencyFormat)),
        this.cart.classList.remove(t_),
        this.totalItems !== this.newTotalItems &&
          ((this.totalItems = this.newTotalItems),
          this.toggleClassesOnContainers()),
        this.cartDrawerIsOpen && this.itemsHolder.classList.add(t8),
        this.hasItemsInCart() ||
          this.cartEmpty.querySelectorAll(tD).forEach((t) => {
            t.classList.remove(tA);
          }),
        this.freeShippingMessageHandle(this.subtotal),
        this.cartRemoveEvents(),
        this.cartUpdateEvents(),
        this.toggleErrorMessage(),
        this.enableCartButtons(),
        this.updateProgress(),
        document.dispatchEvent(
          new CustomEvent("theme:product:added", { bubbles: !0 })
        ),
        this.cartDrawer || this.showAnimatedItems();
    }
    getCartItemCount() {
      return Array.from(this.cart.querySelectorAll(tU)).reduce(
        (t, e) => t + parseInt(e.value),
        0
      );
    }
    hasItemsInCart() {
      return this.totalItems > 0;
    }
    freeShippingMessageHandle(t) {
      this.freeShipping.length &&
        this.freeShipping.forEach((e) => {
          let i = e.hasAttribute(t3) && "true" === e.getAttribute(t3) && t >= 0;
          e.classList.toggle("is-success", i && t >= this.freeShippingLimit);
        });
    }
    updateProgress() {
      if (
        ((this.freeShipping = document.querySelectorAll(tz)),
        !this.freeShipping.length)
      )
        return;
      let t = isNaN(this.subtotal / this.freeShippingLimit)
          ? 100
          : this.subtotal / this.freeShippingLimit,
        e = Math.min(100 * t, 100),
        s = this.circumference - ((e / 100) * this.circumference) / 2,
        r = i.formatMoney(
          this.freeShippingLimit - this.subtotal,
          theme.moneyFormat
        );
      this.freeShipping.forEach((t) => {
        let i = t.querySelector("[data-progress-bar]"),
          o = t.querySelector("[data-progress-graph]"),
          a = t.querySelector("[data-left-to-spend]");
        a && (a.innerHTML = r.replace(".00", "")),
          i && (i.value = e),
          o && o.style.setProperty("--stroke-dashoffset", `${s}`);
      });
    }
    skipUpsellProductEvent() {
      if (null === this.upsellProductsHolder) return;
      let t = this.upsellProductsHolder.querySelectorAll(
        "[data-skip-upsell-product]"
      );
      t.length &&
        t.forEach((t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault();
            let i = t.closest(tW).getAttribute(tX);
            this.skipUpsellProductsArray.includes(i) ||
              this.skipUpsellProductsArray.push(i),
              window.sessionStorage.setItem(
                "skip_upsell_products",
                this.skipUpsellProductsArray
              ),
              this.removeUpsellProduct(i),
              this.toggleCartUpsellWidgetVisibility();
          });
        });
    }
    checkSkippedUpsellProductsFromStorage() {
      let t = window.sessionStorage.getItem("skip_upsell_products");
      t &&
        t.split(",").forEach((t) => {
          this.skipUpsellProductsArray.includes(t) ||
            this.skipUpsellProductsArray.push(t),
            this.removeUpsellProduct(t);
        });
    }
    removeUpsellProduct(t) {
      if (!this.upsellProductsHolder) return;
      let e = this.upsellProductsHolder.querySelector(`[${tX}="${t}"]`);
      e && e.parentNode.remove();
    }
    toggleCartUpsellWidgetVisibility() {
      if (!this.upsellProductsHolder) return;
      let t = this.upsellProductsHolder.querySelectorAll(tW),
        e = this.upsellProductsHolder.closest("[data-upsell-widget]");
      e && e.classList.toggle(tq, !t.length);
    }
    observeAdditionalCheckoutButtons() {
      let t = this.cartDrawer.querySelector(".additional-checkout-buttons");
      if (t) {
        let e = new MutationObserver(() => {
          this.accessibility.trapFocus(this.cartDrawer, {
            elementToFocus: this.cartDrawer.querySelector(tM),
          }),
            e.disconnect();
        });
        e.observe(t, { subtree: !0, childList: !0 });
      }
    }
    resetAnimatedItems() {
      this.cart.querySelectorAll(tD).forEach((t) => {
        t.classList.remove(tA), t.classList.remove(tx);
      });
    }
    showAnimatedItems() {
      requestAnimationFrame(this.animateItems);
    }
    animateItems() {
      this.cart.querySelectorAll(tD).forEach((t) => {
        t.classList.add(tA);
      });
    }
    constructor() {
      window.location.pathname.endsWith("/password") || this.init();
    }
  })()),
    customElements.get("shipping-calculator") ||
      customElements.define("shipping-calculator", tk);
  let t4 = "is-focused";
  (window.accessibility = new (class {
    init() {
      (this.a11y = z),
        (this.html = document.documentElement),
        (this.body = document.body),
        (this.inPageLink = document.querySelector("[data-skip-content]")),
        (this.linkesWithOnlyHash = document.querySelectorAll('a[href="#"]')),
        this.a11y.focusHash(),
        this.a11y.bindInPageLinks(),
        this.clickEvents(),
        this.focusEvents();
    }
    clickEvents() {
      this.inPageLink &&
        this.inPageLink.addEventListener("click", (t) => {
          t.preventDefault();
        }),
        this.linkesWithOnlyHash &&
          this.linkesWithOnlyHash.forEach((t) => {
            t.addEventListener("click", (t) => {
              t.preventDefault();
            });
          });
    }
    focusEvents() {
      document.addEventListener("mousedown", () => {
        this.body.classList.remove(t4);
      }),
        document.addEventListener("keyup", (t) => {
          "Tab" === t.code && this.body.classList.add(t4);
        });
    }
    constructor() {
      this.init();
    }
  })()),
    customElements.define(
      "main-search",
      class extends U {
        setupEventListeners() {
          let t = [];
          this.allSearchInputs.forEach((e) => t.push(e.form)),
            this.input.addEventListener("focus", this.onInputFocus.bind(this)),
            t.length < 2 ||
              (t.forEach((t) =>
                t.addEventListener("reset", this.onFormReset.bind(this))
              ),
              this.allSearchInputs.forEach((t) =>
                t.addEventListener("input", this.onInput.bind(this))
              ));
        }
        onFormReset(t) {
          super.onFormReset(t),
            super.shouldResetForm() && this.keepInSync("", this.input);
        }
        onInput(t) {
          let e = t.target;
          this.keepInSync(e.value, e);
        }
        onInputFocus() {
          E() || this.scrollIntoView({ behavior: "smooth" });
        }
        keepInSync(t, e) {
          this.allSearchInputs.forEach((i) => {
            i !== e && (i.value = t);
          });
        }
        constructor() {
          super(),
            (this.allSearchInputs = document.querySelectorAll(
              'input[type="search"]'
            )),
            this.setupEventListeners();
        }
      }
    );
  let tQ = "details",
    t5 = class extends HTMLElement {
      connectedCallback() {
        this.popdownContainer.addEventListener(
          "keyup",
          (t) => "ESCAPE" === t.code.toUpperCase() && this.close()
        ),
          this.popdownClose.addEventListener("click", this.close.bind(this)),
          this.popdownToggle.addEventListener(
            "click",
            this.onPopdownToggleClick.bind(this)
          ),
          this.popdownToggle.setAttribute("role", "button"),
          this.popdown.addEventListener("transitionend", (t) => {
            "visibility" == t.propertyName &&
              this.popdownContainer.hasAttribute("open") &&
              "false" == this.popdownContainer.getAttribute("open") &&
              this.popdownContainer.removeAttribute("open");
          });
      }
      onPopdownToggleClick(t) {
        t.preventDefault(),
          t.target.closest(tQ).hasAttribute("open")
            ? this.close()
            : this.open(t);
      }
      onBodyClick(t) {
        (this.contains(t.target) &&
          !t.target.hasAttribute("data-popdown-underlay")) ||
          this.close();
      }
      open(t) {
        (this.onBodyClickEvent =
          this.onBodyClickEvent || this.onBodyClick.bind(this)),
          t.target.closest(tQ).setAttribute("open", ""),
          document.body.addEventListener("click", this.onBodyClickEvent),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
          requestAnimationFrame(() => {
            t.target.closest(tQ).setAttribute("open", "true"),
              this.a11y.trapFocus(this.popdown, {
                elementToFocus: this.popdown.querySelector(
                  'input:not([type="hidden"])'
                ),
              });
          });
      }
      close() {
        this.a11y.removeTrapFocus(),
        this.popdownContainer.removeAttribute("open");
          document.body.removeEventListener("click", this.onBodyClickEvent),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          );
      }
      constructor() {
        super(),
          (this.popdown = this.querySelector("[data-popdown]")),
          (this.popdownContainer = this.querySelector(tQ)),
          (this.popdownToggle = this.querySelector("[data-popdown-toggle]")),
          (this.popdownClose = this.querySelector("[data-popdown-close]")),
          (this.a11y = z);
      }
    };
  customElements.define("header-search-popdown", t5);
  let t6 = "[data-collapsible]",
    tJ = "[data-collapsible-trigger]",
    tY = "[data-collapsible-body]",
    t7 = "[data-collapsible-content]",
    tG = "open",
    tK = class extends HTMLElement {
      connectedCallback() {
        this.collapsibles.forEach((t) => {
          let e = t.querySelector(tJ),
            i = t.querySelector(tY);
          e.addEventListener("click", (t) => this.onCollapsibleClick(t)),
            i.addEventListener("transitionend", (e) => {
              e.target === i &&
                ("true" == t.getAttribute(tG) && this.setBodyHeight(i, "auto"),
                "false" == t.getAttribute(tG) &&
                  (t.removeAttribute(tG), this.setBodyHeight(i, "")));
            });
        });
      }
      open(t) {
        if ("true" == t.getAttribute("open")) return;
        let e = t.querySelector(tY),
          i = t.querySelector(t7);
        t.setAttribute("open", !0), this.setBodyHeight(e, i.offsetHeight);
      }
      close(t) {
        if (!t.hasAttribute("open")) return;
        let e = t.querySelector(tY),
          i = t.querySelector(t7);
        this.setBodyHeight(e, i.offsetHeight),
          t.setAttribute("open", !1),
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.setBodyHeight(e, 0);
            });
          });
      }
      setBodyHeight(t, e) {
        t.style.height = "auto" !== e && "" !== e ? `${e}px` : e;
      }
      onCollapsibleClick(t) {
        t.preventDefault();
        let e = (
          t.target.matches(tJ) ? t.target : t.target.closest(tJ)
        ).closest(t6);
        this.single &&
          this.collapsibles.forEach((t) => {
            t.hasAttribute(tG) &&
              t != e &&
              requestAnimationFrame(() => {
                this.close(t);
              });
          }),
          e.hasAttribute(tG) ? this.close(e) : this.open(e),
          e.dispatchEvent(
            new CustomEvent("theme:form:sticky", {
              bubbles: !0,
              detail: { element: "accordion" },
            })
          );
      }
      constructor() {
        super(),
          (this.collapsibles = this.querySelectorAll(t6)),
          (this.single = this.hasAttribute("single"));
      }
    };
  customElements.get("collapsible-elements") ||
    customElements.define("collapsible-elements", tK);
  let tZ = "data-form-id",
    et = "hidden",
    ee = document.querySelector(".template-addresses");
  ee &&
    new (class {
      init() {
        if (this.addressNewForm) {
          let t = this.section,
            e = this.addressNewForm;
          this.customerAddresses();
          let i = t.querySelectorAll(".address-new-toggle");
          i.length &&
            i.forEach((t) => {
              t.addEventListener("click", function () {
                e.classList.toggle(et);
              });
            });
          let s = t.querySelectorAll(".address-edit-toggle");
          s.length &&
            s.forEach((e) => {
              e.addEventListener("click", function () {
                let e = this.getAttribute(tZ);
                t.querySelector(`#EditAddress_${e}`).classList.toggle(et);
              });
            });
          let r = t.querySelectorAll(".address-delete");
          r.length &&
            r.forEach((t) => {
              t.addEventListener("click", function () {
                let t = this.getAttribute(tZ),
                  e = this.getAttribute("data-confirm-message");
                confirm(e) &&
                  Shopify.postLink(
                    window.theme.routes.addresses_url + "/" + t,
                    { parameters: { _method: "delete" } }
                  );
              });
            });
        }
      }
      customerAddresses() {
        Shopify.CountryProvinceSelector &&
          new Shopify.CountryProvinceSelector(
            "AddressCountryNew",
            "AddressProvinceNew",
            { hideElement: "AddressProvinceContainerNew" }
          ),
          this.section
            .querySelectorAll(".address-country-option")
            .forEach((t) => {
              let e = t.getAttribute(tZ),
                i = `AddressCountry_${e}`,
                s = `AddressProvince_${e}`,
                r = `AddressProvinceContainer_${e}`;
              new Shopify.CountryProvinceSelector(i, s, { hideElement: r });
            });
      }
      constructor(t) {
        (this.section = t),
          (this.addressNewForm = this.section.querySelector("#AddressNewForm")),
          this.init();
      }
    })(ee);
  let ei = ".account-sidebar--mobile",
    es = document.querySelector(".customer-logged-in");
  es &&
    new (class {
      init() {
        this.section.querySelector(".account") && this.accountMobileSidebar();
      }
      accountMobileSidebar() {
        this.section.querySelector(ei) &&
          this.section.querySelector(ei).addEventListener("click", function () {
            let t = this.nextElementSibling;
            t && "UL" === t.tagName && t.classList.toggle("visible");
          });
      }
      constructor(t) {
        (this.section = t), this.init();
      }
    })(es);
  let er = "#recover",
    eo = "is-hidden",
    ea = document.querySelector("[data-account-form]");
  ea &&
    new (class {
      init() {
        window.location.hash == er || this.recoverSuccess
          ? this.showRecoverPasswordForm()
          : this.hideRecoverPasswordForm(),
          this.showButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.showRecoverPasswordForm();
            }.bind(this),
            !1
          ),
          this.hideButton.addEventListener(
            "click",
            function (t) {
              t.preventDefault(), this.hideRecoverPasswordForm();
            }.bind(this),
            !1
          );
      }
      showRecoverPasswordForm() {
        return (
          this.login.classList.add(eo),
          this.recover.classList.remove(eo),
          (window.location.hash = er),
          !1
        );
      }
      hideRecoverPasswordForm() {
        return (
          this.recover.classList.add(eo),
          this.login.classList.remove(eo),
          (window.location.hash = ""),
          !1
        );
      }
      constructor(t) {
        (this.form = t),
          (this.showButton = t.querySelector("[data-show-reset]")),
          (this.hideButton = t.querySelector("[data-hide-reset]")),
          (this.recover = t.querySelector("[data-recover-password]")),
          (this.recoverSuccess = t.querySelector("[data-recover-success]")),
          (this.login = t.querySelector("[data-login-form]")),
          this.init();
      }
    })(ea),
    (window.Shopify = window.Shopify || {}),
    (window.Shopify.theme = window.Shopify.theme || {}),
    (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
    (window.Shopify.theme.sections.registered =
      window.Shopify.theme.sections.registered || {}),
    (window.Shopify.theme.sections.instances =
      window.Shopify.theme.sections.instances || []);
  let en = window.Shopify.theme.sections.registered,
    el = window.Shopify.theme.sections.instances,
    eh = "data-section-id",
    ec = "data-section-type",
    ed = class {
      callFunctions(t, e = null) {
        this.callStack[t].forEach((t) => {
          let i = { id: this.id, type: this.type, container: this.container };
          e ? t.call(i, e) : t.call(i);
        });
      }
      onLoad() {
        this.callFunctions("onLoad");
      }
      onUnload() {
        this.callFunctions("onUnload");
      }
      onSelect(t) {
        this.callFunctions("onSelect", t);
      }
      onDeselect(t) {
        this.callFunctions("onDeselect", t);
      }
      onBlockSelect(t) {
        this.callFunctions("onBlockSelect", t);
      }
      onBlockDeselect(t) {
        this.callFunctions("onBlockDeselect", t);
      }
      onReorder(t) {
        this.callFunctions("onReorder", t);
      }
      constructor(t, e) {
        (this.container = (function (t) {
          if (!(t instanceof Element))
            throw TypeError(
              "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
            );
          if (null === t.getAttribute(eh))
            throw Error(
              "Theme Sections: The section container provided does not have an id assigned to the " +
                eh +
                " attribute."
            );
          return t;
        })(t)),
          (this.id = t.getAttribute(eh)),
          (this.type = e.type),
          (this.callStack = e.getStack());
        try {
          this.onLoad();
        } catch (i) {
          console.warn(`Error in section: ${this.id}`),
            console.warn(this),
            console.warn(i);
        }
      }
    };
  function eu(t, e) {
    if ("string" != typeof t)
      throw TypeError(
        "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
      );
    if (void 0 !== en[t])
      throw Error(
        'Theme Sections: A section of type "' +
          t +
          '" has already been registered. You cannot register the same section type twice'
      );
    Array.isArray(e) || (e = [e]);
    let i = new (class {
      getStack() {
        return this.callStack;
      }
      constructor(t = null, e = []) {
        (this.type = t),
          (this.components = (function (t) {
            if ((void 0 !== t && "object" != typeof t) || null === t)
              throw TypeError(
                "Theme Sections: The components object provided is not a valid"
              );
            return t;
          })(e)),
          (this.callStack = {
            onLoad: [],
            onUnload: [],
            onSelect: [],
            onDeselect: [],
            onBlockSelect: [],
            onBlockDeselect: [],
            onReorder: [],
          }),
          e.forEach((t) => {
            for (let [e, i] of Object.entries(t)) {
              let s = this.callStack[e];
              Array.isArray(s) && "function" == typeof i
                ? s.push(i)
                : (console.warn(
                    `Unregisted function: '${e}' in component: '${this.type}'`
                  ),
                  console.warn(i));
            }
          });
      }
    })(t, e);
    return (en[t] = i), en;
  }
  function ep(t, e) {
    (t = ef(t)),
      void 0 === e && (e = document.querySelectorAll("[" + ec + "]")),
      (e = ev(e)),
      t.forEach(function (t) {
        let i = en[t];
        void 0 !== i &&
          (e = e.filter(function (e) {
            return (
              !(em(e).length > 0) &&
              null !== e.getAttribute(ec) &&
              (e.getAttribute(ec) !== t || (el.push(new ed(e, i)), !1))
            );
          }));
      });
  }
  function em(t) {
    var e = [];
    if (NodeList.prototype.isPrototypeOf(t) || Array.isArray(t)) var i = t[0];
    return (
      t instanceof Element || i instanceof Element
        ? ev(t).forEach(function (t) {
            e = e.concat(
              el.filter(function (e) {
                return e.container === t;
              })
            );
          })
        : ("string" == typeof t || "string" == typeof i) &&
          ef(t).forEach(function (t) {
            e = e.concat(
              el.filter(function (e) {
                return e.type === t;
              })
            );
          }),
      e
    );
  }
  function eg(t) {
    for (var e, i = 0; i < el.length; i++)
      if (el[i].id === t) {
        e = el[i];
        break;
      }
    return e;
  }
  function ef(t) {
    return (
      "*" === t
        ? (t = Object.keys(en))
        : "string" == typeof t
        ? (t = [t])
        : t.constructor === ed
        ? (t = [t.prototype.type])
        : Array.isArray(t) &&
          t[0].constructor === ed &&
          (t = t.map(function (t) {
            return t.type;
          })),
      (t = t.map(function (t) {
        return t.toLowerCase();
      }))
    );
  }
  function ev(t) {
    return (
      NodeList.prototype.isPrototypeOf(t) && t.length > 0
        ? (t = Array.prototype.slice.call(t))
        : (NodeList.prototype.isPrototypeOf(t) && 0 === t.length) || null === t
        ? (t = [])
        : !Array.isArray(t) && t instanceof Element && (t = [t]),
      t
    );
  }
  window.Shopify.designMode &&
    (document.addEventListener("shopify:section:load", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + eh + '="' + e + '"]');
      null !== i && ep(i.getAttribute(ec), i);
    }),
    document.addEventListener("shopify:section:reorder", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + eh + '="' + e + '"]');
      "object" == typeof em(i)[0] &&
        em(i).forEach(function (t) {
          t.onReorder();
        });
    }),
    document.addEventListener("shopify:section:unload", function (t) {
      var e = t.detail.sectionId,
        i = t.target.querySelector("[" + eh + '="' + e + '"]');
      "object" == typeof em(i)[0] &&
        em(i).forEach(function (t) {
          var e = el
            .map(function (t) {
              return t.id;
            })
            .indexOf(t.id);
          el.splice(e, 1), t.onUnload();
        });
    }),
    document.addEventListener("shopify:section:select", function (t) {
      var e = eg(t.detail.sectionId);
      "object" == typeof e && e.onSelect(t);
    }),
    document.addEventListener("shopify:section:deselect", function (t) {
      var e = eg(t.detail.sectionId);
      "object" == typeof e && e.onDeselect(t);
    }),
    document.addEventListener("shopify:block:select", function (t) {
      var e = eg(t.detail.sectionId);
      "object" == typeof e && e.onBlockSelect(t);
    }),
    document.addEventListener("shopify:block:deselect", function (t) {
      var e = eg(t.detail.sectionId);
      "object" == typeof e && e.onBlockDeselect(t);
    }));
  let ey = "data-tooltip",
    eb = "data-tooltip-stop-mouseenter",
    eS = "is-visible",
    eE = "is-hiding",
    eL = {},
    ew = class {
      init() {
        if (!document.querySelector(`.${this.class}`)) {
          let t = `<div class="${this.class}__arrow"></div><div class="${this.class}__inner"><div class="${this.class}__text"></div></div>`,
            e = document.createElement("div");
          (e.className = this.class),
            (e.innerHTML = t),
            document.body.appendChild(e);
        }
        this.tooltip.addEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.addEventListener("mouseleave", this.removePinMouseEvent),
          this.tooltip.addEventListener("theme:tooltip:init", this.addPinEvent),
          document.addEventListener("theme:tooltip:close", this.removePinEvent);
      }
      addPin(t = !1) {
        let e = document.querySelector(`.${this.class}`);
        if (e && ((t && !this.tooltip.hasAttribute(eb)) || !t)) {
          let i = e.querySelector(`.${this.class}__arrow`),
            s = e.querySelector(`.${this.class}__inner`);
          e.querySelector(`.${this.class}__text`).textContent = this.label;
          let r = s.offsetWidth,
            o = this.tooltip.getBoundingClientRect(),
            a = o.top,
            n = o.width,
            l = a + o.height + window.scrollY,
            h = o.left - r / 2 + n / 2,
            c = h + r - b();
          c > 0 && (h -= c),
            h < 0 && (h = 0),
            (i.style.left = `${o.left + n / 2}px`),
            e.style.setProperty("--tooltip-top", `${l}px`),
            (s.style.transform = `translateX(${h}px)`),
            e.classList.remove(eE),
            e.classList.add(eS),
            document.addEventListener("theme:scroll", this.removePinEvent);
        }
      }
      removePin(t, e = !1, i = !1) {
        let s = document.querySelector(`.${this.class}`),
          r = s.classList.contains(eS);
        s &&
          ((e && !this.tooltip.hasAttribute(eb)) || !e) &&
          (r &&
            (i || t.detail.hideTransition) &&
            (s.classList.add(eE),
            this.hideTransitionTimeout &&
              clearTimeout(this.hideTransitionTimeout),
            (this.hideTransitionTimeout = setTimeout(() => {
              s.classList.remove(eE);
            }, this.transitionSpeed))),
          s.classList.remove(eS),
          document.removeEventListener("theme:scroll", this.removePinEvent));
      }
      unload() {
        this.tooltip.removeEventListener("mouseenter", this.addPinMouseEvent),
          this.tooltip.removeEventListener(
            "mouseleave",
            this.removePinMouseEvent
          ),
          this.tooltip.removeEventListener(
            "theme:tooltip:init",
            this.addPinEvent
          ),
          document.removeEventListener(
            "theme:tooltip:close",
            this.removePinEvent
          ),
          document.removeEventListener("theme:scroll", this.removePinEvent);
      }
      constructor(t, e = {}) {
        (this.tooltip = t),
          this.tooltip.hasAttribute(ey) &&
            ((this.label = this.tooltip.getAttribute(ey)),
            (this.class = e.class || "tooltip-default"),
            (this.transitionSpeed = e.transitionSpeed || 200),
            (this.hideTransitionTimeout = 0),
            (this.addPinEvent = () => this.addPin()),
            (this.addPinMouseEvent = () => this.addPin(!0)),
            (this.removePinEvent = (t) => t$(this.removePin(t), 50)),
            (this.removePinMouseEvent = (t) => this.removePin(t, !0, !0)),
            this.init());
      }
    },
    ek = {
      onLoad() {
        (eL[this.id] = []),
          this.container.querySelectorAll(`[${ey}]`).forEach((t) => {
            eL[this.id].push(new ew(t));
          });
      },
      onUnload: function () {
        eL[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    };
  var e$ = {};
  let eA = {
    onLoad() {
      (e$[this.id] = []),
        this.container
          .querySelectorAll("[data-parallax-wrapper]")
          .forEach((t) => {
            let e = t.querySelector("[data-parallax-img]");
            e$[this.id].push(new s(e, { center: !0, round: !0, frame: t }));
          }),
        window.addEventListener("load", () => {
          e$[this.id].forEach((t) => {
            "function" == typeof t.refresh && t.refresh();
          });
        });
    },
    onUnload: function () {
      e$[this.id].forEach((t) => {
        "function" == typeof t.destroy && t.destroy();
      });
    },
  };
  eu("article", [ek, eA]);
  let eT = "[data-slide]",
    eC = "[data-slider]",
    eq = "[data-slider-thumb]",
    ex = {
      arrowPositionMiddle: "data-arrow-position-middle",
      equalizeHeight: "data-equalize-height",
      slideIndex: "data-slide-index",
      sliderOptions: "data-options",
      slideTextColor: "data-slide-text-color",
    },
    e_ = "aos-animate",
    eP = "flickity-resize",
    eH = "flickity-resizing",
    eB = "is-loading",
    e8 = "is-selected",
    eD = {},
    eM = class {
      init() {
        this.slideshow.classList.add(eB),
          (this.sliderOptions = {
            contain: !0,
            wrapAround: !0,
            adaptiveHeight: !0,
            ...this.customOptions,
            on: {
              ready: () => {
                requestAnimationFrame(() => {
                  this.slideshow.classList.add("is-initialized"),
                    this.slideshow.classList.remove(eB),
                    this.slideshow.parentNode.dispatchEvent(
                      new CustomEvent("theme:slider:loaded", {
                        bubbles: !0,
                        detail: { slider: this },
                      })
                    );
                }),
                  this.slideActions(),
                  this.sliderOptions.prevNextButtons && this.positionArrows();
              },
              change: (t) => {
                let e = this.slideshowSlides[t];
                if (!e || this.sliderOptions.groupCells) return;
                let i = e.querySelectorAll("[data-aos]");
                i.length &&
                  i.forEach((t) => {
                    t.classList.remove(e_),
                      requestAnimationFrame(() => {
                        t.classList.add(e_);
                      });
                  });
              },
              resize: () => {
                this.sliderOptions.prevNextButtons && this.positionArrows();
              },
            },
          }),
          this.sliderOptions.fade &&
            (this.flkty = new o(this.slideshow, this.sliderOptions)),
          this.sliderOptions.fade ||
            (this.flkty = new r(this.slideshow, this.sliderOptions)),
          this.isHeightEqualized && this.equalizeHeight(),
          this.flkty.on("change", () => this.slideActions(!0)),
          this.sliderThumbs.length &&
            this.sliderThumbs.forEach((t) => {
              t.addEventListener("click", (e) => {
                e.preventDefault();
                let i = [...t.parentElement.children].indexOf(t);
                this.flkty.select(i);
              });
            }),
          this.flkty || this.slideshow.classList.remove(eB);
      }
      resetSlider() {
        this.slideshow &&
          (this.flkty && this.flkty.isActive
            ? this.flkty.select(0, !1, !0)
            : this.slideshow.scrollTo({ left: 0, behavior: "auto" }));
      }
      slideActions(t = !1) {
        let e = this.slideshow.querySelector(`.${e8}`),
          i = e.getAttribute(ex.slideTextColor),
          s = e.querySelector("a:not(.btn)"),
          r = this.slideshow.querySelectorAll(`${eT} a, ${eT} button`);
        if (
          (document.body.classList.contains("is-focused") &&
            s &&
            this.sliderOptions.groupCells &&
            t &&
            s.focus(),
          r.length &&
            r.forEach((t) => {
              let e = t.closest(eT);
              if (e) {
                let i = e.classList.contains(e8) ? 0 : -1;
                t.setAttribute("tabindex", i);
              }
            }),
          "rgba(0,0,0,0)" !== i &&
            "" !== i &&
            this.slideshow.style.setProperty("--text", i),
          this.sliderThumbs.length &&
            this.sliderThumbs.length === this.slideshowSlides.length &&
            e.hasAttribute(ex.slideIndex))
        ) {
          let o = parseInt(e.getAttribute(ex.slideIndex)),
            a = this.container.querySelector(`${eq}.${e8}`);
          a && a.classList.remove(e8), this.sliderThumbs[o].classList.add(e8);
        }
      }
      positionArrows() {
        if (
          this.slideshow.hasAttribute(ex.arrowPositionMiddle) &&
          this.sliderOptions.prevNextButtons
        ) {
          let t =
            this.slideshow.querySelector(".collection-item__image") ||
            this.slideshow.querySelector(".product-item__image") ||
            this.slideshow.querySelector("[data-column-image]");
          t &&
            ((this.slideshow.querySelector(
              ".flickity-button.previous"
            ).style.top = t.clientHeight / 2 + "px"),
            (this.slideshow.querySelector(".flickity-button.next").style.top =
              t.clientHeight / 2 + "px"));
        }
      }
      equalizeHeight() {
        (r.prototype._createResizeClass = function () {
          requestAnimationFrame(() => {
            this.element.classList.add(eP);
          });
        }),
          this.flkty._createResizeClass();
        let t = r.prototype.resize;
        r.prototype.resize = function () {
          this.element.classList.remove(eP),
            this.element.classList.add(eH),
            t.call(this),
            requestAnimationFrame(() => {
              this.element.classList.remove(eH), this.element.classList.add(eP);
            });
        };
      }
      onUnload() {
        this.slideshow &&
          this.flkty &&
          ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
      }
      onBlockSelect(t) {
        if (!this.slideshow) return;
        let e = this.slideshow.querySelector(
          `[data-slide="${t.detail.blockId}"]`
        );
        if (!e) return;
        let i = parseInt(e.getAttribute(ex.slideIndex));
        this.multipleSlides &&
          !this.slideshow.classList.contains("js-slider--initialized") &&
          (i = 0),
          this.slideshow.classList.add(e8),
          this.flkty &&
            this.slideshow.classList.contains("flickity-enabled") &&
            (this.flkty.selectCell(i), this.flkty.stopPlayer());
      }
      onBlockDeselect() {
        this.slideshow &&
          (this.slideshow.classList.remove(e8),
          this.flkty &&
            this.sliderOptions.hasOwnProperty("autoPlay") &&
            this.sliderOptions.autoPlay &&
            this.flkty.playPlayer());
      }
      constructor(t, e = null) {
        (this.container = t),
          (this.slideshow = e || this.container.querySelector(eC)),
          this.slideshow &&
            ((this.slideshowSlides = this.slideshow.querySelectorAll(eT)),
            this.slideshowSlides.length <= 1 ||
              ((this.sliderThumbs = this.container.querySelectorAll(eq)),
              (this.multipleSlides = this.slideshow.hasAttribute(
                ex.slidesLargeDesktop
              )),
              (this.isHeightEqualized =
                "true" === this.slideshow.getAttribute(ex.equalizeHeight)),
              this.slideshow.hasAttribute(ex.sliderOptions) &&
                (this.customOptions = JSON.parse(
                  decodeURIComponent(
                    this.slideshow.getAttribute(ex.sliderOptions)
                  )
                )),
              (this.flkty = null),
              this.init()));
      }
    },
    eI = {
      onLoad() {
        (eD[this.id] = []),
          this.container.querySelectorAll(eC).forEach((t) => {
            eD[this.id].push(new eM(this.container, t));
          });
      },
      onUnload() {
        eD[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
      onBlockSelect(t) {
        eD[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        eD[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    };
  eu("blog-section", [eI]), eu("hero", eA), eu("double", eI);
  let e9 = "[data-header-height]",
    eF = (t) => {
      let e =
        document.querySelector("[data-header-sticky]") &&
        document.querySelector(e9)
          ? document.querySelector(e9).getBoundingClientRect().height
          : 0;
      window.scrollTo({
        top: t + window.scrollY - e,
        left: 0,
        behavior: "smooth",
      });
    },
    eO = class {
      write() {
        ((-1 === document.cookie.indexOf("; ") ||
          document.cookie.split("; ").find((t) => t.startsWith(this.name))) &&
          -1 !== document.cookie.indexOf("; ")) ||
          (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}; sameSite=${this.configuration.sameSite}; secure=${this.configuration.secure}`);
      }
      read() {
        return (
          !!(
            -1 !== document.cookie.indexOf("; ") &&
            document.cookie.split("; ").find((t) => t.startsWith(this.name))
          ) &&
          document.cookie
            .split("; ")
            .find((t) => t.startsWith(this.name))
            .split("=")[1]
        );
      }
      destroy() {
        document.cookie.split("; ").find((t) => t.startsWith(this.name)) &&
          (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
      }
      constructor(t, e, i = 7) {
        let s = new Date(),
          r = new Date();
        r.setTime(s.getTime() + 864e5 * i),
          (this.configuration = {
            expires: r.toGMTString(),
            path: "/",
            domain: window.location.hostname,
            sameSite: "none",
            secure: !0,
          }),
          (this.name = t),
          (this.value = e);
      }
    },
    eR = "has-success",
    ez = "has-error",
    eN = "hidden",
    eW = {},
    eU = {
      onLoad() {
        (eW[this.id] = []),
          this.container
            .querySelectorAll("[data-newsletter-form]")
            .forEach((t) => {
              eW[this.id].push(
                new (class {
                  init() {
                    this.newsletter.addEventListener(
                      "submit",
                      this.newsletterSubmit
                    ),
                      this.showMessage();
                  }
                  newsletterSubmitEvent(t) {
                    this.stopSubmit &&
                      (t.preventDefault(),
                      t.stopImmediatePropagation(),
                      this.removeStorage(),
                      this.writeStorage(),
                      (this.stopSubmit = !1),
                      this.newsletter.submit());
                  }
                  checkForChallengePage() {
                    this.isChallengePage =
                      "/challenge" === window.location.pathname;
                  }
                  writeStorage() {
                    void 0 !== this.sessionStorage &&
                      this.sessionStorage.setItem(
                        "newsletter_form_id",
                        this.newsletter.id
                      );
                  }
                  readStorage() {
                    this.formID =
                      this.sessionStorage.getItem("newsletter_form_id");
                  }
                  removeStorage() {
                    this.sessionStorage.removeItem("newsletter_form_id");
                  }
                  showMessage() {
                    if (
                      (this.readStorage(), this.newsletter.id === this.formID)
                    ) {
                      let t = document.getElementById(this.formID),
                        e = t.parentElement.querySelector(
                          "[data-newsletter-heading]"
                        ),
                        i =
                          -1 !==
                          window.location.search.indexOf(
                            "?customer_posted=true"
                          ),
                        s =
                          -1 !==
                          window.location.search.indexOf("accepts_marketing");
                      i
                        ? (t.classList.remove(ez),
                          t.classList.add(eR),
                          e && (e.classList.add(eN), t.classList.remove(eN)),
                          this.popup && this.cookie.write())
                        : s &&
                          (t.classList.remove(eR),
                          t.classList.add(ez),
                          e && (e.classList.add(eN), t.classList.remove(eN))),
                        (i || s) &&
                          window.addEventListener("load", () => {
                            this.scrollToForm(t);
                          });
                    }
                  }
                  scrollToForm(t) {
                    let e = t.getBoundingClientRect();
                    (e.top >= 0 &&
                      e.left >= 0 &&
                      e.bottom <= S() &&
                      e.right <= b()) ||
                      setTimeout(() => {
                        eF(t.getBoundingClientRect().top);
                      }, 500);
                  }
                  unload() {
                    this.newsletter.removeEventListener(
                      "submit",
                      this.newsletterSubmit
                    );
                  }
                  constructor(t) {
                    (this.sessionStorage = window.sessionStorage),
                      (this.newsletter = t),
                      (this.popup =
                        this.newsletter.closest("[data-newsletter]")),
                      this.popup &&
                        (this.cookie = new eO(
                          this.popup.getAttribute("data-cookie-name"),
                          "user_has_closed",
                          null
                        )),
                      (this.stopSubmit = !0),
                      (this.isChallengePage = !1),
                      (this.formID = null),
                      this.checkForChallengePage(),
                      (this.newsletterSubmit = (t) =>
                        this.newsletterSubmitEvent(t)),
                      this.isChallengePage || this.init();
                  }
                })(t)
              );
            });
      },
      onUnload() {
        eW[this.id].forEach((t) => {
          "function" == typeof t.unload && t.unload();
        });
      },
    };
  eu("footer", [eA, eU]);
  let e0 = "[data-collection-sidebar]",
    eV = "input",
    ej = "[data-field-price-min]",
    e3 = "[data-field-price-max]",
    e1 = "[data-se-min-value]",
    e2 = "[data-se-max-value]",
    eX = "data-se-min-value",
    e4 = "data-se-max-value",
    eQ = "data-se-min",
    e5 = "data-se-max",
    e6 = "[data-products-grid]",
    eJ = "[data-filter-update-url]",
    eY = "data-active-filters-count",
    e7 = "data-sort-enabled",
    eG = "hidden",
    eK = "is-loading",
    eZ = class extends HTMLElement {
      connectedCallback() {
        this.form &&
          (this.sidebar.addEventListener("input", this.updatePriceEvent),
          this.sidebar.addEventListener(
            "theme:range:update",
            this.updateRangeEvent
          )),
          this.sidebar &&
            this.sidebar.addEventListener(
              "click",
              this.filterUpdateFromUrlEvent
            ),
          this.productsContainer &&
            this.productsContainer.addEventListener(
              "click",
              this.filterUpdateFromUrlEvent
            ),
          this.sort &&
            this.container.addEventListener(
              "theme:filter:sort-update",
              this.submitFormEvent
            ),
          (this.sidebar || this.sort) &&
            window.addEventListener("popstate", this.submitFormEvent),
          this.showMoreOptions.length &&
            this.showMoreOptions.forEach((t) => {
              t.addEventListener("click", this.showMoreEvent);
            });
        if (!this.inStockFilterExecuted) {
          this.inStockFilterExecuted = true;
          setTimeout(() => {
            // this.handleInStockFilter();
            // $(".collection__sidebar").load(location.href+" .collection__sidebar>*","");
          }, 100);
        }
      }
      //    handleInStockFilter() {
      //   console.log("Handling In stock filter");

      //   if (!this.form) {
      //     console.log("Form not found");
      //     return;
      //   }

      //   const inStockCheckbox = this.form.querySelector(
      //     'input[name="filter.v.availability"][value="1"]'
      //   );
      //   const outOfStockCheckbox = this.form.querySelector(
      //     'input[name="filter.v.availability"][value="0"]'
      //   );

      //   console.log("In stock checkbox:", inStockCheckbox);
      //   console.log("Out of stock checkbox:", outOfStockCheckbox);

      //   if (inStockCheckbox && outOfStockCheckbox) {
      //     console.log("Found checkboxes:", {
      //       inStock: inStockCheckbox.checked,
      //       outOfStock: outOfStockCheckbox.checked,
      //     });

      //     // Check if we're on the initial page load (no query string)
      //     const isInitialLoad = !window.location.search;
      //     console.log("Is initial load:", isInitialLoad);

      //     if (isInitialLoad) {
      //       console.log("Setting In stock as default filter on initial load");
      //       inStockCheckbox.checked = true;
      //       outOfStockCheckbox.checked = false;
      //       outOfStockCheckbox.disabled = true;
      //       this.form.submit();
      //     }

      //     // Handle In stock checkbox changes
      //     inStockCheckbox.addEventListener("change", (e) => {
      //       console.log("In stock checkbox changed:", e.target.checked);
      //       if (e.target.checked) {
      //         outOfStockCheckbox.checked = false;
      //         outOfStockCheckbox.disabled = true;
      //         this.form.submit();
      //       } else {
      //         outOfStockCheckbox.disabled = false;
      //       }
      //     });

      //     // Handle Out of stock checkbox changes
      //     outOfStockCheckbox.addEventListener("change", (e) => {
      //       console.log("Out of stock checkbox changed:", e.target.checked);
      //       if (e.target.checked) {
      //         inStockCheckbox.checked = false;
      //         inStockCheckbox.disabled = true;
      //         this.form.submit();
      //       } else {
      //         inStockCheckbox.disabled = false;
      //       }
      //     });
      //   } else {
      //     console.log("Checkboxes not found");
      //   }
      // }
      showMore(t) {
        t.preventDefault(),
          t.target.parentElement.classList.add(eG),
          t.target.parentElement.previousElementSibling
            .querySelectorAll("[data-link-hidden]")
            .forEach((t, e) => {
              t.classList.remove(eG);
              let i = t.querySelector(eV);
              0 === e &&
                document.body.classList.contains("is-focused") &&
                i &&
                (this.collectionSidebarSlideOut || L()
                  ? (this.accessibility.removeTrapFocus(),
                    this.accessibility.trapFocus(this.sidebar, {
                      elementToFocus: i,
                    }))
                  : i.focus());
            });
      }
      updatePrice(t) {
        let e = t.type,
          i = t.target;
        if (
          (e === eV || "select" === e || "label" === e || "textarea" === e) &&
          this.form &&
          "function" == typeof this.form.submit
        ) {
          let s = this.form.querySelector(ej),
            r = this.form.querySelector(e3);
          s &&
            r &&
            (i.hasAttribute("data-field-price-min") && !r.value
              ? (r.value = r.placeholder)
              : i.hasAttribute("data-field-price-max") &&
                !s.value &&
                (s.value = s.placeholder)),
            this.submitForm(t);
        }
      }
      filterUpdateFromUrl(t) {
        let e = t.target;
        if (e.matches(eJ) || (e.closest(eJ) && e)) {
          t.preventDefault();
          let i = e.matches(eJ) ? e : e.closest(eJ);
          this.submitForm(t, i.getAttribute("href"));
        }
      }
      submitForm(t, e = "") {
        this.sort = this.container.querySelector(`[${e7}]`);
        let i = this.sort ? this.sort.getAttribute(e7) : "";
        if (!t || (t && "popstate" !== t.type)) {
          if ("" === e) {
            let s = new window.URL(window.location.href).searchParams,
              r = Object.fromEntries(s),
              o = s.toString();
            if (o.includes("filter.") || o.includes("page="))
              for (let a in r)
                (a.includes("filter.") || "page" === a) && s.delete(a);
            if (this.form) {
              let n = new FormData(this.form),
                l = new URLSearchParams(n),
                h = this.form.querySelector(e1),
                c = this.form.querySelector(e2),
                d = h && h.hasAttribute(eQ) ? h.getAttribute(eQ) : "",
                u = c && c.hasAttribute(e5) ? c.getAttribute(e5) : "",
                p = 0;
              for (let [m, g] of l.entries())
                m.includes("filter.") &&
                  g &&
                  (s.append(m, g),
                  ((g === d && "filter.v.price.gte" === m) ||
                    (g === u && "filter.v.price.lte" === m)) &&
                    (p += 1));
              2 === p &&
                (s.delete("filter.v.price.gte"),
                s.delete("filter.v.price.lte"));
            }
            if (i || (t && t.detail && t.detail.href)) {
              let f = i || t.detail.href;
              s.set("sort_by", f);
            }
            let v = s.toString(),
              y = v ? `?${v}` : location.pathname;
            window.history.pushState(null, "", y);
          } else window.history.pushState(null, "", e);
        } else
          this.sort &&
            this.sort.dispatchEvent(
              new CustomEvent("theme:filter:sort", { bubbles: !1 })
            );
        this.productsContainer &&
          (this.productsContainer.classList.add(eK),
          fetch(`${window.location.pathname}${window.location.search}`)
            .then((t) => t.text())
            .then((t) => {
              if (
                ((this.productsContainer.innerHTML = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(e6).innerHTML),
                this.sidebar)
              ) {
                this.sidebar.innerHTML = new DOMParser()
                  .parseFromString(t, "text/html")
                  .querySelector(e0).innerHTML;
                let e = this.sidebar.querySelector(`[${eY}]`),
                  i = this.container.querySelectorAll("[data-active-filters]");
                if (e && i.length) {
                  let s = parseInt(e.getAttribute(eY));
                  i.forEach((t) => {
                    (t.textContent = s), t.classList.toggle(eG, s < 1);
                  });
                }
                this.sidebar.dispatchEvent(
                  new CustomEvent("theme:filter:update", { bubbles: !0 })
                );
              }
              this.collectionNav &&
                eF(
                  this.productsContainer.getBoundingClientRect().top -
                    this.collectionNav.offsetHeight
                ),
                setTimeout(() => {
                  this.productsContainer.classList.remove(eK);
                }, 500);
            })
            .catch((t) => {
              console.log(t);
            }));
      }
      updateRange(t) {
        if (this.form && "function" == typeof this.form.submit) {
          let e = this.form.querySelector(e1),
            i = this.form.querySelector(e2),
            s = this.form.querySelector(ej),
            r = this.form.querySelector(e3);
          if (e && i && s && r && e.hasAttribute(eX) && i.hasAttribute(e4)) {
            let o = parseInt(s.placeholder),
              a = parseInt(r.placeholder),
              n = parseInt(e.getAttribute(eX)),
              l = parseInt(i.getAttribute(e4));
            (o === n && a === l) ||
              ((s.value = n), (r.value = l), this.submitForm(t));
          }
        }
      }
      disconnectedCallback() {
        this.form &&
          (this.sidebar.removeEventListener("input", this.updatePriceEvent),
          this.sidebar.removeEventListener(
            "theme:range:update",
            this.updateRangeEvent
          )),
          this.sidebar &&
            this.sidebar.removeEventListener(
              "click",
              this.filterUpdateFromUrlEvent
            ),
          this.productsContainer &&
            this.productsContainer.removeEventListener(
              "click",
              this.filterUpdateFromUrlEvent
            ),
          this.sort &&
            this.container.removeEventListener(
              "theme:filter:sort-update",
              this.submitFormEvent
            ),
          (this.sidebar || this.sort) &&
            window.removeEventListener("popstate", this.submitFormEvent),
          this.showMoreOptions.length &&
            this.showMoreOptions.forEach((t) => {
              t.removeEventListener("click", this.showMoreEvent);
            });
      }
      constructor() {
        super(),
          (this.container = this.closest("[data-section-type]")),
          (this.sidebar = this.container.querySelector(e0)),
          (this.collectionSidebarSlideOut = this.container.querySelector(
            "[data-collection-sidebar-slide-out]"
          )),
          (this.sort = this.container.querySelector(`[${e7}]`)),
          (this.productsContainer = this.container.querySelector(e6)),
          (this.collectionNav = this.container.querySelector(
            "[data-collection-nav]"
          )),
          (this.form = this.querySelector("[data-collection-filters-form]")),
          (this.showMoreOptions = this.querySelectorAll("[data-show-more]")),
          (this.accessibility = z),
          (this.filterUpdateFromUrlEvent = (t) => this.filterUpdateFromUrl(t)),
          (this.submitFormEvent = (t) => this.submitForm(t)),
          (this.updatePriceEvent = y((t) => this.updatePrice(t), 500)),
          (this.updateRangeEvent = (t) => this.updateRange(t)),
          (this.showMoreEvent = (t) => this.showMore(t));
      }
    },
    it = "data-se-min-value",
    ie = "data-se-max-value",
    ii = "data-se-step",
    is = class extends HTMLElement {
      connectedCallback() {
        let t = this.min;
        this.hasAttribute(it) && (t = parseFloat(this.getAttribute(it)));
        let e = this.max;
        this.hasAttribute(ie) && (e = parseFloat(this.getAttribute(ie))),
          t < this.min && (t = this.min),
          e > this.max && (e = this.max),
          t > e && (t = e),
          this.getAttribute(ii) &&
            (this.step = Math.abs(parseFloat(this.getAttribute(ii)))),
          this.reset(),
          (this.maxX = this.offsetWidth - this.touchRight.offsetWidth),
          (this.selectedTouch = null),
          (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
          this.setMinValue(t),
          this.setMaxValue(e),
          this.touchLeft.addEventListener("mousedown", this.onStartEvent),
          this.touchRight.addEventListener("mousedown", this.onStartEvent),
          this.touchLeft.addEventListener("touchstart", this.onStartEvent, {
            passive: !0,
          }),
          this.touchRight.addEventListener("touchstart", this.onStartEvent, {
            passive: !0,
          }),
          this.classList.add("is-initialized");
      }
      reset() {
        (this.touchLeft.style.left = "0px"),
          (this.touchRight.style.left =
            this.offsetWidth - this.touchLeft.offsetWidth + "px"),
          (this.lineSpan.style.marginLeft = "0px"),
          (this.lineSpan.style.width =
            this.offsetWidth - this.touchLeft.offsetWidth + "px"),
          (this.startX = 0),
          (this.x = 0);
      }
      setMinValue(t) {
        let e = (t - this.min) / (this.max - this.min);
        (this.touchLeft.style.left =
          Math.ceil(
            e *
              (this.offsetWidth -
                (this.touchLeft.offsetWidth + this.normalizeFact))
          ) + "px"),
          (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
          (this.lineSpan.style.width =
            this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
          this.setAttribute(it, t);
      }
      setMaxValue(t) {
        let e = (t - this.min) / (this.max - this.min);
        (this.touchRight.style.left =
          Math.ceil(
            e *
              (this.offsetWidth -
                (this.touchLeft.offsetWidth + this.normalizeFact)) +
              this.normalizeFact
          ) + "px"),
          (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
          (this.lineSpan.style.width =
            this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
          this.setAttribute(ie, t);
      }
      onStart(t) {
        let e = t;
        t.touches && (e = t.touches[0]),
          t.currentTarget === this.touchLeft
            ? (this.x = this.touchLeft.offsetLeft)
            : t.currentTarget === this.touchRight &&
              (this.x = this.touchRight.offsetLeft),
          (this.startX = e.pageX - this.x),
          (this.selectedTouch = t.currentTarget),
          document.addEventListener("mousemove", this.onMoveEvent),
          document.addEventListener("mouseup", this.onStopEvent),
          document.addEventListener("touchmove", this.onMoveEvent, {
            passive: !0,
          }),
          document.addEventListener("touchend", this.onStopEvent, {
            passive: !0,
          });
      }
      onMove(t) {
        let e = t;
        t.touches && (e = t.touches[0]),
          (this.x = e.pageX - this.startX),
          this.selectedTouch === this.touchLeft
            ? (this.x >
              this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                ? (this.x =
                    this.touchRight.offsetLeft -
                    this.selectedTouch.offsetWidth +
                    10)
                : this.x < 0 && (this.x = 0),
              (this.selectedTouch.style.left = this.x + "px"))
            : this.selectedTouch === this.touchRight &&
              (this.x <
              this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                ? (this.x =
                    this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
                : this.x > this.maxX && (this.x = this.maxX),
              (this.selectedTouch.style.left = this.x + "px")),
          (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
          (this.lineSpan.style.width =
            this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
          this.calculateValue(),
          this.getAttribute("on-change") &&
            Function("min, max", this.getAttribute("on-change"))(
              this.getAttribute(it),
              this.getAttribute(ie)
            ),
          this.onChange(this.getAttribute(it), this.getAttribute(ie));
      }
      onStop() {
        document.removeEventListener("mousemove", this.onMoveEvent),
          document.removeEventListener("mouseup", this.onStopEvent),
          document.removeEventListener("touchmove", this.onMoveEvent),
          document.removeEventListener("touchend", this.onStopEvent),
          (this.selectedTouch = null),
          this.calculateValue(),
          this.onChanged(this.getAttribute(it), this.getAttribute(ie));
      }
      onChange(t, e) {
        let i = this.closest("[data-range-holder]");
        if (i) {
          let s = i.querySelector("[data-field-price-min]"),
            r = i.querySelector("[data-field-price-max]");
          s && r && ((s.value = t), (r.value = e));
        }
      }
      onChanged(t, e) {
        this.hasAttribute("data-range-filter-update") &&
          this.dispatchEvent(
            new CustomEvent("theme:range:update", { bubbles: !0 })
          );
      }
      calculateValue() {
        let t =
            (this.lineSpan.offsetWidth - this.normalizeFact) /
            this.initialValue,
          e = this.lineSpan.offsetLeft / this.initialValue,
          i = e + t;
        if (
          ((e = e * (this.max - this.min) + this.min),
          (i = i * (this.max - this.min) + this.min),
          0 !== this.step)
        ) {
          let s = Math.floor(e / this.step);
          (e = this.step * s),
            (s = Math.floor(i / this.step)),
            (i = this.step * s);
        }
        this.selectedTouch === this.touchLeft && this.setAttribute(it, e),
          this.selectedTouch === this.touchRight && this.setAttribute(ie, i);
      }
      onSidebarTransitionEnd(t) {
        t.target == this.sidebar &&
          "min-width" == t.propertyName &&
          (this.sidebar.removeEventListener(
            "transitionend",
            this.sidebarTransitionEvent
          ),
          this.connectedCallback());
      }
      disconnectedCallback() {
        this.sidebar.removeEventListener(
          "transitionend",
          this.sidebarTransitionEvent
        ),
          this.resizeEvent &&
            document.removeEventListener(
              "theme:resize:width",
              this.resizeEvent
            );
      }
      constructor() {
        super(),
          (this.sidebar = this.closest("[data-collection-sidebar]")),
          (this.sidebarTransitionEvent = (t) => this.onSidebarTransitionEnd(t)),
          (this.resizeEvent = () => {
            this.connectedCallback(),
              this.sidebar.addEventListener(
                "transitionend",
                this.sidebarTransitionEvent
              );
          }),
          (this.onMoveEvent = (t) => this.onMove(t)),
          (this.onStopEvent = (t) => this.onStop(t)),
          (this.onStartEvent = (t) => this.onStart(t)),
          (this.startX = 0),
          (this.x = 0),
          (this.touchLeft = this.querySelector("[data-range-left]")),
          (this.touchRight = this.querySelector("[data-range-right]")),
          (this.lineSpan = this.querySelector("[data-range-line]")),
          (this.min = parseFloat(this.getAttribute("data-se-min"))),
          (this.max = parseFloat(this.getAttribute("data-se-max"))),
          (this.step = 0),
          (this.normalizeFact = 26),
          document.addEventListener("theme:resize:width", this.resizeEvent);
      }
    },
    ir = "data-sort-enabled",
    io = "data-value",
    ia = "[data-collection-sidebar-slide-out]",
    il = "[data-collection-sidebar-close]",
    ih = "drawer--animated",
    ic = "expanded",
    id = "is-active",
    iu = {};
  eu("collection", [
    eI,
    eA,
    {
      onLoad() {
        iu[this.id] = new (class {
          init() {
            this.sort && this.initSort(),
              null !== this.groupTagsButton &&
                (document.addEventListener(
                  "theme:resize:width",
                  this.sidebarResizeEvent
                ),
                this.groupTagsButton.addEventListener(
                  "click",
                  this.groupTagsButtonClickEvent
                ),
                this.collectionSidebar &&
                  setTimeout(() => {
                    this.collectionSidebar.classList.remove(
                      "no-mobile-animation"
                    );
                  }, 1e3),
                new MutationObserver((t) => {
                  for (let e of t)
                    "attributes" === e.type &&
                      "true" == e.target.getAttribute("aria-expanded") &&
                      this.showSidebarCallback();
                }).observe(this.groupTagsButton, {
                  attributes: !0,
                  childList: !1,
                  subtree: !1,
                })),
              this.collectionSidebarCloseButtons.length &&
                this.collectionSidebarCloseButtons.forEach((t) => {
                  t.addEventListener("click", this.collectionSidebarCloseEvent);
                }),
              this.container.addEventListener(
                "keyup",
                function (t) {
                  "Escape" === t.code && this.hideSidebar();
                }.bind(this)
              ),
              this.collectionSidebar &&
                (this.collectionSidebar.addEventListener(
                  "transitionend",
                  () => {
                    this.collectionSidebar.classList.contains(ic) ||
                      this.collectionSidebar.classList.remove(ih);
                  }
                ),
                this.toggleSidebarSlider(),
                this.collectionSidebar.addEventListener(
                  "theme:filter:update",
                  () => {
                    let t = this.container.querySelectorAll(il);
                    t.length &&
                      t.forEach((t) => {
                        t.addEventListener(
                          "click",
                          this.collectionSidebarCloseEvent
                        );
                      });
                  }
                ));
          }
          sortActions(t, e = !0) {
            let i = t ? t.getAttribute(io) : "";
            this.sort.setAttribute(ir, i);
            let s = this.sort.querySelector("[data-sort-button-text]"),
              r = this.sort.querySelector(`.${id}`);
            if (s) {
              let o = t ? t.textContent.trim() : "";
              s.textContent = o;
            }
            r && r.classList.remove(id),
              this.sort.classList.toggle(id, t),
              t &&
                (t.parentElement.classList.add(id),
                e &&
                  t.dispatchEvent(
                    new CustomEvent("theme:filter:sort-update", {
                      bubbles: !0,
                      detail: { href: i },
                    })
                  ));
          }
          onSortButtonClick(t) {
            t.preventDefault(),
              this.sortButton &&
                this.sortButton.dispatchEvent(new Event("click")),
              this.sortActions(t.currentTarget);
          }
          onSortCheck(t) {
            let e = null;
            if (window.location.search.includes("sort_by")) {
              let i = new window.URL(window.location.href).searchParams;
              for (let [s, r] of i.entries()) {
                let o = this.sort.querySelector(`[${io}="${r}"]`);
                if (s.includes("sort_by") && o) {
                  e = o;
                  break;
                }
              }
            }
            this.sortActions(e, !1);
          }
          initSort() {
            this.sortLinks.forEach((t) => {
              t.addEventListener("click", this.onSortButtonClickEvent);
            }),
              this.sort.addEventListener(
                "theme:filter:sort",
                this.onSortCheckEvent
              ),
              this.sortButton &&
                this.sortButton.addEventListener("click", () => {
                  let t = this.collectionSidebar.classList.contains(ic);
                  L() && t && this.hideSidebar();
                });
          }
          showSidebarCallback() {
            let t = this.container.querySelector(ia),
              e = document.documentElement.hasAttribute("data-scroll-locked"),
              i = L();
            this.collectionSidebar.classList.add(ih),
              null === t &&
                !i &&
                e &&
                (this.accessibility.removeTrapFocus(),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                )),
              (i || null !== t) &&
                (t &&
                  this.accessibility.trapFocus(this.collectionSidebar, {
                    elementToFocus: this.collectionSidebar.querySelector(il),
                  }),
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                ));
          }
          hideSidebar() {
            let t = this.container.querySelector(ia),
              e = document.documentElement.hasAttribute("data-scroll-locked");
            this.groupTagsButton.setAttribute("aria-expanded", "false"),
              this.collectionSidebar.classList.remove(ic),
              t && this.accessibility.removeTrapFocus(),
              e &&
                document.dispatchEvent(
                  new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                );
          }
          toggleSidebarSlider() {
            L()
              ? this.hideSidebar()
              : this.collectionSidebar.classList.contains(ic) &&
                this.showSidebarCallback();
          }
          collectionSidebarClose(t) {
            t.preventDefault(),
              this.hideSidebar(),
              document.body.classList.contains("is-focused") &&
                this.groupTagsButton &&
                this.groupTagsButton.focus();
          }
          groupTagsButtonClick() {
            document.documentElement.hasAttribute("data-scroll-locked") &&
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
          }
          onUnload() {
            null !== this.groupTagsButton &&
              (document.removeEventListener(
                "theme:resize:width",
                this.sidebarResizeEvent
              ),
              this.groupTagsButton.removeEventListener(
                "click",
                this.groupTagsButtonClickEvent
              )),
              this.collectionSidebarCloseButtons.length &&
                this.collectionSidebarCloseButtons.forEach((t) => {
                  t.removeEventListener(
                    "click",
                    this.collectionSidebarCloseEvent
                  );
                }),
              this.sort &&
                (this.sortLinks.forEach((t) => {
                  t.removeEventListener("click", this.onSortButtonClickEvent);
                }),
                this.sort.removeEventListener(
                  "theme:filter:sort",
                  this.onSortCheckEvent
                ));
          }
          constructor(t) {
            (this.container = t.container),
              (this.sort = this.container.querySelector(`[${ir}]`)),
              (this.sortButton = this.container.querySelector(
                "[data-popout-toggle]"
              )),
              (this.sortLinks =
                this.container.querySelectorAll("[data-sort-link]")),
              (this.collectionSidebar = this.container.querySelector(
                "[data-collection-sidebar]"
              )),
              (this.collectionSidebarCloseButtons =
                this.container.querySelectorAll(il)),
              (this.groupTagsButton =
                this.container.querySelector("[data-aria-toggle]")),
              (this.collectionNav = this.container.querySelector(
                "[data-collection-nav]"
              )),
              (this.accessibility = z),
              (this.groupTagsButtonClickEvent = (t) =>
                this.groupTagsButtonClick(t)),
              (this.collectionSidebarCloseEvent = (t) =>
                this.collectionSidebarClose(t)),
              (this.onSortButtonClickEvent = (t) => this.onSortButtonClick(t)),
              (this.onSortCheckEvent = (t) => this.onSortCheck(t)),
              (this.sidebarResizeEvent = () => this.toggleSidebarSlider()),
              this.init();
          }
        })(this);
      },
      onUnload() {
        iu[this.id].onUnload();
      },
    },
    ek,
  ]),
    customElements.get("collection-filters-form") ||
      customElements.define("collection-filters-form", eZ),
    customElements.get("range-slider") ||
      customElements.define("range-slider", is);
  let ip = "data-clone",
    im = "data-marquee-speed",
    ig = "ticker--animated",
    iv = "[data-slide]",
    iy = "[data-slider]",
    ib = "[data-ticker-text]",
    iS = "ticker--animated",
    iE = "data-stop",
    iL = "data-target-referrer",
    iw = class extends HTMLElement {
      connectedCallback() {
        this.removeAnnouncement(),
          this.slider && this.initSliders(),
          this.marquee && this.initTickers(!0),
          this.addEventListener("theme:block:select", (t) => {
            this.onBlockSelect(t);
          }),
          this.addEventListener("theme:block:deselect", (t) => {
            this.onBlockDeselect(t);
          }),
          document.dispatchEvent(
            new CustomEvent("theme:announcement:init", { bubbles: !0 })
          );
      }
      removeAnnouncement() {
        for (let t = 0; t < this.slides.length; t++) {
          let e = this.slides[t];
          e.hasAttribute(iL) &&
            (-1 !== this.locationPath.indexOf(e.getAttribute(iL)) ||
              window.Shopify.designMode ||
              e.parentNode.removeChild(e));
        }
      }
      initSliders() {
        this.initSlider(),
          document.addEventListener("theme:resize:width", this.initSliderEvent),
          this.addEventListener("theme:slider:loaded", () => {
            this.initTickers();
          });
      }
      initSlider(t) {
        let e =
          window.innerWidth ||
          document.documentElement.clientWidth ||
          document.body.clientWidth;
        if (
          (e >= theme.sizes.small && this.enableSlider) ||
          (e < theme.sizes.small && !this.enableSlider)
        ) {
          var i, s;
          let r = "";
          null === (i = this.slider.flkty) || void 0 === i || i.destroy(),
            e >= theme.sizes.small && this.enableSlider
              ? ((this.enableSlider = !1), (r = `${iv}:not(.mobile)`))
              : e < theme.sizes.small &&
                !this.enableSlider &&
                ((this.enableSlider = !0), (r = `${iv}:not(.desktop)`)),
            (this.slider = new eM(this, this.querySelector(iy), r)),
            null === (s = this.slider.flkty) || void 0 === s || s.reposition();
        }
        this.slider.flkty || this.initTickers();
      }
      initTickers(t = !1) {
        this.frames.forEach((e) => {
          new (class {
            listen() {
              this.frame.addEventListener(
                "theme:marquee:refresh",
                this.checkWidthEvent
              ),
                this.checkWidth();
            }
            checkWidth() {
              let t =
                  2 *
                  window
                    .getComputedStyle(this.frame)
                    .paddingLeft.replace("px", ""),
                e = this.frame.getAttribute(im)
                  ? this.frame.getAttribute(im)
                  : 1.63;
              if (
                this.frame.clientWidth - t < this.comparitor.clientWidth ||
                this.stopClone
              ) {
                if (
                  (this.text.classList.add(ig),
                  1 === this.scale.childElementCount)
                ) {
                  if (
                    ((this.clone = this.text.cloneNode(!0)),
                    this.clone.setAttribute(ip, ""),
                    this.scale.appendChild(this.clone),
                    this.stopClone)
                  )
                    for (let i = 0; i < 10; i++) {
                      let s = this.text.cloneNode(!0);
                      s.setAttribute(ip, ""), this.scale.appendChild(s);
                    }
                  let r = ((this.text.clientWidth / 100) * Number(e)).toFixed(
                    2
                  );
                  this.scale.style.setProperty("--animation-time", `${r}s`);
                }
              } else {
                this.text.classList.add(ig);
                let o = this.scale.querySelector(`[${ip}]`);
                o && this.scale.removeChild(o), this.text.classList.remove(ig);
              }
            }
            constructor(t, e = !1) {
              (this.frame = t),
                (this.stopClone = e),
                (this.scale = this.frame.querySelector("[data-ticker-scale]")),
                (this.text = this.frame.querySelector("[data-ticker-text]")),
                (this.comparitor = this.text.cloneNode(!0)),
                this.comparitor.classList.add("ticker__comparitor"),
                this.frame.appendChild(this.comparitor),
                this.scale.classList.remove("ticker--unloaded"),
                (this.checkWidthEvent = this.checkWidth.bind(this)),
                this.listen();
            }
          })(e, t);
        }),
          document.addEventListener(
            "theme:resize:width",
            this.tickerResizeEvent
          );
      }
      onTickerResize() {
        this.frames.forEach((t) => {
          t.dispatchEvent(new CustomEvent("theme:marquee:refresh"));
        });
      }
      toggleTicker(t, e) {
        let i = this.querySelector("[data-ticker-scale]"),
          s = this.querySelector(`[data-slide="${t.detail.blockId}"]`);
        e &&
          s &&
          (i.setAttribute(iE, ""),
          i.querySelectorAll(ib).forEach((t) => {
            t.classList.remove(iS),
              (t.style.transform = `translate3d(${-(
                s.offsetLeft - s.clientWidth
              )}px, 0, 0)`);
          })),
          !e &&
            s &&
            (i.querySelectorAll(ib).forEach((t) => {
              t.classList.add(iS), t.removeAttribute("style");
            }),
            i.removeAttribute(iE));
      }
      onBlockSelect(t) {
        this.slider ? this.slider.onBlockSelect(t) : this.toggleTicker(t, !0);
      }
      onBlockDeselect(t) {
        this.slider ? this.slider.onBlockDeselect(t) : this.toggleTicker(t, !1);
      }
      disconnectedCallback() {
        document.removeEventListener(
          "theme:resize:width",
          this.initSliderEvent
        ),
          document.removeEventListener(
            "theme:resize:width",
            this.tickerResizeEvent
          );
      }
      constructor() {
        super(),
          (this.locationPath = location.href),
          (this.slides = this.querySelectorAll(iv)),
          (this.frames = this.querySelectorAll("[data-ticker-frame]")),
          (this.slider = this.querySelector(iy)),
          (this.marquee = this.querySelector("[data-marquee]")),
          (this.enableSlider =
            (window.innerWidth ||
              document.documentElement.clientWidth ||
              document.body.clientWidth) >= theme.sizes.small),
          (this.initSliderEvent = (t) => this.initSlider(t)),
          (this.tickerResizeEvent = (t) => this.onTickerResize(t));
      }
    };
  customElements.get("announcement-bar") ||
    customElements.define("announcement-bar", iw);
  let ik = "[data-drawer]",
    i$ = "drawer--animated",
    iA = "is-open",
    iT = "is-focused",
    iC = {},
    iq = ".page-header",
    ix = "js__header__stuck",
    i_ = {},
    iP = "is-visible",
    iH = "meganav--visible",
    iB = "meganav--is-transitioning",
    i8 = {},
    iD = {},
    iM = "data-cart-count",
    iI = {
      slideruleOpen: "data-sliderule-open",
      slideruleClose: "data-sliderule-close",
      sliderulePane: "data-sliderule-pane",
      slideruleWrappper: "[data-sliderule]",
      drawerContent: "[data-drawer-content]",
      focusable:
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
      dataAnimates: "data-animates",
      children:
        ":scope > [data-animates],\n             :scope > * > [data-animates],\n             :scope > * > * >[data-animates],\n             :scope > * > .sliderule-grid  > *",
    },
    i9 = "is-visible",
    iF = "is-hiding",
    iO = "is-hidden",
    iR = "is-scrolling",
    iz = {},
    iN = "js__show__mobile",
    iW = {};
  eu("header", [
    {
      onLoad() {
        iW = new (class {
          listenWidth() {
            "ResizeObserver" in window
              ? ((this.resizeObserver = new ResizeObserver(this.checkWidth)),
                this.resizeObserver.observe(this.wrapper))
              : document.addEventListener("theme:resize", this.checkWidth);
          }
          killDeadLinks() {
            this.deadLinks.forEach((t) => {
              t.onclick = (t) => {
                t.preventDefault();
              };
            });
          }
          checkWidth() {
            document.body.clientWidth < this.minWidth
              ? this.wrapper.classList.add(iN)
              : this.wrapper.classList.remove(iN);
          }
          getMinWidth() {
            let t = this.wrapper.cloneNode(!0);
            t.classList.add("js__header__clone"), document.body.appendChild(t);
            let e = t.querySelectorAll("[data-takes-space-wrapper]"),
              i = 0,
              s = 0;
            return (
              e.forEach((t) => {
                var e, r;
                let o = t.querySelectorAll("[data-child-takes-space]"),
                  a = 0,
                  n,
                  l;
                (a =
                  3 === o.length
                    ? ((n = []),
                      (e = o).forEach((t) => {
                        t.firstElementChild &&
                          n.push(t.firstElementChild.clientWidth);
                      }),
                      n[0] > n[2] ? (n[2] = n[0]) : (n[0] = n[2]),
                      n.reduce((t, e) => t + e))
                    : ((l = 0),
                      (r = o).forEach((t) => {
                        l += t.clientWidth;
                      }),
                      l)) > i && ((i = a), (s = 20 * o.length));
              }),
              document.body.removeChild(t),
              i + s
            );
          }
          cartToggleEvent() {
            let t = this.wrapper.querySelectorAll("[data-cart-toggle]");
            t.length &&
              t.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(),
                    document.dispatchEvent(
                      new CustomEvent("theme:cart:toggle", { bubbles: !0 })
                    );
                });
              });
          }
          unload() {
            var t;
            "ResizeObserver" in window
              ? null === (t = this.resizeObserver) ||
                void 0 === t ||
                t.unobserve(this.wrapper)
              : document.removeEventListener("theme:resize", this.checkWidth);
          }
          constructor(t) {
            (this.wrapper = t),
              (this.style = this.wrapper.dataset.style),
              (this.desktop = this.wrapper.querySelector(
                "[data-header-desktop]"
              )),
              (this.deadLinks =
                document.querySelectorAll('.navlink[href="#"]')),
              (this.resizeObserver = null),
              (this.checkWidth = this.checkWidth.bind(this)),
              this.killDeadLinks(),
              "drawer" !== this.style &&
                this.desktop &&
                ((this.minWidth = this.getMinWidth()), this.listenWidth()),
              this.cartToggleEvent();
            let e = document.querySelector(
              ".main-content > .shopify-section.section-overlay-header:first-of-type"
            );
            document.body.classList.toggle(
              "has-header-transparent",
              this.wrapper.hasAttribute("data-header-transparent")
            ),
              document.body.classList.toggle(
                "has-first-section-overlay-header",
                e
              );
          }
        })(this.container);
      },
      onUnload() {
        "function" == typeof iW.unload && iW.unload();
      },
    },
    {
      onLoad() {
        (iC[this.id] = []),
          this.container.querySelectorAll(ik).forEach((t) => {
            iC[this.id].push(
              new (class {
                connectToggle() {
                  this.buttons.forEach((t) => {
                    t.addEventListener("click", () => {
                      this.drawer.dispatchEvent(
                        new CustomEvent("theme:drawer:toggle", { bubbles: !1 })
                      );
                    });
                  });
                }
                connectDrawer() {
                  this.drawer.addEventListener("theme:drawer:toggle", () => {
                    this.drawer.classList.contains(iA)
                      ? this.drawer.dispatchEvent(
                          new CustomEvent("theme:drawer:close", { bubbles: !0 })
                        )
                      : this.drawer.dispatchEvent(
                          new CustomEvent("theme:drawer:open", { bubbles: !0 })
                        );
                  }),
                    this.drawerInner &&
                      this.drawerInner.addEventListener(
                        "transitionend",
                        (t) => {
                          t.target == this.drawerInner &&
                            (this.drawer.classList.contains(iA) ||
                              (this.drawer.classList.remove(i$),
                              document.dispatchEvent(
                                new CustomEvent("theme:sliderule:close", {
                                  bubbles: !1,
                                })
                              )));
                        }
                      ),
                    document.addEventListener(
                      "theme:cart:open",
                      this.hideDrawer
                    ),
                    document.addEventListener(
                      "theme:drawer:close",
                      this.hideDrawer
                    ),
                    document.addEventListener(
                      "theme:drawer:open",
                      this.showDrawer
                    );
                }
                watchFocus(t) {
                  !this.wrapper.contains(t.target) &&
                    this.body.classList.contains(iT) &&
                    this.hideDrawer();
                }
                closers() {
                  this.wrapper.addEventListener(
                    "keyup",
                    function (t) {
                      "Escape" === t.code &&
                        (this.hideDrawer(), this.buttons[0].focus());
                    }.bind(this)
                  ),
                    this.underlay.addEventListener("click", () => {
                      this.hideDrawer();
                    });
                }
                showDrawer() {
                  this.drawerInner &&
                    this.drawerInner.querySelector(this.btnSelector) &&
                    (this.accessibility.removeTrapFocus(),
                    this.drawerInner.addEventListener("transitionend", (t) => {
                      t.target == this.drawerInner &&
                        this.drawer.classList.contains(iA) &&
                        this.accessibility.trapFocus(this.drawerInner, {
                          elementToFocus: this.drawerInner.querySelector(
                            this.btnSelector
                          ),
                        });
                    })),
                    this.buttons.forEach((t) => {
                      t.setAttribute("aria-expanded", !0);
                    }),
                    this.drawer.classList.add(iA),
                    this.drawer.classList.add(i$),
                    this.drawer
                      .querySelector(
                        'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
                      )
                      .focus(),
                    document.addEventListener("focusin", this.initWatchFocus),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                    );
                }
                hideDrawer() {
                  this.drawer.classList.contains(iA) &&
                    (this.accessibility.removeTrapFocus(),
                    this.body.classList.contains(iT) &&
                      this.buttons.length &&
                      this.buttons[0].focus(),
                    this.buttons.forEach((t) => {
                      t.setAttribute("aria-expanded", !1);
                    }),
                    this.drawer.classList.remove(iA),
                    document.removeEventListener(
                      "focusin",
                      this.initWatchFocus
                    ),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    ));
                }
                onUnload() {
                  document.removeEventListener(
                    "theme:cart:open",
                    this.hideDrawer
                  ),
                    document.removeEventListener(
                      "theme:drawer:close",
                      this.hideDrawer
                    ),
                    document.removeEventListener(
                      "theme:drawer:open",
                      this.showDrawer
                    );
                }
                constructor(t) {
                  (this.drawer = t),
                    (this.drawerWrapper = this.drawer.closest(ik)),
                    (this.drawerInner = this.drawer.querySelector(
                      "[data-drawer-inner]"
                    )),
                    (this.underlay = this.drawer.querySelector(
                      "[data-drawer-underlay]"
                    )),
                    (this.wrapper = this.drawer.closest(
                      "[data-header-wrapper]"
                    )),
                    (this.key = this.drawer.dataset.drawer),
                    (this.btnSelector = `[data-drawer-toggle='${this.key}']`),
                    (this.buttons = document.querySelectorAll(
                      this.btnSelector
                    )),
                    (this.staggers = this.drawer.querySelectorAll(
                      "[data-stagger-animation]"
                    )),
                    (this.body = document.querySelector("body")),
                    (this.accessibility = z),
                    (this.initWatchFocus = (t) => this.watchFocus(t)),
                    (this.showDrawer = this.showDrawer.bind(this)),
                    (this.hideDrawer = this.hideDrawer.bind(this)),
                    this.connectToggle(),
                    this.connectDrawer(),
                    this.closers();
                }
              })(t)
            );
          });
      },
      onUnload() {
        iC[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    {
      onLoad() {
        (iz[this.id] = []),
          this.container.querySelectorAll(iI.slideruleWrappper).forEach((t) => {
            iz[this.id].push(
              new (class {
                clickEvents() {
                  this.trigger.addEventListener("click", () => {
                    (this.cachedButton = this.trigger), this.showSliderule();
                  }),
                    this.exit.forEach((t) => {
                      t.addEventListener("click", () => {
                        this.hideSliderule();
                      });
                    });
                }
                keyboardEvents() {
                  this.sliderule.addEventListener("keyup", (t) => {
                    t.stopPropagation(),
                      "Escape" === t.code && this.hideSliderule();
                  });
                }
                trapFocusSliderule(t = !0) {
                  let e = t
                    ? this.sliderule.querySelector(this.exitSelector)
                    : this.cachedButton;
                  this.accessibility.removeTrapFocus(),
                    e &&
                      this.drawerContent &&
                      this.accessibility.trapFocus(this.drawerContent, {
                        elementToFocus: document.body.classList.contains(
                          "is-focused"
                        )
                          ? e
                          : null,
                      });
                }
                hideSliderule(t = !1) {
                  let e = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                  this.pane.setAttribute(iI.sliderulePane, e),
                    this.pane.classList.add(iF),
                    this.sliderule.classList.add(iF);
                  let i = t
                      ? `[${iI.dataAnimates}].${iO}`
                      : `[${iI.dataAnimates}="${e}"]`,
                    s = this.pane.querySelectorAll(i);
                  s.length &&
                    s.forEach((t) => {
                      t.classList.remove(iO);
                    });
                  let r = t
                    ? this.pane.querySelectorAll(`.${i9}, .${iF}`)
                    : this.children;
                  r.forEach((i, s) => {
                    let o = r.length - 1 == s;
                    i.classList.remove(i9),
                      t &&
                        (i.classList.remove(iF),
                        this.pane.classList.remove(iF));
                    let a = () => {
                      parseInt(this.pane.getAttribute(iI.sliderulePane)) ===
                        e && this.sliderule.classList.remove(i9),
                        this.sliderule.classList.remove(iF),
                        this.pane.classList.remove(iF),
                        o &&
                          (this.accessibility.removeTrapFocus(),
                          t || this.trapFocusSliderule(!1)),
                        i.removeEventListener("animationend", a);
                    };
                    window.theme.settings.enableAnimations
                      ? i.addEventListener("animationend", a)
                      : a();
                  });
                }
                showSliderule() {
                  let t = null,
                    e = this.sliderule.closest(`.${i9}`),
                    i = this.pane;
                  e && (i = e),
                    i.scrollTo({ top: 0, left: 0, behavior: "smooth" }),
                    i.classList.add(iR);
                  let s = () => {
                    i.scrollTop <= 0
                      ? (i.classList.remove(iR), t && cancelAnimationFrame(t))
                      : (t = requestAnimationFrame(s));
                  };
                  (t = requestAnimationFrame(s)),
                    this.sliderule.classList.add(i9);
                  let r = parseInt(this.pane.dataset.sliderulePane, 10);
                  this.pane.setAttribute(iI.sliderulePane, r + 1);
                  let o = this.pane.querySelectorAll(
                    `[${iI.dataAnimates}="${r}"]`
                  );
                  o.length &&
                    o.forEach((t, e) => {
                      let i = o.length - 1 == e;
                      t.classList.add(iF);
                      let s = () => {
                        t.classList.remove(iF),
                          parseInt(this.pane.getAttribute(iI.sliderulePane)) !==
                            r && t.classList.add(iO),
                          i && this.trapFocusSliderule(),
                          t.removeEventListener("animationend", s);
                      };
                      window.theme.settings.enableAnimations
                        ? t.addEventListener("animationend", s)
                        : s();
                    });
                }
                closeSliderule() {
                  this.pane &&
                    this.pane.hasAttribute(iI.sliderulePane) &&
                    parseInt(this.pane.getAttribute(iI.sliderulePane)) > 0 &&
                    (this.hideSliderule(!0),
                    parseInt(this.pane.getAttribute(iI.sliderulePane)) > 0 &&
                      this.pane.setAttribute(iI.sliderulePane, 0));
                }
                onUnload() {
                  document.removeEventListener(
                    "theme:sliderule:close",
                    this.closeSliderule
                  );
                }
                constructor(t) {
                  (this.sliderule = t), (this.key = this.sliderule.id);
                  let e = `[${iI.slideruleOpen}='${this.key}']`;
                  (this.exitSelector = `[${iI.slideruleClose}='${this.key}']`),
                    (this.trigger = document.querySelector(e)),
                    (this.exit = document.querySelectorAll(this.exitSelector)),
                    (this.pane = document.querySelector(
                      `[${iI.sliderulePane}]`
                    )),
                    (this.children = this.sliderule.querySelectorAll(
                      iI.children
                    )),
                    (this.drawerContent = document.querySelector(
                      iI.drawerContent
                    )),
                    (this.cachedButton = null),
                    (this.accessibility = z),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    (this.closeSliderule = this.closeSliderule.bind(this)),
                    this.clickEvents(),
                    this.keyboardEvents(),
                    document.addEventListener(
                      "theme:sliderule:close",
                      this.closeSliderule
                    );
                }
              })(t)
            );
          });
      },
      onUnload() {
        iz[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    {
      onLoad() {
        i_ = new (class {
          listen() {
            document.addEventListener("theme:scroll", this.scrollEvent),
              document.addEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.addEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          onScroll(t) {
            t.detail.down
              ? !this.isStuck &&
                t.detail.position > this.headerOffset &&
                this.stickSimple()
              : t.detail.position <= this.headerOffset && this.unstickSimple();
          }
          updateHeaderOffset(t) {
            t.target.classList.contains("shopify-section-group-header-group") &&
              setTimeout(() => {
                var t;
                this.headerOffset =
                  null === (t = document.querySelector(iq)) || void 0 === t
                    ? void 0
                    : t.offsetTop;
              });
          }
          stickOnLoad() {
            window.scrollY > this.headerOffset && this.stickSimple();
          }
          stickSimple() {
            this.cls.add(ix), (this.isStuck = !0);
          }
          unstickSimple() {
            document.documentElement.hasAttribute("data-scroll-locked") ||
              (this.cls.remove(ix), (this.isStuck = !1));
          }
          unload() {
            document.removeEventListener("theme:scroll", this.scrollEvent),
              document.removeEventListener(
                "shopify:section:load",
                this.updateHeaderOffset
              ),
              document.removeEventListener(
                "shopify:section:unload",
                this.updateHeaderOffset
              );
          }
          constructor(t) {
            var e;
            (this.wrapper = t),
              (this.sticks = this.wrapper.hasAttribute("data-header-sticky")),
              document.body.classList.toggle("has-header-sticky", this.sticks),
              this.sticks &&
                ((this.isStuck = !1),
                (this.cls = this.wrapper.classList),
                (this.headerOffset =
                  null === (e = document.querySelector(iq)) || void 0 === e
                    ? void 0
                    : e.offsetTop),
                (this.headerHeight = document.querySelector(
                  "[data-header-wrapper] header"
                ).clientHeight),
                (this.updateHeaderOffset = this.updateHeaderOffset.bind(this)),
                (this.scrollEvent = (t) => this.onScroll(t)),
                this.listen(),
                this.stickOnLoad());
          }
        })(this.container);
      },
      onUnload: function () {
        "function" == typeof i_.unload && i_.unload();
      },
    },
    {
      onLoad() {
        (i8[this.id] = []),
          (iD = this.container.querySelectorAll(
            "[data-hover-disclosure]"
          )).forEach((t) => {
            i8[this.id].push(
              new (class {
                onBlockSelect(t) {
                  this.disclosure.contains(t.target) && this.showDisclosure(t);
                }
                onBlockDeselect(t) {
                  this.disclosure.contains(t.target) && this.hideDisclosure();
                }
                showDisclosure(t) {
                  t &&
                    t.type &&
                    "mouseenter" === t.type &&
                    this.wrapper.classList.add(iB),
                    this.grandparent
                      ? this.wrapper.classList.add(iH)
                      : this.wrapper.classList.remove(iH),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(iP),
                    this.disclosure.classList.add(iP),
                    this.transitionTimeout &&
                      clearTimeout(this.transitionTimeout),
                    (this.transitionTimeout = setTimeout(() => {
                      this.wrapper.classList.remove(iB);
                    }, 200));
                }
                hideDisclosure() {
                  this.disclosure.classList.remove(iP),
                    this.trigger.classList.remove(iP),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(iH, iB);
                }
                staggerChildAnimations() {
                  this.disclosure
                    .querySelectorAll("[data-stagger]")
                    .forEach((t, e) => {
                      t.style.transitionDelay = 50 * e + 10 + "ms";
                    }),
                    this.disclosure
                      .querySelectorAll("[data-stagger-first]")
                      .forEach((t, e) => {
                        let i = 100 * e;
                        (t.style.transitionDelay = `${i}ms`),
                          t.parentElement
                            .querySelectorAll("[data-stagger-second]")
                            .forEach((t, e) => {
                              t.style.transitionDelay = `${i + 20 * (e + 1)}ms`;
                            });
                      });
                }
                handleTablets() {
                  this.trigger.addEventListener(
                    "touchstart",
                    function (t) {
                      this.disclosure.classList.contains(iP) ||
                        (t.preventDefault(), this.showDisclosure(t));
                    }.bind(this),
                    { passive: !0 }
                  );
                }
                connectHoverToggle() {
                  this.trigger.addEventListener("mouseenter", (t) =>
                    this.showDisclosure(t)
                  ),
                    this.link.addEventListener("focus", (t) =>
                      this.showDisclosure(t)
                    ),
                    this.trigger.addEventListener("mouseleave", () =>
                      this.hideDisclosure()
                    ),
                    this.trigger.addEventListener("focusout", (t) => {
                      this.trigger.contains(t.relatedTarget) ||
                        this.hideDisclosure();
                    }),
                    this.disclosure.addEventListener("keyup", (t) => {
                      "Escape" === t.code && this.hideDisclosure();
                    });
                }
                constructor(t) {
                  (this.disclosure = t),
                    (this.wrapper = t.closest("[data-header-wrapper]")),
                    (this.key = this.disclosure.id),
                    (this.trigger = document.querySelector(
                      `[data-hover-disclosure-toggle='${this.key}']`
                    )),
                    (this.link = this.trigger.querySelector("[data-top-link]")),
                    (this.grandparent =
                      this.trigger.classList.contains("grandparent")),
                    (this.transitionTimeout = 0),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        i8[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        i8[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
    },
    {
      onLoad() {
        new (class {
          listen() {
            document.addEventListener("theme:cart:change", (t) => {
              (this.cartCount = t.detail.cartCount), this.update();
            });
          }
          update() {
            null !== this.cartCount &&
              this.counts.forEach((t) => {
                t.setAttribute(iM, this.cartCount),
                  (t.innerHTML =
                    this.cartCount < 10 ? `(${this.cartCount})` : "9+");
              });
          }
          constructor(t) {
            (this.section = t),
              (this.counts = this.section.querySelectorAll(`[${iM}]`)),
              (this.cartCount = null),
              this.listen();
          }
        })(this.container);
      },
    },
  ]);
  let iU = {},
    i0 = {
      onLoad() {
        iU[this.id] = new (class {
          onBlockSelect(t) {
            let e = this.container.querySelector("[data-block-scroll]");
            if (e && !e.classList.contains("flickity-enabled")) {
              let i = t.srcElement;
              i &&
                e.scrollTo({ top: 0, left: i.offsetLeft, behavior: "smooth" });
            }
          }
          constructor(t) {
            this.container = t.container;
          }
        })(this);
      },
      onBlockSelect(t) {
        iU[this.id].onBlockSelect(t);
      },
    },
    iV = "[data-header-height]",
    ij = "is-animating",
    i3 = "is-open",
    i1 = "data-slider-thumb",
    i2 = {};
  function iX() {
    this.entries = [];
  }
  function i4(t) {
    if ("object" != typeof t) throw TypeError(t + " is not an object.");
    if (0 === Object.keys(t).length && t.constructor === Object)
      throw Error(t + " is empty.");
  }
  eu("look", [
    {
      onLoad() {
        i2[this.id] = new (class {
          init() {
            this.slider &&
              this.slides.length &&
              this.thumbs.length &&
              (this.popupContainer.addEventListener("transitionend", (t) => {
                t.target == this.popupContainer &&
                  (this.popupContainer.classList.remove(ij),
                  t.target.classList.contains(i3)
                    ? this.popupOpenCallback()
                    : this.popupCloseCallback());
              }),
              this.popupContainer.addEventListener("transitionstart", (t) => {
                t.target == this.popupContainer &&
                  this.popupContainer.classList.add(ij);
              }),
              this.popupClose.forEach((t) => {
                t.addEventListener("click", () => {
                  this.popupContainer.classList.remove(i3), this.scrollUnlock();
                });
              }),
              this.thumbs.forEach((t, e) => {
                t.addEventListener("click", (i) => {
                  i.preventDefault();
                  let s =
                      t.hasAttribute(i1) && "" !== t.getAttribute(i1)
                        ? parseInt(t.getAttribute(i1))
                        : e,
                    r = this.slides[s];
                  if (L()) {
                    let o = parseInt(
                        window.getComputedStyle(this.slider).paddingLeft
                      ),
                      a = r.offsetLeft;
                    this.slider.scrollTo({
                      top: 0,
                      left: a - o,
                      behavior: "auto",
                    }),
                      this.scrollLock(),
                      this.popupContainer.classList.add(ij, i3);
                  } else {
                    let n =
                        document.querySelector("[data-header-sticky]") &&
                        document.querySelector(iV)
                          ? document.querySelector(iV).getBoundingClientRect()
                              .height
                          : 0,
                      l = r.getBoundingClientRect().top,
                      h = r.offsetHeight / 2,
                      c = window.innerHeight,
                      d = this.container.querySelector(
                        "[data-slider-container]"
                      ),
                      u = l + h - c / 2 + window.scrollY;
                    if (d) {
                      let p = d.getBoundingClientRect().top + window.scrollY,
                        m = p + d.offsetHeight;
                      u < p ? (u = p - n) : u + c > m && (u = m - c);
                    }
                    window.scrollTo({ top: u, left: 0, behavior: "smooth" });
                  }
                });
              }));
          }
          popupCloseByEvent() {
            this.popupContainer.classList.remove(i3);
          }
          popupOpenCallback() {
            document.addEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.addEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          popupCloseCallback() {
            document.removeEventListener(
              "theme:quick-add:open",
              this.popupCloseByEvent,
              { once: !0 }
            ),
              document.removeEventListener(
                "theme:product:added",
                this.popupCloseByEvent,
                { once: !0 }
              );
          }
          scrollLock() {
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            );
          }
          scrollUnlock() {
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
          }
          constructor(t) {
            (this.container = t.container),
              (this.slider = this.container.querySelector(
                "[data-slider-mobile]"
              )),
              (this.slides = this.container.querySelectorAll("[data-slide]")),
              (this.thumbs = this.container.querySelectorAll(
                "[data-slider-thumb]"
              )),
              (this.popupContainer = this.container.querySelector(
                "[data-popup-container]"
              )),
              (this.popupClose =
                this.container.querySelectorAll("[data-popup-close]")),
              (this.popupCloseByEvent = this.popupCloseByEvent.bind(this)),
              this.init();
          }
        })(this);
      },
    },
    i0,
  ]),
    (iX.prototype.add = function (t, e, i) {
      this.entries.push({ element: t, event: e, fn: i }),
        t.addEventListener(e, i);
    }),
    (iX.prototype.removeAll = function () {
      this.entries = this.entries.filter(function (t) {
        return t.element.removeEventListener(t.event, t.fn), !1;
      });
    });
  var iQ = '[name="selling_plan"]';
  let i5 = "data-scrollbar-slide-fullwidth",
    i6 = "is-hidden",
    iJ = class {
      init() {
        this.arrowNext &&
          this.arrowPrev &&
          (this.toggleNextArrow(), this.events());
      }
      resize() {
        document.addEventListener("theme:resize", () => {
          this.toggleNextArrow();
        });
      }
      events() {
        this.arrowNext.addEventListener("click", (t) => {
          t.preventDefault(), this.goToNext();
        }),
          this.arrowPrev.addEventListener("click", (t) => {
            t.preventDefault(), this.goToPrev();
          }),
          this.scrollbar.addEventListener("scroll", () => {
            this.togglePrevArrow(), this.toggleNextArrow();
          });
      }
      goToNext() {
        let t =
          (this.scrollbar.hasAttribute(i5)
            ? this.scrollbar.getBoundingClientRect().width
            : this.scrollbar.getBoundingClientRect().width / 2) +
          this.scrollbar.scrollLeft;
        this.move(t),
          this.arrowPrev.classList.remove(i6),
          this.toggleNextArrow();
      }
      goToPrev() {
        let t = this.scrollbar.hasAttribute(i5)
            ? this.scrollbar.getBoundingClientRect().width
            : this.scrollbar.getBoundingClientRect().width / 2,
          e = this.scrollbar.scrollLeft - t;
        this.move(e),
          this.arrowNext.classList.remove(i6),
          this.togglePrevArrow();
      }
      toggleNextArrow() {
        setTimeout(() => {
          this.arrowNext.classList.toggle(
            i6,
            Math.round(
              this.scrollbar.scrollLeft +
                this.scrollbar.getBoundingClientRect().width +
                1
            ) >= this.scrollbar.scrollWidth
          );
        }, 200);
      }
      togglePrevArrow() {
        setTimeout(() => {
          this.arrowPrev.classList.toggle(i6, this.scrollbar.scrollLeft <= 0);
        }, 200);
      }
      scrollToVisibleElement() {
        [].forEach.call(this.scrollbar.children, (t) => {
          t.addEventListener("click", (e) => {
            e.preventDefault(), this.move(t.offsetLeft - t.clientWidth);
          });
        });
      }
      move(t) {
        this.scrollbar.scrollTo({ top: 0, left: t, behavior: "smooth" });
      }
      constructor(t) {
        (this.scrollbar = t),
          (this.arrowNext = this.scrollbar.parentNode.querySelector(
            "[data-scrollbar-arrow-next]"
          )),
          (this.arrowPrev = this.scrollbar.parentNode.querySelector(
            "[data-scrollbar-arrow-prev]"
          )),
          this.scrollbar.hasAttribute("data-scrollbar") &&
            (this.init(), this.resize()),
          this.scrollbar.hasAttribute("data-scrollbar-slider") &&
            this.scrollToVisibleElement();
      }
    },
    iY = "[data-swatch-button]",
    i7 = "[data-swatch-link]",
    iG = "is-visible",
    iK = "no-events",
    iZ = "data-swatch-count",
    st = "data-tooltip",
    se = "data-variant-title",
    si = class extends HTMLElement {
      connectedCallback() {
        this.hasAttribute(st) && new ew(this);
      }
      constructor() {
        super();
      }
    },
    ss = class extends HTMLElement {
      connectedCallback() {
        (this.handle = this.getAttribute("data-swatch-handle")),
          (this.productItem = this.closest("[data-product-grid-item]")),
          (this.productInfo = this.closest("[data-product-information]")),
          (this.productImage = this.productItem.querySelector(
            "[data-product-image]"
          )),
          (this.template = document.querySelector(
            "[data-swatch-template]"
          ).innerHTML);
        let t = this.getAttribute("data-swatch-label").trim().toLowerCase();
        (function (t) {
          let e = `${window.theme.routes.root}products/${t}.js`;
          return window
            .fetch(e)
            .then((t) => t.json())
            .catch((t) => {
              console.error(t);
            });
        })(this.handle).then((e) => {
          (this.product = e),
            (this.colorOption = e.options.find(function (e) {
              return e.name.toLowerCase() === t || null;
            })),
            this.colorOption &&
              ((this.swatches = this.colorOption.values), this.init());
        });
      }
      init() {
        (this.innerHTML = ""),
          (this.count = 0),
          this.swatches.forEach((t) => {
            var e, i;
            let s = null,
              r = !1,
              o = "";
            for (let a of this.product.variants) {
              let n = a.options.includes(t);
              if ((!s && n && (s = a), n && a.featured_media)) {
                (o = a.featured_media.preview_image.src), (s = a);
                break;
              }
            }
            for (let l of this.product.variants)
              if (l.options.includes(t) && l.available) {
                r = !0;
                break;
              }
            if (s) {
              let h = document.createElement("div");
              h.innerHTML = this.template;
              let c = h.querySelector(iY),
                d = h.querySelector(i7),
                u = t.trim().toLowerCase().replaceAll(" ", "-"),
                p = s.title.replaceAll('"', "'");
              (c.style = `--animation-delay: ${(100 * this.count) / 1e3}s`),
                c.classList.add(`swatch-${u}`),
                (c.dataset.tooltip = t),
                (c.dataset.swatchVariant = s.id),
                (c.dataset.swatchVariantName = p),
                (c.dataset.swatchImage = o),
                (c.dataset.variant = s.id),
                c.style.setProperty("--swatch", `var(--${u})`),
                (d.href =
                  ((e = this.product.url),
                  (i = s.id),
                  /variant=/.test(e)
                    ? e.replace(/(variant=)[^&]+/, "$1" + i)
                    : /\?/.test(e)
                    ? e.concat("&variant=").concat(i)
                    : e.concat("?variant=").concat(i))),
                (d.innerText = t),
                (d.dataset.swatch = t),
                (d.disabled = !r),
                (this.innerHTML += h.innerHTML),
                this.count++;
            }
          }),
          (this.swatchCount = this.productInfo.querySelector(`[${iZ}]`)),
          (this.swatchElements = this.querySelectorAll(i7)),
          (this.swatchForm = this.productInfo.querySelector(
            "[data-grid-swatch-form]"
          )),
          (this.hideSwatchesTimer = 0),
          this.swatchCount.hasAttribute(iZ) &&
            ((this.swatchCount.innerText = `${this.count} ${
              this.count > 1 ? theme.strings.otherColor : theme.strings.oneColor
            }`),
            this.swatchCount.addEventListener("mouseenter", () => {
              this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
                this.productInfo.classList.add(iK),
                this.swatchForm.classList.add(iG);
            }),
            this.productInfo.addEventListener("mouseleave", () => {
              this.hideSwatchesTimer = setTimeout(() => {
                this.productInfo.classList.remove(iK),
                  this.swatchForm.classList.remove(iG);
              }, 100);
            })),
          this.hasAttribute("data-scrollbar") && new iJ(this),
          this.showDeferredImage(),
          this.bindSwatchButtonEvents();
      }
      showDeferredImage() {
        let t = this.productItem.querySelectorAll(`[${se}]`);
        t.length &&
          this.productItem.addEventListener(
            "mouseenter",
            () => {
              t.forEach((t) => {
                t.classList.remove("hidden");
              });
            },
            { once: !0 }
          );
      }
      bindSwatchButtonEvents() {
        var t;
        null === (t = this.querySelectorAll(iY)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.addEventListener("mouseenter", this.showVariantImageEvent),
              t.hasAttribute(st) && new ew(t);
          }),
          this.productItem.addEventListener(
            "mouseleave",
            this.productItemMouseLeaveEvent
          );
      }
      showVariantImage(t) {
        var e;
        let i =
            null === (e = t.target.getAttribute("data-swatch-variant-name")) ||
            void 0 === e
              ? void 0
              : e.replaceAll('"', "'"),
          s = this.productImage.querySelectorAll(`[${se}]`),
          r = this.productImage.querySelector(`[${se}="${i}"]`);
        null == s ||
          s.forEach((t) => {
            t.classList.remove(iG);
          }),
          null == r || r.classList.add(iG);
      }
      hideVariantImages() {
        var t;
        null === (t = this.productImage.querySelectorAll(`[${se}].${iG}`)) ||
          void 0 === t ||
          t.forEach((t) => {
            t.classList.remove(iG);
          });
      }
      constructor() {
        super(),
          (this.productItemMouseLeaveEvent = () => this.hideVariantImages()),
          (this.showVariantImageEvent = (t) => this.showVariantImage(t));
      }
    },
    sr = {
      productCutline: "[data-product-cutline]",
      productLink: "[data-product-link]",
      productGridItem: "[data-product-grid-item]",
      productInfo: "[data-product-information]",
      productImage: "[data-product-image-default]",
      productImageSibling: "[data-product-image-sibling]",
      productPrice: "[data-product-price]",
      siblingsInnerHolder: "[data-sibling-inner]",
      siblingCount: "[data-sibling-count]",
      siblingHolder: "[data-sibling-holder]",
      siblingFieldset: "[data-sibling-fieldset]",
      siblingLink: "[data-sibling-link]",
      tooltip: "[data-tooltip]",
    },
    so = "is-visible",
    sa = "is-fade",
    sn = "no-events",
    sl = "data-sibling-cutline",
    sh = "data-sibling-image",
    sc = "data-sibling-link",
    sd = "data-sibling-price",
    su = "data-product-link",
    sp = class extends HTMLElement {
      connectedCallback() {
        (this.product = this.closest(sr.productGridItem)),
          (this.siblingScrollbar = this.querySelector(sr.siblingsInnerHolder)),
          (this.siblingCount = this.querySelector(sr.siblingCount)),
          (this.siblingFieldset = this.querySelector(sr.siblingFieldset)),
          (this.siblingLinks = this.querySelectorAll(sr.siblingLink)),
          (this.productInfo = this.closest(sr.productInfo)),
          (this.productLink = this.closest(sr.link)),
          (this.hideSwatchesTimer = 0),
          this.initScrollbar(),
          this.siblingCount &&
            this.siblingFieldset &&
            this.productInfo &&
            (this.siblingCount.addEventListener("mouseenter", () =>
              this.showSiblings()
            ),
            this.productInfo.addEventListener("mouseleave", () =>
              this.hideSiblings()
            )),
          this.siblingLinks.length &&
            new (class {
              init() {
                this.cacheDefaultValues(),
                  this.product.addEventListener("mouseleave", () =>
                    this.resetProductValues()
                  ),
                  this.swatches.forEach((t) => {
                    t.addEventListener("mouseenter", (t) =>
                      this.showSibling(t)
                    );
                  }),
                  this.productLinks.length &&
                    this.swatches.forEach((t) => {
                      t.addEventListener("click", () => {
                        this.productLinks[0].click();
                      });
                    });
              }
              cacheDefaultValues() {
                (this.productLinkValue = this.productLinks[0].hasAttribute(su)
                  ? this.productLinks[0].getAttribute(su)
                  : ""),
                  (this.productPriceValue = this.productPrice.innerHTML),
                  this.productCutline &&
                    (this.productCutlineValue = this.productCutline.innerHTML);
              }
              resetProductValues() {
                this.product.classList.remove("is-active"),
                  this.productLinkValue &&
                    this.productLinks.forEach((t) => {
                      t.href = this.productLinkValue;
                    }),
                  this.productPrice &&
                    (this.productPrice.innerHTML = this.productPriceValue),
                  this.productCutline &&
                    this.productCutline &&
                    (this.productCutline.innerHTML = this.productCutlineValue),
                  this.hideSiblingImage();
              }
              showSibling(t) {
                let e = t.target,
                  i = e.hasAttribute(sc) ? e.getAttribute(sc) : "",
                  s = e.hasAttribute(sd) ? e.getAttribute(sd) : "",
                  r = e.hasAttribute(sl) ? e.getAttribute(sl) : "",
                  o = e.hasAttribute(sh) ? e.getAttribute(sh) : "";
                i &&
                  this.productLinks.forEach((t) => {
                    t.href = i;
                  }),
                  s && (this.productPrice.innerHTML = s),
                  (this.productCutline.innerHTML = r || ""),
                  o && this.showSiblingImage(o);
              }
              showSiblingImage(t) {
                if (!this.productImageSibling) return;
                let e = window.devicePixelRatio || 1,
                  i = this.productImage.offsetWidth * e,
                  s = a.getSizedImageUrl(t, `${180 * Math.ceil(i / 180)}x`),
                  r = this.productImageSibling.querySelector(`[src="${s}"]`),
                  o = () => {
                    this.productImageSibling.classList.add(so),
                      this.productImageSibling
                        .querySelector(`[src="${s}"]`)
                        .classList.add(sa);
                  },
                  n = () => {
                    this.productImageSibling
                      .querySelectorAll("img")
                      .forEach((t) => {
                        t.classList.remove(sa);
                      }),
                      requestAnimationFrame(o);
                  };
                if (r) n();
                else {
                  let l = document.createElement("img");
                  (l.src = s),
                    this.productCutline &&
                      (l.alt = this.productCutline.innerText),
                    l.addEventListener("load", () => {
                      this.productImageSibling.append(l), n();
                    });
                }
              }
              hideSiblingImage() {
                this.productImageSibling &&
                  (this.productImageSibling.classList.remove(so),
                  this.productImageSibling
                    .querySelectorAll("img")
                    .forEach((t) => {
                      t.classList.remove(sa);
                    }));
              }
              constructor(t, e) {
                (this.swatches = t),
                  (this.product = e),
                  (this.productLinks = this.product.querySelectorAll(
                    sr.productLink
                  )),
                  (this.productCutline = this.product.querySelector(
                    sr.productCutline
                  )),
                  (this.productPrice = this.product.querySelector(
                    sr.productPrice
                  )),
                  (this.productImage = this.product.querySelector(
                    sr.productImage
                  )),
                  (this.productImageSibling = this.product.querySelector(
                    sr.productImageSibling
                  )),
                  this.init();
              }
            })(this.siblingLinks, this.product),
          this.querySelectorAll(sr.tooltip).forEach((t) => {
            new ew(t);
          });
      }
      showSiblings() {
        this.hideSwatchesTimer && clearTimeout(this.hideSwatchesTimer),
          this.productLink && this.productLink.classList.add(sn),
          this.siblingFieldset.classList.add(so);
      }
      hideSiblings() {
        this.hideSwatchesTimer = setTimeout(() => {
          this.productLink && this.productLink.classList.remove(sn),
            this.siblingFieldset.classList.remove(so);
        }, 100);
      }
      initScrollbar() {
        this.siblingScrollbar && new iJ(this.siblingScrollbar);
      }
      constructor() {
        super();
      }
    },
    sm = "data-tab",
    sg = "data-tab-index",
    sf = "[data-tab]",
    sv = ".tab-content",
    sy = "current",
    sb = "hidden",
    sS = "aos-animate",
    sE = "aos-no-transition",
    sL = {},
    sw = {
      onLoad() {
        (sL[this.id] = []),
          this.container.querySelectorAll("[data-tabs-holder]").forEach((t) => {
            sL[this.id].push(
              new (class {
                init() {
                  let t = this.container.querySelectorAll(sf);
                  this.container.addEventListener("theme:tab:check", () =>
                    this.checkRecentTab()
                  ),
                    this.container.addEventListener("theme:tab:hide", () =>
                      this.hideRelatedTab()
                    ),
                    t.length &&
                      t.forEach((t) => {
                        let e = parseInt(t.getAttribute(sm)),
                          i = this.container.querySelector(`${sv}-${e}`);
                        t.addEventListener("click", () => {
                          this.tabChange(t, i);
                        }),
                          t.addEventListener("keyup", (e) => {
                            ("Space" === e.code || "Enter" === e.code) &&
                              this.body.classList.contains("is-focused") &&
                              this.tabChange(t, i);
                          });
                      });
                }
                tabChange(t, e) {
                  if (t.classList.contains(sy)) return;
                  let i = this.container.querySelector(`${sf}.${sy}`),
                    s = this.container.querySelector(`${sv}.${sy}`);
                  null == i || i.classList.remove(sy),
                    null == s || s.classList.remove(sy),
                    t.classList.add(sy),
                    e.classList.add(sy),
                    t.classList.contains(sb) && e.classList.add(sb),
                    this.accessibility.a11y.removeTrapFocus(),
                    this.container.dispatchEvent(
                      new CustomEvent("theme:tab:change", { bubbles: !0 })
                    ),
                    t.dispatchEvent(
                      new CustomEvent("theme:form:sticky", {
                        bubbles: !0,
                        detail: { element: "tab" },
                      })
                    ),
                    this.animateItems(e);
                }
                animateItems(t, e = !0) {
                  let i = t.querySelectorAll("[data-aos]");
                  i.length &&
                    i.forEach((t) => {
                      t.classList.remove(sS),
                        e &&
                          (t.classList.add(sE),
                          requestAnimationFrame(() => {
                            t.classList.remove(sE), t.classList.add(sS);
                          }));
                    });
                }
                initNativeScrollbar() {
                  this.scrollbarHolder.length &&
                    this.scrollbarHolder.forEach((t) => {
                      new iJ(t);
                    });
                }
                checkRecentTab() {
                  let t = this.container.querySelector(".tab-link__recent");
                  if (t) {
                    t.classList.remove(sb);
                    let e = parseInt(t.getAttribute(sm)),
                      i = this.container.querySelector(`${sv}[${sg}="${e}"]`);
                    i && (i.classList.remove(sb), this.animateItems(i, !1)),
                      this.initNativeScrollbar();
                  }
                }
                hideRelatedTab() {
                  let t = this.container.querySelector(
                    "[data-related-section]"
                  );
                  if (!t) return;
                  let e = t.closest(`${sv}.${sy}`);
                  if (!e) return;
                  let i = parseInt(e.getAttribute(sg)),
                    s = this.container.querySelectorAll(sf);
                  if (s.length > i) {
                    let r = s[i].nextSibling;
                    r &&
                      (s[i].classList.add(sb),
                      r.dispatchEvent(new Event("click")),
                      this.initNativeScrollbar());
                  }
                }
                onBlockSelect(t) {
                  let e = this.container.querySelector(
                    `.tab-link[data-block-id="${t.detail.blockId}"]`
                  );
                  e &&
                    (e.dispatchEvent(new Event("click")),
                    e.parentNode.scrollTo({
                      top: 0,
                      left: e.offsetLeft - e.clientWidth,
                      behavior: "smooth",
                    }));
                }
                constructor(t) {
                  (this.container = t),
                    (this.body = document.querySelector("body")),
                    (this.accessibility = window.accessibility),
                    this.container &&
                      ((this.scrollbarHolder =
                        this.container.querySelectorAll("[data-scrollbar]")),
                      this.init(),
                      this.initNativeScrollbar());
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        sL[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
    },
    sk = "data-media-id",
    s$ = "data-thumb-index",
    sA = ".is-active",
    sT = "data-type",
    sC = "is-active",
    sq = "is-dragging",
    sx = "is-selected",
    s_ = "media--hidden",
    sP = "aria-current",
    sH = "data-options",
    sB = {},
    s8 = class {
      init() {
        this.slideshow &&
          (this.tallLayout
            ? this.mobileSliderDisabled ||
              (this.initSliderMobile(),
              document.addEventListener(
                "theme:resize:width",
                this.initSliderMobileEvent
              ))
            : this.mobileSliderDisabled
            ? (this.initSliderDesktop(),
              document.addEventListener(
                "theme:resize:width",
                this.initSliderDesktopEvent
              ))
            : this.createSlider());
      }
      initSliderMobile() {
        L() ? this.createSlider() : this.destroySlider();
      }
      initSliderDesktop() {
        L() ? this.destroySlider() : this.createSlider();
      }
      destroySlider() {
        this.slideshow.classList.contains("flickity-enabled") &&
          this.flkty.destroy();
      }
      createSlider() {
        if (!this.slideshow || (this.mobileSliderDisabled && L())) return;
        let t = {
            autoPlay: !1,
            pageDots: !1,
            wrapAround: !0,
            ...this.customOptions,
          },
          e = this,
          i = this.slideshow.querySelectorAll(`[${sT}]`)[0],
          s = {
            ...t,
            on: {
              ready: function () {
                let t = this.element;
                t.addEventListener("keyup", (e) => {
                  if ("Enter" === e.code) {
                    let i = t.querySelector(`.${sx} [data-zoom-wrapper]`);
                    i &&
                      (i.dispatchEvent(new Event("click", { bubbles: !1 })),
                      (window.accessibility.lastElement = t));
                  }
                }),
                  e.sliderThumbs(this),
                  e.accessibilityActions(this);
              },
            },
          };
        if (((this.flkty = new o(this.slideshow, s)), this.flkty.resize(), i)) {
          let r = i.getAttribute(sT);
          ("model" !== r && "video" !== r && "external_video" !== r) ||
            ((this.flkty.options.draggable = !1), this.flkty.updateDraggable());
        }
        this.flkty.on("change", function (t) {
          let i = t;
          if (e.thumbSlider) {
            let s = e.thumbSlider.querySelector(sA),
              r = e.thumbSlider.querySelector(
                `[data-thumb-item] [${s$}="${t}"]`
              );
            if (s) {
              let o = s.querySelector(`[${s$}]`);
              (i = Array.from(s.parentElement.children).indexOf(s)),
                s.classList.remove(sC),
                o && o.setAttribute(sP, !1);
            }
            r && (r.parentElement.classList.add(sC), r.setAttribute(sP, !0)),
              e.scrollToThumb();
          }
          let a = this.cells[i].element,
            n = this.selectedElement;
          a.dispatchEvent(new CustomEvent("theme:media:hidden")),
            n.classList.remove(s_);
        }),
          this.flkty.on("settle", function () {
            let t = this.selectedElement,
              i = Array.prototype.filter.call(
                t.parentNode.children,
                function (e) {
                  return e !== t;
                }
              ),
              s = t.getAttribute(sT),
              r = document.body.classList.contains("is-focused");
            "model" === s || "video" === s || "external_video" === s
              ? ((e.flkty.options.draggable = !1), e.flkty.updateDraggable())
              : ((e.flkty.options.draggable = !0), e.flkty.updateDraggable()),
              r && t.dispatchEvent(new Event("focus")),
              i.length &&
                i.forEach((t) => {
                  t.classList.add(s_);
                }),
              t.dispatchEvent(new CustomEvent("theme:media:visible"));
            let o = t.querySelector("deferred-media");
            o &&
              !0 !== o.getAttribute("loaded") &&
              t
                .querySelector("[data-deferred-media-button]")
                .dispatchEvent(new Event("click", { bubbles: !1 })),
              e.accessibilityActions(this);
          }),
          this.flkty.on("dragStart", (t, e) => {
            t.target.classList.add(sq);
          }),
          this.flkty.on("dragEnd", (t, e) => {
            let i = this.flkty.element.querySelector(`.${sq}`);
            i && i.classList.remove(sq);
          });
      }
      accessibilityActions(t) {
        let e = t.slides;
        e.length &&
          e.forEach((t) => {
            let e = t.cells[0].element,
              i = e.querySelectorAll(
                "model-viewer, video, iframe, button, [href], input, [tabindex]"
              );
            e.classList.contains(sx)
              ? e.removeAttribute("tabindex")
              : e.setAttribute("tabindex", "-1"),
              i.length &&
                i.forEach((t) => {
                  e.classList.contains(sx)
                    ? t.removeAttribute("tabindex")
                    : t.setAttribute("tabindex", "-1");
                });
          });
      }
      scrollToThumb() {
        let t = this.thumbSlider;
        if (t) {
          let e = t.querySelector(sA);
          if (!e) return;
          let i = t.scrollTop,
            s = t.scrollLeft,
            r = t.offsetWidth,
            o = t.offsetHeight,
            a = e.offsetTop,
            n = e.offsetLeft,
            l = e.offsetWidth,
            h = e.offsetHeight,
            c = i > a,
            d = s > n,
            u = n + l > s + r,
            p = L();
          if (a + h > i + o || c || u || d) {
            let m = a - o + h,
              g = n - r + l;
            c && (m = a),
              u &&
                p &&
                (g += parseInt(window.getComputedStyle(t).paddingRight)),
              d &&
                ((g = n),
                p && (g -= parseInt(window.getComputedStyle(t).paddingLeft))),
              t.scrollTo({ top: m, left: g, behavior: "smooth" });
          }
        }
      }
      sliderThumbs(t) {
        this.thumbLinks.length &&
          this.thumbLinks.forEach((e) => {
            e.addEventListener("click", (t) => {
              t.preventDefault();
              let i = e.hasAttribute(s$) ? parseInt(e.getAttribute(s$)) : 0;
              this.flkty.select(i);
            }),
              e.addEventListener("keyup", (i) => {
                if ("Enter" === i.code) {
                  let s = e.getAttribute(sk),
                    r = t.element
                      .querySelector(`[${sk}="${s}"]`)
                      .querySelectorAll(
                        'model-viewer, video, iframe, button, [href], input, [tabindex]:not([tabindex="-1"])'
                      )[0];
                  r &&
                    (r.dispatchEvent(new Event("focus")),
                    r.dispatchEvent(new Event("select")));
                }
              });
          });
      }
      onUnload() {
        this.tallLayout
          ? this.mobileSliderDisabled ||
            document.removeEventListener(
              "theme:resize:width",
              this.initSliderMobileEvent
            )
          : this.mobileSliderDisabled &&
            document.removeEventListener(
              "theme:resize:width",
              this.initSliderDesktopEvent
            );
      }
      constructor(t, e = null) {
        (this.container = e || t.container),
          (this.tallLayout =
            "true" === this.container.getAttribute("data-tall-layout")),
          (this.slideshow = this.container.querySelector(
            "[data-product-slideshow]"
          )),
          (this.thumbSlider = this.container.querySelector(
            "[data-thumbs-slider]"
          )),
          (this.thumbLinks =
            this.container.querySelectorAll("[data-thumb-link]")),
          (this.mobileSliderDisabled =
            "true" ===
            this.container.getAttribute("data-slideshow-disabled-mobile")),
          (this.initSliderMobileEvent = () => this.initSliderMobile()),
          (this.initSliderDesktopEvent = () => this.initSliderDesktop()),
          this.slideshow &&
            this.slideshow.hasAttribute(sH) &&
            (this.customOptions = JSON.parse(
              decodeURIComponent(this.slideshow.getAttribute(sH))
            )),
          (this.flkty = null),
          this.init();
      }
    },
    sD = {
      added: "is-added",
      animated: "is-animated",
      disabled: "is-disabled",
      error: "has-error",
      loading: "is-loading",
      open: "is-open",
      overlayText: "product-item--overlay-text",
      visible: "is-visible",
      siblingLinkCurrent: "sibling__link--current",
      focused: "is-focused",
    },
    sM = "[data-animation]",
    sI = "[data-add-to-cart]",
    s9 = "[data-quick-add-modal]",
    sF = "closing",
    sO = "data-product-id",
    sR = class extends HTMLElement {
      connectedCallback() {
        this.modalButton &&
          this.modalButton.addEventListener(
            "click",
            this.modalButtonClickEvent
          ),
          this.buttonATC &&
            this.buttonATC.addEventListener("click", (t) => {
              t.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:cart:add", {
                    detail: { button: this.buttonATC },
                  })
                );
            }),
          this.quickAddHolder &&
            (this.quickAddHolder.addEventListener(
              "animationend",
              this.quickAddLoadingToggle
            ),
            this.errorHandler());
      }
      modalButtonClickEvent(t) {
        t.preventDefault();
        let e = this.modalButton.hasAttribute("data-sibling-swapper"),
          i = this.modalButton.classList.contains(sD.siblingLinkCurrent);
        i ||
          (this.modalButton.classList.add(sD.loading),
          (this.modalButton.disabled = !0),
          e &&
            !i &&
            ((this.currentModal = t.target.closest(s9)),
            this.currentModal.classList.add(sD.loading)),
          this.renderModal());
      }
      modalCreate(t) {
        let e = document.querySelector(`${s9}[${sO}="${this.productId}"]`);
        if (e) (this.modal = e), this.modalOpen();
        else {
          let i = this.quickAddHolder.querySelector(
            "[data-quick-add-modal-template]"
          );
          if (!i) return;
          let s = document.createElement("div");
          (s.innerHTML = i.innerHTML),
            document.body.appendChild(s.querySelector(s9)),
            i.remove(),
            (this.modal = document.querySelector(
              `${s9}[${sO}="${this.productId}"]`
            )),
            (this.modal.querySelector("[data-product-upsell-ajax]").innerHTML =
              new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector("[data-api-content]").innerHTML),
            this.modalCreatedCallback();
        }
      }
      modalOpen() {
        "function" == typeof this.modal.show && this.modal.show(),
          this.modal.setAttribute("open", !0),
          this.modal.removeAttribute("inert"),
          this.currentModal &&
            this.currentModal.dispatchEvent(
              new CustomEvent("theme:modal:close", { bubbles: !1 })
            ),
          (
            this.modal.querySelector("[autofocus]") ||
            this.modal.querySelector(
              'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
            )
          ).focus(),
          this.quickAddHolder.classList.add(sD.disabled),
          this.modalButton &&
            (this.modalButton.classList.remove(sD.loading),
            (this.modalButton.disabled = !1)),
          requestAnimationFrame(() => {
            this.modal.querySelectorAll(sM).forEach((t) => {
              t.classList.add(sD.animated);
            });
          }),
          document.dispatchEvent(
            new CustomEvent("theme:quick-add:open", { bubbles: !0 })
          ),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
          document.addEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded,
            { once: !0 }
          );
      }
      modalClose() {
        if (this.isAnimating) return;
        if (!this.modal.hasAttribute(sF))
          return this.modal.setAttribute(sF, ""), void (this.isAnimating = !0);
        "function" == typeof this.modal.close
          ? this.modal.close()
          : this.modal.removeAttribute("open"),
          this.modal.removeAttribute(sF),
          this.modal.setAttribute("inert", ""),
          this.modal.classList.remove(sD.loading),
          this.modalButton && (this.modalButton.disabled = !1),
          this.quickAddHolder &&
            this.quickAddHolder.classList.contains(sD.disabled) &&
            this.quickAddHolder.classList.remove(sD.disabled),
          this.resetAnimatedItems();
        let t = this.cartDrawer && this.cartDrawer.classList.contains(sD.open),
          e = document.querySelector("dialog[open]");
        t ||
          e ||
          document.dispatchEvent(
            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
          ),
          document.removeEventListener(
            "theme:product:added",
            this.modalCloseOnProductAdded
          );
      }
      modalEvents() {
        var t;
        null ===
          (t = this.modal.querySelector("[data-quick-add-modal-close]")) ||
          void 0 === t ||
          t.addEventListener("click", (t) => {
            t.preventDefault(), this.modalClose();
          }),
          this.modal.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.modalClose();
          }),
          this.modal.addEventListener("keydown", (t) => {
            "Escape" == t.code && (t.preventDefault(), this.modalClose());
          }),
          this.modal.addEventListener("theme:modal:close", () => {
            this.modalClose();
          }),
          this.modal.addEventListener("animationend", (t) => {
            t.target === this.modal &&
              ((this.isAnimating = !1),
              this.modal.hasAttribute(sF) &&
                (this.modalClose(),
                document.body.classList.contains(sD.focused) &&
                  this.buttonQuickAdd &&
                  (this.buttonQuickAdd.addEventListener(
                    "transitionend",
                    () => {
                      this.buttonQuickAdd.focus(),
                        this.buttonQuickAdd.classList.remove(sD.visible);
                    },
                    { once: !0 }
                  ),
                  this.buttonQuickAdd.classList.add(sD.visible))));
          });
      }
      modalCloseOnProductAdded() {
        this.resetQuickAddButtons(),
          this.modal && this.modal.hasAttribute("open") && this.modalClose();
      }
      quickAddLoadingToggle(t) {
        t.target == this.quickAddHolder &&
          this.quickAddHolder.classList.remove(sD.disabled);
      }
      errorHandler() {
        this.quickAddHolder.addEventListener("theme:cart:error", (t) => {
          let e = t.detail.holder,
            i = e.closest("[data-product-grid-item]");
          if (!i) return;
          let s = e.querySelector("[data-message-error]"),
            r = i.classList.contains(sD.overlayText),
            o = i.querySelector("[data-product-information]"),
            a = e.querySelector(sI);
          a &&
            (a.classList.remove(sD.added, sD.loading),
            e.classList.add(sD.error)),
            s && (s.innerText = t.detail.description),
            r && o.classList.add(sD.hidden),
            setTimeout(() => {
              this.resetQuickAddButtons(), r && o.classList.remove(sD.hidden);
            }, 3e3);
        });
      }
      resetQuickAddButtons() {
        this.quickAddHolder &&
          this.quickAddHolder.classList.remove(sD.visible, sD.error),
          this.buttonQuickAdd &&
            (this.buttonQuickAdd.classList.remove(sD.added),
            (this.buttonQuickAdd.disabled = !1));
      }
      renderModal() {
        this.modal
          ? this.modalOpen()
          : window
              .fetch(
                `${window.theme.routes.root}products/${this.handle}?section_id=api-product-upsell`
              )
              .then(this.upsellErrorsHandler)
              .then((t) => t.text())
              .then((t) => {
                this.modalCreate(t);
              });
      }
      modalCreatedCallback() {
        this.modalEvents(),
          this.modalOpen(),
          new s8(null, this.modal),
          B(this.modal);
      }
      upsellErrorsHandler(t) {
        return t.ok
          ? t
          : t.json().then(function (e) {
              throw new tb({
                status: t.statusText,
                headers: t.headers,
                json: e,
              });
            });
      }
      resetAnimatedItems() {
        var t;
        null === (t = this.modal) ||
          void 0 === t ||
          t.querySelectorAll(sM).forEach((t) => {
            t.classList.remove(sD.animated);
          });
      }
      constructor() {
        var t;
        super(),
          (this.container = this),
          (this.quickAddHolder = this.container.querySelector(
            "[data-quick-add-holder]"
          )),
          this.quickAddHolder &&
            ((this.modal = null),
            (this.currentModal = null),
            (this.productId = this.quickAddHolder.getAttribute(
              "data-quick-add-holder"
            )),
            (this.modalButton = this.quickAddHolder.querySelector(
              "[data-quick-add-modal-handle]"
            )),
            (this.handle =
              null === (t = this.modalButton) || void 0 === t
                ? void 0
                : t.getAttribute("data-quick-add-modal-handle")),
            (this.cartDrawer = document.querySelector("[data-cart-drawer]")),
            (this.buttonQuickAdd = this.quickAddHolder.querySelector(
              "[data-quick-add-btn]"
            )),
            (this.buttonATC = this.quickAddHolder.querySelector(sI)),
            (this.button = this.modalButton || this.buttonATC),
            (this.modalClose = this.modalClose.bind(this)),
            (this.modalCloseOnProductAdded =
              this.modalCloseOnProductAdded.bind(this)),
            (this.isAnimating = !1),
            (this.modalButtonClickEvent =
              this.modalButtonClickEvent.bind(this)),
            (this.quickAddLoadingToggle =
              this.quickAddLoadingToggle.bind(this)));
      }
    };
  eu("product-grid", [eI, sw]),
    customElements.get("quick-add-product") ||
      customElements.define("quick-add-product", sR),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", si),
    customElements.get("grid-swatch") ||
      customElements.define("grid-swatch", ss),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", sp);
  let sz = (t, e) => {
      let {
          el: i,
          elStyle: s,
          elHeight: r,
          rowsLimit: o,
          rowsWrapped: a,
          options: n,
        } = t,
        l = t.buffer,
        h = l;
      if (a === o + 1) return { ...t };
      let c = l,
        d = a,
        u = r;
      return (
        (i.innerHTML = h =
          l.length
            ? `${l}${n.delimiter}${e}${n.replaceStr}`
            : `${e}${n.replaceStr}`),
        parseFloat(s.height) > parseFloat(r) &&
        (d++, (u = s.height), d === o + 1)
          ? ((i.innerHTML = h =
              "." === c[c.length - 1] && "..." === n.replaceStr
                ? `${c}..`
                : `${c}${n.replaceStr}`),
            { ...t, elHeight: u, rowsWrapped: d })
          : ((i.innerHTML = h = c.length ? `${c}${n.delimiter}${e}` : `${e}`),
            { ...t, buffer: h, elHeight: u, rowsWrapped: d })
      );
    },
    sN = "complementary-products",
    sW = "data-url",
    sU = class extends HTMLElement {
      connectedCallback() {
        new IntersectionObserver(
          ((t, e) => {
            t[0].isIntersecting &&
              (e.unobserve(this),
              this.hasAttribute(sW) &&
                "" !== this.getAttribute(sW) &&
                fetch(this.getAttribute(sW))
                  .then((t) => t.text())
                  .then((t) => {
                    let e = document.createElement("div");
                    e.innerHTML = t;
                    let i = e.querySelector(sN);
                    i &&
                      i.innerHTML.trim().length &&
                      (this.innerHTML = i.innerHTML),
                      e.querySelector(`${sN} quick-add-product`) &&
                        this.classList.add("is-loaded");
                  })
                  .catch((t) => {
                    console.error(t);
                  }));
          }).bind(this),
          { rootMargin: "0px 0px 400px 0px" }
        ).observe(this);
      }
      constructor() {
        super();
      }
    },
    s0 = class extends HTMLElement {
      connectedCallback() {
        this.fieldCheckbox &&
          (this.fieldCheckbox.addEventListener("change", this.onChangeEvent),
          this.form &&
            this.form.addEventListener("theme:product:add", () => {
              (this.fieldCheckbox.checked = !1),
                this.fieldCheckbox.dispatchEvent(new Event("change"));
            }));
      }
      clearInputValues() {
        this.fields.length &&
          this.fields.forEach((t) => {
            t.value = "";
          });
      }
      onChange(t) {
        (this.fieldEmail.required = Boolean(t.target.checked)),
          t.target.checked || this.clearInputValues();
      }
      disconnectedCallback() {
        this.fieldCheckbox.removeEventListener("change", this.onChangeEvent);
      }
      constructor() {
        super(),
          (this.fieldCheckbox = this.querySelector('input[type="checkbox"]')),
          (this.fieldEmail = this.querySelector('input[type="email"]')),
          (this.fields = this.querySelectorAll(
            'input:not([type="checkbox"]):not([type="hidden"]), textarea'
          )),
          (this.form = this.closest("[data-form-wrapper]")),
          (this.onChangeEvent = (t) => this.onChange(t));
      }
    },
    sV = "[data-form-wrapper]",
    sj = "[data-header-height]",
    s3 = "is-sticky";
  window.theme.variables = { productPageSticky: !1 };
  let s1 = {},
    s2 = "data-section-type",
    sX = "is-visible",
    s4 = class extends HTMLElement {
      init() {
        navigator.share
          ? this.shareButton.addEventListener("click", () => {
              navigator.share({ url: this.urlToShare, title: document.title });
            })
          : this.shareButton.addEventListener(
              "click",
              this.copyToClipboard.bind(this)
            );
      }
      updateShareLink() {
        "product" == this.container.getAttribute(s2) &&
          this.container.addEventListener("theme:variant:change", (t) => {
            t.detail.variant &&
              (this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${
                t.detail.variant.id
              }`);
          });
      }
      copyToClipboard() {
        navigator.clipboard.writeText(this.urlToShare).then(() => {
          this.shareMessage.classList.add(sX);
          let t = () => {
            this.shareMessage.classList.remove(sX),
              this.shareMessage.removeEventListener("animationend", t);
          };
          this.shareMessage.addEventListener("animationend", t);
        });
      }
      constructor() {
        super(),
          (this.container = this.closest(`[${s2}]`)),
          (this.shareButton = this.querySelector("[data-share-button]")),
          (this.shareMessage = this.querySelector("[data-share-message]")),
          (this.urlToShare = this.shareButton.dataset.shareUrl
            ? this.shareButton.dataset.shareUrl
            : document.location.href),
          this.init(),
          this.updateShareLink();
      }
    },
    sQ = "data-option-position",
    s5 = "sold-out",
    s6 = "unavailable",
    sJ = "sale",
    sY = "[data-add-to-cart]",
    s7 = "[data-price-wrapper]",
    sG = "[data-product-unit]",
    sK = "data-group-toggle",
    sZ = 'input[name="id"]',
    rt = "hidden",
    re = "variant--soldout",
    ri = "variant--unavailable",
    rs = "product__price--sale",
    rr = "count-is-low",
    ro = "count-is-in",
    ra = "count-is-out",
    rn = "count-is-unavailable",
    rl = class extends HTMLElement {
      connectedCallback() {
        if (
          (this.cartAddEvents(),
          (this.container =
            this.closest("[data-section-type]") ||
            this.closest("[data-quick-add-modal]")),
          !this.container)
        )
          return;
        if (
          ((this.sectionId = this.container.dataset.sectionId),
          (this.tallLayout =
            "true" === this.container.getAttribute("data-tall-layout")),
          (this.product = this.container.querySelector("[data-product]")),
          (this.productForm = this.container.querySelector(
            "[data-product-form]"
          )),
          (this.installmentForm = this.container.querySelector(
            "[data-product-form-installment]"
          )),
          (this.sellout = null),
          (this.priceOffWrap =
            this.container.querySelector("[data-price-off]")),
          (this.priceOffAmount = this.container.querySelector(
            "[data-price-off-amount]"
          )),
          (this.priceOffType = this.container.querySelector(
            "[data-price-off-type]"
          )),
          (this.planDescription = this.container.querySelector(
            "[data-plan-description]"
          )),
          (this.remainingWrapper = this.container.querySelector(
            "[data-remaining-wrapper]"
          )),
          this.remainingWrapper)
        ) {
          let t = this.container.querySelector("[data-remaining-max]");
          t &&
            ((this.remainingMaxInt = parseInt(
              t.getAttribute("data-remaining-max"),
              10
            )),
            (this.remainingCount = this.container.querySelector(
              "[data-remaining-count]"
            )),
            (this.remainingJSONWrapper = this.container.querySelector(
              "[data-product-remaining-json]"
            )),
            (this.remainingJSON = null),
            this.remainingJSONWrapper &&
            "" !== this.remainingJSONWrapper.innerHTML
              ? (this.remainingJSON = JSON.parse(
                  this.remainingJSONWrapper.innerHTML
                ))
              : console.warn("Missing product quantity JSON"));
        }
        (this.enableHistoryState =
          "true" === this.container.getAttribute("data-enable-history-state")),
          (this.hasUnitPricing = this.container.querySelector(sG)),
          (this.subSelectors = this.container.querySelector(
            "[data-subscription-selectors]"
          )),
          (this.subPrices = this.container.querySelector(
            "[data-subscription-watch-price]"
          )),
          (this.isPreOrder = this.container.querySelector(
            "[data-product-preorder]"
          ));
        let e = null,
          i = this.container.querySelector("[data-product-json]");
        i && (e = i.innerHTML),
          e
            ? ((this.productJSON = JSON.parse(e)),
              this.linkForm(),
              (this.sellout = new (class {
                init() {
                  this.update();
                }
                update() {
                  this.getCurrentState(),
                    this.optionElements.forEach((t) => {
                      let e = t.closest(`[${sQ}]`);
                      if (!e) return;
                      let i = t.value || t.getAttribute("data-value"),
                        s = e.getAttribute(sQ),
                        r = parseInt(s, 10) - 1,
                        o = t.closest("[data-popout]"),
                        a = [...this.selections];
                      a[r] = i;
                      let n = this.productJSON.variants.find((t) => {
                        let e = !0;
                        for (let i = 0; i < a.length; i++)
                          t.options[i] !== a[i] && (e = !1);
                        return e;
                      });
                      t.classList.remove(s5, s6),
                        t.parentNode.classList.remove(sJ),
                        o && o.classList.remove(s5, s6, sJ),
                        void 0 === n
                          ? (t.classList.add(s6), o && o.classList.add(s6))
                          : n &&
                            !1 === n.available &&
                            (t.classList.add(s5), o && o.classList.add(s5)),
                        n &&
                          n.compare_at_price > n.price &&
                          theme.settings.variantOnSale &&
                          t.parentNode.classList.add(sJ);
                    });
                }
                getCurrentState() {
                  this.selections = [];
                  let t = this.container.querySelectorAll(
                    '[name^="options"]:checked, [name^="options"][type="hidden"]'
                  );
                  t.length &&
                    t.forEach((t) => {
                      let e = t.value;
                      e && "" !== e && this.selections.push(e);
                    });
                }
                constructor(t, e) {
                  (this.container = t),
                    (this.productJSON = e),
                    (this.optionElements = this.container.querySelectorAll(
                      '[name^="options"], [data-popout-option]'
                    )),
                    this.productJSON &&
                      this.optionElements.length &&
                      this.init();
                }
              })(this.container, this.productJSON)))
            : console.error("Missing product JSON");
      }
      cartAddEvents() {
        (this.buttonATC = this.querySelector(sY)),
          this.buttonATC &&
            this.buttonATC.addEventListener("click", (t) => {
              t.preventDefault(),
                document.dispatchEvent(
                  new CustomEvent("theme:cart:add", {
                    detail: { button: this.buttonATC },
                    bubbles: !1,
                  })
                );
            });
      }
      destroy() {
        this.productForm.destroy();
      }
      linkForm() {
        (this.productForm = new (class {
          destroy() {
            this._listeners.removeAll();
          }
          options() {
            return this._serializeInputValues(this.optionInputs, function (t) {
              return (
                (t.name = /(?:^(options\[))(.*?)(?:\])/.exec(t.name)[2]), t
              );
            });
          }
          variant() {
            var t, e, i, s, r, o, a, n;
            let l = this.options();
            return l.length
              ? ((t = this.product),
                (e = l),
                i4(t),
                (o =
                  ((i = t),
                  (s = e),
                  i4(i),
                  (function (t) {
                    if (!Array.isArray(t))
                      throw TypeError(t + " is not an array.");
                    if (0 === t.length) throw Error(t + " is empty.");
                    if (!t[0].hasOwnProperty("name"))
                      throw Error(t[0] + "does not contain name key.");
                    if ("string" != typeof t[0].name)
                      throw TypeError(
                        "Invalid value type passed for name of option " +
                          t[0].name +
                          ". Value should be string."
                      );
                  })(s),
                  (r = []),
                  s.forEach(function (t) {
                    for (var e = 0; e < i.options.length; e++)
                      if (
                        (i.options[e].name || i.options[e]).toLowerCase() ===
                        t.name.toLowerCase()
                      ) {
                        r[e] = t.value;
                        break;
                      }
                  }),
                  r)),
                (a = t),
                (n = o),
                i4(a),
                (function (t) {
                  if (Array.isArray(t) && "object" == typeof t[0])
                    throw Error(t + "is not a valid array of options.");
                })(n),
                a.variants.filter(function (t) {
                  return n.every(function (e, i) {
                    return t.options[i] === e;
                  });
                })[0] || null)
              : this.product.variants[0];
          }
          plan(t) {
            let e = { allocation: null, group: null, detail: null },
              i = this.element.querySelector(`${iQ}:checked`);
            if (!i) return null;
            let s = i.value,
              r = s && "" !== s ? s : null;
            return (
              r &&
                t &&
                (e.allocation = t.selling_plan_allocations.find(function (t) {
                  return t.selling_plan_id.toString() === r.toString();
                })),
              e.allocation &&
                (e.group = this.product.selling_plan_groups.find(function (t) {
                  return (
                    t.id.toString() ===
                    e.allocation.selling_plan_group_id.toString()
                  );
                })),
              e.group &&
                (e.detail = e.group.selling_plans.find(function (t) {
                  return t.id.toString() === r.toString();
                })),
              e && e.allocation && e.detail && e.allocation ? e : null
            );
          }
          properties() {
            return this._serializeInputValues(
              this.propertyInputs,
              function (t) {
                return (
                  (t.name = /(?:^(properties\[))(.*?)(?:\])/.exec(t.name)[2]), t
                );
              }
            );
          }
          quantity() {
            return this.quantityInputs[0]
              ? Number.parseInt(this.quantityInputs[0].value, 10)
              : 1;
          }
          getFormState() {
            let t = this.variant();
            return {
              options: this.options(),
              variant: t,
              properties: this.properties(),
              quantity: this.quantity(),
              plan: this.plan(t),
            };
          }
          _setIdInputValue(t) {
            t && t.id
              ? (this.variantElement.value = t.id.toString())
              : (this.variantElement.value = ""),
              this.variantElement.dispatchEvent(new Event("change"));
          }
          _onSubmit(t, e) {
            (e.dataset = this.getFormState()),
              t.onFormSubmit && t.onFormSubmit(e);
          }
          _onOptionChange(t) {
            this._setIdInputValue(t.dataset.variant);
          }
          _onFormEvent(t) {
            return void 0 === t
              ? Function.prototype.bind()
              : function (e) {
                  (e.dataset = this.getFormState()),
                    this._setIdInputValue(e.dataset.variant),
                    t(e);
                }.bind(this);
          }
          _initInputs(t, e) {
            return Array.prototype.slice
              .call(this.element.querySelectorAll(t))
              .map(
                function (t) {
                  return (
                    this._listeners.add(t, "change", this._onFormEvent(e)), t
                  );
                }.bind(this)
              );
          }
          _serializeInputValues(t, e) {
            return t.reduce(function (t, i) {
              return (
                (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                  t.push(e({ name: i.name, value: i.value })),
                t
              );
            }, []);
          }
          _validateProductObject(t) {
            if ("object" != typeof t) throw TypeError(t + " is not an object.");
            if (void 0 === t.variants[0].options)
              throw TypeError(
                "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
              );
            return t;
          }
          constructor(t, e, i) {
            (this.element = t),
              (this.product = this._validateProductObject(e)),
              (this.variantElement = this.element.querySelector('[name="id"]')),
              (i = i || {}),
              (this._listeners = new iX()),
              this._listeners.add(
                this.element,
                "submit",
                this._onSubmit.bind(this, i)
              ),
              (this.optionInputs = this._initInputs(
                '[name^="options"]',
                i.onOptionChange
              )),
              (this.planInputs = this._initInputs(iQ, i.onPlanChange)),
              (this.quantityInputs = this._initInputs(
                '[name="quantity"]',
                i.onQuantityChange
              )),
              (this.propertyInputs = this._initInputs(
                '[name^="properties"]',
                i.onPropertyChange
              ));
          }
        })(this.container, this.productJSON, {
          onOptionChange: this.onOptionChange.bind(this),
          onPlanChange: this.onPlanChange.bind(this),
        })),
          this.pushState(this.productForm.getFormState(), !0),
          this.subsToggleListeners();
      }
      onOptionChange(t) {
        this.pushState(t.dataset), this.updateProductImage(t);
      }
      onPlanChange(t) {
        this.subPrices && this.pushState(t.dataset);
      }
      pushState(t, e = !1) {
        var i;
        (this.productState = this.setProductState(t)),
          this.updateAddToCartState(t),
          this.updateProductPrices(t),
          this.updateSaleText(t),
          this.updateSubscriptionText(t),
          this.updateRemaining(t),
          this.updateLegend(t),
          this.fireHookEvent(t),
          null === (i = this.sellout) || void 0 === i || i.update(t),
          this.enableHistoryState && !e && this.updateHistoryState(t);
      }
      updateAddToCartState(t) {
        let e = t.variant,
          i = theme.strings.addToCart,
          s = this.container.querySelectorAll(s7),
          r = this.container.querySelectorAll(sY),
          o = this.container.querySelectorAll("[data-add-to-cart-text]"),
          a = this.container.querySelectorAll("[data-form-wrapper]");
        if (this.installmentForm && e) {
          let n = this.installmentForm.querySelector(sZ);
          (n.value = e.id),
            n.dispatchEvent(new Event("change", { bubbles: !0 }));
        }
        this.isPreOrder && (i = theme.strings.preOrder),
          s.length &&
            e &&
            s.forEach((t) => {
              t.classList.remove(rt);
            }),
          r.length &&
            r.forEach((t) => {
              t.hasAttribute("data-quick-add-btn") ||
                (e && e.available ? (t.disabled = !1) : (t.disabled = !0));
            }),
          o.length &&
            o.forEach((t) => {
              e
                ? e.available
                  ? (t.innerHTML = i)
                  : (t.innerHTML = theme.strings.soldOut)
                : (t.innerHTML = theme.strings.unavailable);
            }),
          a.length &&
            a.forEach((t) => {
              if (e) {
                e.available
                  ? t.classList.remove(re, ri)
                  : (t.classList.add(re), t.classList.remove(ri));
                let i = t.querySelector("[data-product-select]");
                i && (i.value = e.id);
                let s = t.querySelector(`${sZ}[form]`);
                s && ((s.value = e.id), s.dispatchEvent(new Event("change")));
              } else t.classList.add(ri), t.classList.remove(re);
            });
      }
      updateHistoryState(t) {
        let e = t.variant,
          i = t.plan,
          s = window.location.href;
        if (e && s.includes("/product")) {
          let r = new window.URL(s),
            o = r.searchParams;
          o.set("variant", e.id),
            i && i.detail && i.detail.id && this.productState.hasPlan
              ? o.set("selling_plan", i.detail.id)
              : o.delete("selling_plan"),
            (r.search = o.toString());
          let a = r.toString();
          window.history.replaceState({ path: a }, "", a);
        }
      }
      updateRemaining(t) {
        var e;
        let i = t.variant;
        if (
          (null === (e = this.remainingWrapper) ||
            void 0 === e ||
            e.classList.remove(ro, ra, rn, rr),
          i && this.remainingWrapper && this.remainingJSON)
        ) {
          let s = this.remainingJSON[i.id];
          ("out" === s || s < 1) && this.remainingWrapper.classList.add(ra),
            ("in" === s || s >= this.remainingMaxInt) &&
              this.remainingWrapper.classList.add(ro),
            ("low" === s || (s > 0 && s < this.remainingMaxInt)) &&
              (this.remainingWrapper.classList.add(rr),
              this.remainingCount && (this.remainingCount.innerHTML = s));
        } else
          !i &&
            this.remainingWrapper &&
            this.remainingWrapper.classList.add(rn);
      }
      getBaseUnit(t) {
        return 1 === t.unit_price_measurement.reference_value
          ? t.unit_price_measurement.reference_unit
          : t.unit_price_measurement.reference_value +
              t.unit_price_measurement.reference_unit;
      }
      subsToggleListeners() {
        this.container.querySelectorAll("[data-toggles-group]").forEach((t) => {
          t.addEventListener(
            "change",
            function (t) {
              let e = t.target.value.toString(),
                i = this.container.querySelector(`[${sK}="${e}"]`),
                s = this.container.querySelectorAll(`[${sK}]`);
              if (i) {
                i.classList.remove(rt);
                let r = i.querySelector('[name="selling_plan"]');
                (r.checked = !0), r.dispatchEvent(new Event("change"));
              }
              s.forEach((t) => {
                t !== i &&
                  (t.classList.add(rt),
                  t.querySelectorAll('[name="selling_plan"]').forEach((t) => {
                    (t.checked = !1), t.dispatchEvent(new Event("change"));
                  }));
              });
            }.bind(this)
          );
        });
      }
      updateSaleText(t) {
        this.productState.planSale
          ? this.updateSaleTextSubscription(t)
          : this.productState.onSale
          ? this.updateSaleTextStandard(t)
          : this.priceOffWrap && this.priceOffWrap.classList.add(rt);
      }
      updateSaleTextStandard(t) {
        if (
          (this.priceOffType &&
            (this.priceOffType.innerHTML = window.theme.strings.sale || "sale"),
          this.priceOffAmount && this.priceOffWrap)
        ) {
          let e = t.variant,
            i = (e.compare_at_price - e.price) / e.compare_at_price;
          (this.priceOffAmount.innerHTML = `${Math.floor(100 * i)}%`),
            this.priceOffWrap.classList.remove(rt);
        }
      }
      updateSubscriptionText(t) {
        t.plan && this.planDescription
          ? ((this.planDescription.innerHTML = t.plan.detail.description),
            this.planDescription.classList.remove(rt))
          : this.planDescription && this.planDescription.classList.add(rt);
      }
      updateSaleTextSubscription(t) {
        if (
          (this.priceOffType &&
            (this.priceOffType.innerHTML =
              window.theme.strings.subscription || "subscripton"),
          this.priceOffAmount && this.priceOffWrap)
        ) {
          let e = t.plan.detail.price_adjustments[0],
            s = e.value;
          e && "percentage" === e.value_type
            ? (this.priceOffAmount.innerHTML = `${s}%`)
            : (this.priceOffAmount.innerHTML = i.formatMoney(
                s,
                theme.moneyFormat
              )),
            this.priceOffWrap.classList.remove(rt);
        }
      }
      updateProductPrices(t) {
        let e = t.variant,
          s = t.plan;
        this.container.querySelectorAll(s7).forEach((t) => {
          let r = t.querySelector("[data-compare-price]"),
            o = t.querySelector("[data-product-price]"),
            a = t.querySelector("[data-compare-text]"),
            n = "",
            l = "";
          this.productState.available &&
            ((n = e.compare_at_price), (l = e.price)),
            this.productState.hasPlan && (l = s.allocation.price),
            this.productState.planSale &&
              ((n = s.allocation.compare_at_price), (l = s.allocation.price)),
            r &&
              (this.productState.onSale || this.productState.planSale
                ? (r.classList.remove(rt),
                  a.classList.remove(rt),
                  o.classList.add(rs))
                : (r.classList.add(rt),
                  a.classList.add(rt),
                  o.classList.remove(rs)),
              (r.innerHTML = i.formatMoney(n, theme.moneyFormat))),
            (o.innerHTML =
              0 === l
                ? window.theme.strings.free
                : i.formatMoney(l, theme.moneyFormat));
        }),
          this.hasUnitPricing && this.updateProductUnits(t);
      }
      updateProductUnits(t) {
        let e = t.variant,
          s = t.plan,
          r = null;
        if (
          (e && e.unit_price && (r = e.unit_price),
          s &&
            s.allocation &&
            s.allocation.unit_price &&
            (r = s.allocation.unit_price),
          r)
        ) {
          let o = this.getBaseUnit(e),
            a = i.formatMoney(r, theme.moneyFormat);
          (this.container.querySelector("[data-product-unit-price]").innerHTML =
            a),
            (this.container.querySelector("[data-product-base]").innerHTML = o),
            tg(this.container.querySelector(sG));
        } else tv(this.container.querySelector(sG));
      }
      fireHookEvent(t) {
        let e = t.variant;
        this.container.dispatchEvent(
          new CustomEvent("theme:variant:change", {
            detail: { variant: e },
            bubbles: !0,
          })
        );
      }
      setProductState(t) {
        let e = t.variant,
          i = t.plan,
          s = {
            available: !0,
            soldOut: !1,
            onSale: !1,
            showUnitPrice: !1,
            requiresPlan: !1,
            hasPlan: !1,
            planPerDelivery: !1,
            planSale: !1,
          };
        return (
          e && (!e.requires_selling_plan || i)
            ? (e.available || (s.soldOut = !0),
              e.compare_at_price > e.price && (s.onSale = !0),
              e.unit_price && (s.showUnitPrice = !0),
              this.product &&
                this.product.requires_selling_plan &&
                (s.requiresPlan = !0),
              i &&
                this.subPrices &&
                ((s.hasPlan = !0),
                i.allocation.per_delivery_price !== i.allocation.price &&
                  (s.planPerDelivery = !0),
                e.price > i.allocation.price && (s.planSale = !0)))
            : (s.available = !1),
          s
        );
      }
      updateProductImage(t) {
        let e = t.dataset.variant;
        if (e && e.featured_media) {
          let i = this.container.querySelector(
              `[data-image-id="${e.featured_media.id}"]`
            ),
            s = null == i ? void 0 : i.closest(".product__slide");
          if (s) {
            let r = Array.from(s.parentElement.children).indexOf(s),
              a = this.container.querySelector("[data-product-slideshow]"),
              n = E();
            if (
              (a && a.classList.contains("flickity-enabled")
                ? o.data(a).select(r)
                : a &&
                  !n &&
                  a.scrollTo({
                    top: 0,
                    left: s.offsetLeft,
                    behavior: "smooth",
                  }),
              n && this.tallLayout)
            ) {
              let l = i.getBoundingClientRect().top;
              if (0 === r && l + window.scrollY > window.pageYOffset) return;
              document.dispatchEvent(
                new CustomEvent("theme:tooltip:close", {
                  bubbles: !1,
                  detail: { hideTransition: !1 },
                })
              ),
                eF(l);
            }
          }
        }
      }
      updateLegend(t) {
        let e = t.variant;
        if (e) {
          let i = this.container.querySelectorAll("[data-option-value]");
          i.length &&
            i.forEach((t) => {
              let i = t.closest("[data-option-position]");
              if (i) {
                let s = i.getAttribute("data-option-position"),
                  r = parseInt(s, 10) - 1,
                  o = e.options[r];
                t.innerHTML = o;
              }
            });
        }
      }
      constructor() {
        super();
      }
    },
    rh = "closing",
    rc = class extends HTMLElement {
      connectedCallback() {
        (this.modal = this.querySelector("dialog")),
          (this.buttonModalOpen = this.querySelector("[data-modal-open]")),
          (this.buttonModalClose = this.querySelector("[data-modal-close]")),
          (this.focusTarget =
            this.modal.querySelector("[autofocus]") ||
            this.modal.querySelector(
              'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
            )),
          (this.isAnimating = !1),
          this.modalEvents();
      }
      modalOpen() {
        var t;
        "function" == typeof this.modal.showModal && this.modal.showModal(),
          this.modal.setAttribute("open", !0),
          this.modal.removeAttribute("inert"),
          null === (t = this.focusTarget) || void 0 === t || t.focus(),
          document.dispatchEvent(
            new CustomEvent("theme:modal:open", { bubbles: !0 })
          );
      }
      modalClose() {
        if (!this.isAnimating) {
          if (!this.modal.hasAttribute(rh))
            return (
              this.modal.setAttribute(rh, ""), void (this.isAnimating = !0)
            );
          "function" == typeof this.modal.close
            ? this.modal.close()
            : this.modal.removeAttribute("open"),
            this.modal.removeAttribute(rh),
            this.modal.setAttribute("inert", "");
        }
      }
      modalEvents() {
        this.buttonModalOpen.addEventListener("click", (t) => {
          t.preventDefault(), this.modalOpen();
        }),
          this.buttonModalClose.addEventListener("click", (t) => {
            t.preventDefault(), this.modalClose();
          }),
          this.modal.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.modalClose();
          }),
          this.modal.addEventListener("keydown", (t) => {
            "Escape" == t.code && (t.preventDefault(), this.modalClose());
          }),
          this.modal.addEventListener("theme:modal:close", () => {
            this.modalClose();
          }),
          this.modal.addEventListener("animationend", (t) => {
            t.target === this.modal &&
              ((this.isAnimating = !1),
              this.modal.hasAttribute(rh) && this.modalClose());
          });
      }
      constructor() {
        super();
      }
    },
    rd = class extends tp {
      loadContent() {
        super.loadContent(),
          Shopify.loadFeatures([
            {
              name: "model-viewer-ui",
              version: "1.0",
              onLoad: this.setupModelViewerUI.bind(this),
            },
          ]);
      }
      setupModelViewerUI(t) {
        t ||
          (this.modelViewerUI = new Shopify.ModelViewerUI(
            this.querySelector("model-viewer")
          ));
      }
      constructor() {
        super();
      }
    };
  (window.ProductModel = {
    loadShopifyXR() {
      Shopify.loadFeatures([
        {
          name: "shopify-xr",
          version: "1.0",
          onLoad: this.setupShopifyXR.bind(this),
        },
      ]);
    },
    setupShopifyXR(t) {
      t ||
        (window.ShopifyXR
          ? (document.querySelectorAll('[id^="ModelJSON-"]').forEach((t) => {
              window.ShopifyXR.addModels(JSON.parse(t.textContent)), t.remove();
            }),
            window.ShopifyXR.setupXRElements())
          : document.addEventListener("shopify_xr_initialized", () =>
              this.setupShopifyXR()
            ));
    },
  }),
    window.addEventListener("DOMContentLoaded", () => {
      window.ProductModel && window.ProductModel.loadShopifyXR();
    });
  let ru = "hidden",
    rp = "closing",
    rm = class extends HTMLElement {
      connectedCallback() {
        (this.container = this.closest("[data-section-type]")),
          (this.drawer = null),
          (this.buttonDrawerOpen = null),
          (this.buttonDrawerClose = null),
          (this.a11y = z),
          (this.isAnimating = !1),
          this.container.addEventListener("theme:variant:change", (t) =>
            this.fetchPickupAvailability(t)
          ),
          this.fetchPickupAvailability();
      }
      fetchPickupAvailability(t) {
        if (
          (t && !t.detail.variant) ||
          (t && t.detail.variant && !t.detail.variant.available)
        )
          return void this.classList.add(ru);
        let e =
          t && t.detail.variant
            ? t.detail.variant.id
            : this.getAttribute("data-store-availability-container");
        e &&
          fetch(
            `${window.theme.routes.root}variants/${e}/?section_id=api-pickup-availability`
          )
            .then(this.handleErrors)
            .then((t) => t.text())
            .then((t) => {
              let e = new DOMParser()
                .parseFromString(t, "text/html")
                .querySelector(".shopify-section").innerHTML;
              (this.innerHTML = e),
                (this.drawer = this.querySelector("[data-pickup-drawer]")),
                this.drawer
                  ? (this.classList.remove(ru), this.drawerEvents())
                  : this.classList.add(ru);
            })
            .catch((t) => {
              console.error(t);
            });
      }
      openDrawer() {
        this.drawer &&
          ("function" == typeof this.drawer.showModal &&
            this.drawer.showModal(),
          this.drawer.setAttribute("open", !0),
          this.drawer.removeAttribute("inert"),
          this.drawer.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ),
          (
            this.drawer.querySelector("[autofocus]") ||
            this.drawer.querySelector(
              'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])'
            )
          ).focus(),
          document.dispatchEvent(
            new CustomEvent("theme:scroll:lock", { bubbles: !0 })
          ));
      }
      closeDrawer() {
        if (!this.isAnimating) {
          if (!this.drawer.hasAttribute(rp))
            return (
              this.drawer.setAttribute(rp, ""), void (this.isAnimating = !0)
            );
          "function" == typeof this.drawer.close
            ? this.drawer.close()
            : this.drawer.removeAttribute("open"),
            this.drawer.removeAttribute(rp),
            this.drawer.setAttribute("inert", ""),
            document.querySelector("dialog[open]") ||
              document.dispatchEvent(
                new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
              );
        }
      }
      drawerEvents() {
        var t, e;
        null === (t = this.querySelector("[data-pickup-drawer-open]")) ||
          void 0 === t ||
          t.addEventListener("click", () => {
            this.openDrawer(),
              (window.accessibility.lastElement = this.buttonDrawerOpen);
          }),
          null ===
            (e = this.drawer.querySelector("[data-pickup-drawer-close]")) ||
            void 0 === e ||
            e.addEventListener("click", (t) => {
              t.preventDefault(), this.closeDrawer();
            }),
          this.drawer.addEventListener("click", (t) => {
            "DIALOG" === t.target.nodeName &&
              "click" === t.type &&
              this.closeDrawer();
          }),
          this.drawer.addEventListener("keydown", (t) => {
            "Escape" === t.code && (t.preventDefault(), this.closeDrawer());
          }),
          this.drawer.addEventListener("animationend", (t) => {
            t.target === this.drawer &&
              ((this.isAnimating = !1),
              this.drawer.hasAttribute(rp) && this.closeDrawer());
          });
      }
      handleErrors(t) {
        return t.ok
          ? t
          : t.json().then(function (e) {
              throw new tb({
                status: t.statusText,
                headers: t.headers,
                json: e,
              });
            });
      }
      constructor() {
        super();
      }
    },
    rg = {};
  function rf(t = {}) {
    if ((t.type || (t.type = "json"), t.url))
      return rg[t.url]
        ? rg[t.url]
        : (function (t, e) {
            let i = new Promise((i, s) => {
              var r, o, a;
              let n, l, h;
              "text" === e
                ? fetch(t)
                    .then((t) => t.text())
                    .then((t) => {
                      i(t);
                    })
                    .catch((t) => {
                      s(t);
                    })
                : ((r = t),
                  (o = function () {
                    i();
                  }),
                  (a = function () {
                    s();
                  }),
                  (n = document.getElementsByTagName("head")[0]),
                  (l = !1),
                  ((h = document.createElement("script")).src = r),
                  (h.onload = h.onreadystatechange =
                    function () {
                      l ||
                      (this.readyState &&
                        "loaded" != this.readyState &&
                        "complete" != this.readyState)
                        ? a()
                        : ((l = !0), o());
                    }),
                  n.appendChild(h));
            });
            return (rg[t] = i), i;
          })(t.url, t.type);
    if (t.json)
      return rg[t.json]
        ? Promise.resolve(rg[t.json])
        : window
            .fetch(t.json)
            .then((t) => t.json())
            .then((e) => ((rg[t.json] = e), e));
    if (t.name) {
      let e = "".concat(t.name, t.version);
      return rg[e]
        ? rg[e]
        : (function (t) {
            let e = "".concat(t.name, t.version),
              i = new Promise((e, i) => {
                try {
                  window.Shopify.loadFeatures([
                    {
                      name: t.name,
                      version: t.version,
                      onLoad(t) {
                        var s, r, o;
                        (s = e), (r = i), (o = t) ? r(o) : s();
                      },
                    },
                  ]);
                } catch (s) {
                  i(s);
                }
              });
            return (rg[e] = i), i;
          })(t);
    }
    return Promise.reject();
  }
  (window.isYoutubeAPILoaded = !1), (window.isVimeoAPILoaded = !1);
  let rv = ".pswp__thumbs",
    ry = "is-current",
    rb = "pswp--custom-loader",
    rS = "pswp--custom-opening",
    rE = "pswp__loader",
    rL = "is-focused",
    rw = "data-pswp-option-classes",
    rk = "aria-current",
    r$ = `<div class="${rE}"><div class="loader pswp__loader-line"><div class="loader-indeterminate"></div></div></div>`,
    rA = class {
      init() {
        this.pswpElement.classList.add(rS),
          this.initLoader(),
          rf({ url: window.theme.assets.photoswipe })
            .then(() => this.loadPopup())
            .catch((t) => console.error(t));
      }
      initLoader() {
        if (
          this.pswpElement.classList.contains(rb) &&
          "" !== this.options &&
          this.options.mainClass
        ) {
          this.pswpElement.setAttribute(rw, this.options.mainClass);
          let t = document.createElement("div");
          (t.innerHTML = r$),
            (t = t.firstChild),
            this.pswpElement.appendChild(t);
        } else this.pswpElement.setAttribute(rw, "");
      }
      loadPopup() {
        let t = window.themePhotoswipe.PhotoSwipe.default,
          e = window.themePhotoswipe.PhotoSwipeUI.default;
        this.pswpElement.classList.contains(rb) &&
          this.pswpElement.classList.remove(rb),
          this.pswpElement.classList.remove(rS),
          (this.popup = new t(this.pswpElement, e, this.items, this.options)),
          this.popup.init(),
          this.thumbsActions(),
          document.body.classList.contains(rL) &&
            setTimeout(() => {
              this.a11y.trapFocus(this.pswpElement, {
                elementToFocus: this.closeBtn,
              });
            }, 200),
          this.popup.listen("close", () => this.onClose()),
          this.options &&
            this.options.closeElClasses &&
            this.options.closeElClasses.length &&
            this.options.closeElClasses.forEach((t) => {
              let e = this.pswpElement.querySelector(`.pswp__${t}`);
              e && e.addEventListener("keyup", this.keyupCloseEvent);
            });
      }
      thumbsActions() {
        this.popupThumbsContainer &&
          this.popupThumbsContainer.children.length &&
          (this.popupThumbsContainer.addEventListener("wheel", (t) =>
            this.stopDisabledScroll(t)
          ),
          this.popupThumbsContainer.addEventListener("mousewheel", (t) =>
            this.stopDisabledScroll(t)
          ),
          this.popupThumbsContainer.addEventListener("DOMMouseScroll", (t) =>
            this.stopDisabledScroll(t)
          ),
          (this.popupThumbs = this.pswpElement.querySelectorAll(`${rv} > *`)),
          this.popupThumbs.forEach((t, e) => {
            t.addEventListener("click", (i) => {
              i.preventDefault();
              let s = t.parentElement.querySelector(`.${ry}`);
              s.classList.remove(ry),
                s.setAttribute(rk, !1),
                t.classList.add(ry),
                t.setAttribute(rk, !0),
                this.popup.goTo(e);
            });
          }),
          this.popup.listen("imageLoadComplete", () => this.setCurrentThumb()),
          this.popup.listen("beforeChange", () => this.setCurrentThumb()));
      }
      stopDisabledScroll(t) {
        t.stopPropagation();
      }
      keyupClose(t) {
        "Enter" === t.code && this.popup.close();
      }
      onClose() {
        let t = this.pswpElement.querySelector("iframe, video");
        if (
          (t && t.parentNode.removeChild(t),
          this.popupThumbsContainer && this.popupThumbsContainer.firstChild)
        )
          for (; this.popupThumbsContainer.firstChild; )
            this.popupThumbsContainer.removeChild(
              this.popupThumbsContainer.firstChild
            );
        this.pswpElement.setAttribute(rw, "");
        let e = this.pswpElement.querySelector(`.${rE}`);
        e && this.pswpElement.removeChild(e),
          this.options &&
            this.options.closeElClasses &&
            this.options.closeElClasses.length &&
            this.options.closeElClasses.forEach((t) => {
              let e = this.pswpElement.querySelector(`.pswp__${t}`);
              e && e.removeEventListener("keyup", this.keyupCloseEvent);
            }),
          this.a11y.removeTrapFocus(),
          window.accessibility.lastElement &&
            document.body.classList.contains(rL) &&
            requestAnimationFrame(() => {
              window.accessibility.lastElement.focus();
            });
      }
      setCurrentThumb() {
        let t = this.pswpElement.querySelector(`${rv} > .${ry}`);
        if (
          (t && (t.classList.remove(ry), t.setAttribute(rk, !1)),
          !this.popupThumbs)
        )
          return;
        let e = this.popupThumbs[this.popup.getCurrentIndex()];
        e.classList.add(ry), e.setAttribute(rk, !0), this.scrollThumbs(e);
      }
      scrollThumbs(t) {
        let e =
            this.popupThumbsContainer.scrollLeft +
            this.popupThumbsContainer.offsetWidth,
          i = t.offsetLeft;
        if (e <= i + t.offsetWidth || e > i) {
          let s = parseInt(window.getComputedStyle(t).marginLeft);
          this.popupThumbsContainer.scrollTo({
            top: 0,
            left: i - s,
            behavior: "smooth",
          });
        }
      }
      constructor(t, e = "") {
        (this.items = t),
          (this.pswpElement = document.querySelectorAll(".pswp")[0]),
          (this.popup = null),
          (this.popupThumbs = null),
          (this.popupThumbsContainer = this.pswpElement.querySelector(rv)),
          (this.closeBtn = this.pswpElement.querySelector(
            ".pswp__custom-close"
          )),
          (this.keyupCloseEvent = (t) => this.keyupClose(t)),
          (this.a11y = z),
          (this.options =
            "" !== e ? e : { history: !1, focus: !1, mainClass: "" }),
          this.init();
      }
    },
    rT = "variant--soldout",
    rC = "variant--unavailable",
    rq = "pswp-zoom-gallery",
    rx = "data-add-to-cart-bar",
    r_ = "data-truncated-content",
    rP = "[data-slider]",
    rH = "data-slider-index",
    rB = "is-expanded",
    r8 = "is-visible",
    rD = {};
  eu("product", [
    {
      onLoad() {
        rD[this.id] = new (class {
          scrollEvents(t) {
            this.cartBarExist && this.cartBarScroll();
          }
          resizeEvents(t) {
            this.truncateText();
          }
          truncateText() {
            if (this.truncateElementHolder.classList.contains(r8)) return;
            let t = this.truncateElement.querySelectorAll("style");
            t.length &&
              t.forEach((t) => {
                this.truncateElementHolder.prepend(t);
              });
            let e = this.truncateElement.cloneNode(!0),
              i = this.truncateElement.getAttribute(r_),
              s = this.truncateElement.nextElementSibling;
            s && s.remove(), this.truncateElement.parentElement.append(e);
            let r = this.truncateElement.nextElementSibling;
            r.classList.add(i),
              r.removeAttribute(r_),
              tg(r),
              ((t = "", e = 1, i = {}) => {
                let s = {
                    replaceStr: "...",
                    debounceDelay: 250,
                    delimiter: " ",
                    ...i,
                  },
                  r =
                    t &&
                    (t instanceof NodeList
                      ? t
                      : 1 === t.nodeType
                      ? [t]
                      : document.querySelectorAll(t));
                for (let o = 0; o < r.length; o++) {
                  let a = r[o],
                    n = /<!--[\s\S]*?-->/g,
                    l = a.innerHTML.replace(n, "").split(s.delimiter);
                  a.innerHTML = "";
                  let h = window.getComputedStyle(a);
                  l.reduce(sz, {
                    el: a,
                    buffer: a.innerHTML,
                    elStyle: h,
                    elHeight: 0,
                    rowsLimit: e,
                    rowsWrapped: 0,
                    options: s,
                  });
                }
              })(r, 5, { replaceStr: "", delimiter: " " }),
              tv(r),
              this.truncateElement.innerHTML !== r.innerHTML
                ? this.truncateElementHolder.classList.add(rB)
                : (r.remove(), this.truncateElementHolder.classList.remove(rB)),
              this.toggleTruncatedContent(this.truncateElementHolder);
          }
          toggleTruncatedContent(t) {
            let e = t.querySelector("[data-truncated-button]");
            e &&
              e.addEventListener("click", (e) => {
                e.preventDefault(), t.classList.remove(rB), t.classList.add(r8);
              });
          }
          initCartBar() {
            (this.cartBarBtn = this.cartBar.querySelector(
              ".product__submit__add"
            )),
              this.cartBarBtn &&
                (this.cartBarBtn.addEventListener("click", (t) => {
                  t.preventDefault(),
                    t.currentTarget.hasAttribute(rx)
                      ? (theme.settings.cartDrawerEnabled &&
                          (t.currentTarget.classList.add("is-loading"),
                          t.currentTarget.setAttribute("disabled", "disabled")),
                        this.form
                          .querySelector("[data-add-to-cart]")
                          .dispatchEvent(new Event("click", { bubbles: !0 })))
                      : t.currentTarget.hasAttribute("data-cart-bar-scroll") &&
                        this.scrollToTop();
                }),
                this.cartBarBtn.hasAttribute(rx) &&
                  document.addEventListener(
                    "theme:product:add-error",
                    this.scrollToTop
                  ));
          }
          scrollToTop() {
            // let t = this.container.querySelector("[data-product-variants]"),
            //   e = (
            //     E() ? this.container : t || this.form
            //   ).getBoundingClientRect().top;
            // eF(E() ? e : e - 50);
          }
          cartBarScroll() {
            let t = window.pageYOffset,
              e =
                theme.variables.productPageSticky && this.formWrapper
                  ? this.formWrapper
                  : this.form;
            if (e && this.cartBar) {
              let i = t > e.offsetTop + e.offsetHeight;
              this.cartBar.classList.toggle(r8, i);
            }
          }
          onUnload() {
            document.removeEventListener(
              "theme:product:add-error",
              this.scrollToTop
            ),
              this.truncateElementHolder &&
                this.truncateElement &&
                document.removeEventListener("theme:resize", this.resizeEvent),
              this.cartBarExist &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          onBlockSelect(t) {
            let e = t.srcElement.closest(rP);
            if (e && this.slider.length) {
              let i = e.hasAttribute(rH) ? e.getAttribute(rH) : 0;
              if (!this.slider[i]) return;
              this.slider[i].onBlockSelect(t);
            }
          }
          onBlockDeselect(t) {
            let e = t.srcElement.closest(rP);
            if (e && this.slider.length) {
              let i = e.hasAttribute(rH) ? e.getAttribute(rH) : 0;
              if (!this.slider[i]) return;
              this.slider[i].onBlockDeselect(t);
            }
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.id = this.container.getAttribute("data-section-id")),
              (this.sliders = this.container.querySelectorAll(rP)),
              (this.slider = []),
              (this.truncateElementHolder = this.container.querySelector(
                "[data-truncated-holder]"
              )),
              (this.truncateElement = this.container.querySelector(
                "[data-truncated-content]"
              )),
              (this.formWrapper = this.container.querySelector(
                "[data-form-wrapper]"
              )),
              (this.cartBarExist =
                "true" === this.container.getAttribute("data-cart-bar")),
              (this.cartBar = this.container.querySelector("#cart-bar")),
              (this.scrollToTop = this.scrollToTop.bind(this)),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              (this.unlockTimer = 0),
              (this.accessibility = z),
              this.container.hasAttribute("data-image-zoom-enable") &&
                new (class {
                  init() {
                    this.zoomWrappers.length &&
                      this.zoomWrappers.forEach((t, e) => {
                        t.addEventListener("click", (i) => {
                          i.preventDefault(),
                            this.createZoom(e),
                            (window.accessibility.lastElement = t);
                        }),
                          t.addEventListener("keyup", (i) => {
                            "Enter" === i.code &&
                              (i.preventDefault(),
                              this.createZoom(e),
                              (window.accessibility.lastElement = t));
                          });
                      });
                  }
                  createZoom(t) {
                    let e = this.container.querySelector(
                        "[data-pswp-thumbs-template]"
                      ),
                      i = null == e ? void 0 : e.innerHTML,
                      s = [],
                      r = 0;
                    this.zoomWrappers.forEach((e) => {
                      let o = e.getAttribute("data-image-src");
                      (r += 1),
                        s.push({
                          src: o,
                          w: parseInt(e.getAttribute("data-image-width")),
                          h: parseInt(e.getAttribute("data-image-height")),
                          msrc: o,
                        }),
                        this.zoomWrappers.length === r &&
                          (new rA(s, {
                            history: !1,
                            focus: !1,
                            index: t,
                            mainClass:
                              1 === r
                                ? `${rq} pswp-zoom-gallery--single`
                                : `${rq}`,
                            showHideOpacity: !0,
                            howAnimationDuration: 150,
                            hideAnimationDuration: 250,
                            closeOnScroll: !1,
                            closeOnVerticalDrag: !1,
                            captionEl: !0,
                            closeEl: !0,
                            closeElClasses: ["caption-close", "title"],
                            tapToClose: !1,
                            clickToCloseNonZoomable: !1,
                            maxSpreadZoom: 2,
                            loop: !0,
                            spacing: 0,
                            allowPanToNext: !0,
                            pinchToClose: !1,
                            addCaptionHTMLFn: (t, e, i) => {
                              this.zoomCaption(t, e, i);
                            },
                            getThumbBoundsFn: () => {
                              let e = this.zoomWrappers[t],
                                i =
                                  window.pageYOffset ||
                                  document.documentElement.scrollTop,
                                s = e.getBoundingClientRect();
                              return { x: s.left, y: s.top + i, w: s.width };
                            },
                          }),
                          this.thumbsContainer &&
                            "" !== i &&
                            (this.thumbsContainer.innerHTML = i));
                    });
                  }
                  zoomCaption(t, e) {
                    let i = "",
                      s = e.children[0];
                    return (
                      this.zoomCaptionElem &&
                        ((i = this.zoomCaptionElem.innerHTML),
                        this.zoomCaptionElem.closest(`.${rT}`)
                          ? s.classList.add(rT)
                          : s.classList.remove(rT),
                        this.zoomCaptionElem.closest(`.${rC}`)
                          ? s.classList.add(rC)
                          : s.classList.remove(rC)),
                      (i = i.replaceAll(
                        "product__title",
                        "product__title pswp__title"
                      )),
                      (s.innerHTML = i),
                      !1
                    );
                  }
                  constructor(t) {
                    (this.container = t.container),
                      (this.zoomWrappers = this.container.querySelectorAll(
                        "[data-zoom-wrapper]"
                      )),
                      (this.thumbsContainer =
                        document.querySelector(".pswp__thumbs")),
                      (this.zoomCaptionElem = this.container.querySelector(
                        "[data-zoom-caption]"
                      )),
                      this.init();
                  }
                })(this.section),
              this.truncateElementHolder &&
                this.truncateElement &&
                (setTimeout(() => this.truncateText(), 50),
                document.addEventListener("theme:resize", this.resizeEvent));
            let e = this.container.querySelector("[data-product-json]");
            if ((e && !e.innerHTML) || !e) return;
            let i = JSON.parse(e.innerHTML).handle,
              s = {};
            i && (s = { handle: i }),
              Shopify.Products.recordRecentlyViewed(s),
              (this.form = this.container.querySelector("[data-product-form]")),
              this.sliders.length &&
                this.sliders.forEach((t, e) => {
                  t.setAttribute(rH, e),
                    this.slider.push(new eM(this.container, t));
                }),
              this.cartBarExist &&
                (this.initCartBar(),
                document.addEventListener("theme:scroll", this.scrollEvent));
          }
        })(this);
      },
      onUnload(t) {
        rD[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        rD[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        rD[this.id].onBlockDeselect(t);
      },
    },
    ek,
    sw,
    {
      onLoad() {
        s1[this.id] = new (class {
          init() {
            this.stickyEnabled &&
              (this.stickyScrollCheck(),
              document.addEventListener("theme:resize", this.resizeEvent)),
              this.initSticky();
          }
          initSticky() {
            theme.variables.productPageSticky &&
              ((this.requestAnimationSticky = requestAnimationFrame(() =>
                this.calculateStickyPosition()
              )),
              this.formWrapper.addEventListener("theme:form:sticky", (t) => {
                this.removeAnimationFrame(),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  ));
              }),
              document.addEventListener("theme:scroll", this.scrollEvent));
          }
          scrollEvents(t) {
            (this.scrollTop = t.detail.position),
              (this.scrollDirectionDown = t.detail.down),
              this.requestAnimationSticky ||
                (this.requestAnimationSticky = requestAnimationFrame(() =>
                  this.calculateStickyPosition()
                ));
          }
          resizeEvents(t) {
            this.stickyScrollCheck(),
              document.removeEventListener("theme:scroll", this.scrollEvent),
              this.initSticky();
          }
          stickyScrollCheck() {
            let t = this.container.querySelector(`.product__page ${sV}`);
            if (t) {
              if (E()) {
                let e = this.container.querySelector(sV),
                  i = this.container.querySelector("[data-product-slideshow]");
                if (!e || !i) return;
                e.offsetHeight < i.offsetHeight
                  ? ((theme.variables.productPageSticky = !0),
                    t.classList.add(s3))
                  : ((theme.variables.productPageSticky = !1),
                    t.classList.remove(s3));
              } else
                (theme.variables.productPageSticky = !1),
                  t.classList.remove(s3);
            }
          }
          calculateStickyPosition(t = null) {
            if (document.documentElement.hasAttribute("data-scroll-locked"))
              return void this.removeAnimationFrame();
            let e = Boolean(t && t.detail),
              i = Boolean(
                e && t.detail.element && "accordion" === t.detail.element
              ),
              s = this.formWrapper.offsetHeight,
              r = window.innerHeight - s - this.defaultTopBottomSpacings,
              o = Math.abs(this.scrollTop - this.scrollLastPosition);
            this.scrollDirectionDown
              ? (this.stickyScrollTop -= o)
              : (this.stickyScrollTop += o),
              this.stickyFormLoad &&
                (document.querySelector("[data-header-sticky]") &&
                document.querySelector(sj)
                  ? (this.stickyDefaultTop = parseInt(
                      document.querySelector(sj).getBoundingClientRect().height
                    ))
                  : (this.stickyDefaultTop = this.defaultTopBottomSpacings),
                (this.stickyScrollTop = this.stickyDefaultTop)),
              (this.stickyScrollTop = Math.min(
                Math.max(this.stickyScrollTop, r),
                this.stickyDefaultTop
              ));
            let a = this.stickyScrollTop - this.currentPoint;
            (this.currentPoint = this.stickyFormLoad
              ? this.stickyScrollTop
              : this.currentPoint + 0.5 * a),
              this.formWrapper.style.setProperty(
                "--sticky-top",
                `${this.currentPoint}px`
              ),
              (this.scrollLastPosition = this.scrollTop),
              (this.stickyFormLoad = !1),
              (i && this.onChangeCounter <= 10) ||
              (i && this.stickyFormLastHeight !== s) ||
              (this.stickyScrollTop !== this.currentPoint &&
                this.requestAnimationSticky)
                ? (i && (this.onChangeCounter += 1),
                  i &&
                    this.stickyFormLastHeight !== s &&
                    (this.onChangeCounter = 11),
                  (this.requestAnimationSticky = requestAnimationFrame(() =>
                    this.calculateStickyPosition(t)
                  )))
                : this.requestAnimationSticky && this.removeAnimationFrame(),
              (this.stickyFormLastHeight = s);
          }
          removeAnimationFrame() {
            this.requestAnimationSticky &&
              (cancelAnimationFrame(this.requestAnimationSticky),
              (this.requestAnimationSticky = null),
              (this.onChangeCounter = 0));
          }
          onUnload() {
            this.stickyEnabled &&
              document.removeEventListener("theme:resize", this.resizeEvent),
              theme.variables.productPageSticky &&
                document.removeEventListener("theme:scroll", this.scrollEvent);
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.stickyEnabled =
                "true" === this.container.getAttribute("data-sticky-enabled")),
              (this.formWrapper = this.container.querySelector(sV)),
              (this.stickyScrollTop = 0),
              (this.scrollLastPosition = 0),
              (this.stickyDefaultTop = 0),
              (this.currentPoint = 0),
              (this.defaultTopBottomSpacings = 30),
              (this.scrollTop = window.scrollY),
              (this.scrollDirectionDown = !0),
              (this.requestAnimationSticky = null),
              (this.stickyFormLoad = !0),
              (this.stickyFormLastHeight = null),
              (this.onChangeCounter = 0),
              (this.scrollEvent = (t) => this.scrollEvents(t)),
              (this.resizeEvent = (t) => this.resizeEvents(t)),
              setTimeout(() => {
                this.init();
              }, 50);
          }
        })(this);
      },
      onUnload() {
        s1[this.id].onUnload();
      },
    },
    {
      onLoad() {
        sB[this.id] = new s8(this);
      },
      onUnload(t) {
        sB[this.id].onUnload(t);
      },
    },
  ]),
    customElements.get("complementary-products") ||
      customElements.define("complementary-products", sU),
    customElements.get("pickup-availability") ||
      customElements.define("pickup-availability", rm),
    customElements.get("product-form") ||
      customElements.define("product-form", rl),
    customElements.get("product-modal") ||
      customElements.define("product-modal", rc),
    customElements.get("product-model") ||
      customElements.define("product-model", rd),
    customElements.get("product-siblings") ||
      customElements.define("product-siblings", sp),
    customElements.get("radio-swatch") ||
      customElements.define("radio-swatch", si),
    customElements.get("recipient-form") ||
      customElements.define("recipient-form", s0),
    customElements.get("share-button") ||
      customElements.define("share-button", s4);
  let rM = "[data-product-grid-item]",
    rI = "[data-recent-wrapper]",
    r9 = "[data-slider]",
    rF = "data-limit",
    rO = "data-minimum",
    rR = {};
  eu("related", [
    {
      onLoad() {
        rR[this.id] = new (class {
          related() {
            let t = this.container.querySelector("[data-related-section]");
            if (!t) return;
            let e = t.getAttribute("data-product-id"),
              i = t.getAttribute(rF),
              s = `${window.theme.routes.product_recommendations_url}?section_id=api-product-recommendation&limit=${i}&product_id=${e}&intent=related`;
            fetch(s)
              .then((t) => t.text())
              .then((e) => {
                let i = document.createElement("div");
                (i.innerHTML = new DOMParser()
                  .parseFromString(e, "text/html")
                  .querySelector("[data-api-related-template]").innerHTML),
                  i.querySelector(rM)
                    ? ((t.innerHTML = i.innerHTML),
                      t.querySelectorAll(rM).length > 4 &&
                        t.querySelector(r9) &&
                        new eM(t))
                    : t.dispatchEvent(
                        new CustomEvent("theme:tab:hide", { bubbles: !0 })
                      );
              })
              .catch(function () {
                t.dispatchEvent(
                  new CustomEvent("theme:tab:hide", { bubbles: !0 })
                );
              });
          }
          recent() {
            let t = this.container.querySelector(rI),
              e = t ? parseInt(t.getAttribute(rF)) : 4;
            Shopify.Products.showRecentlyViewed({
              howManyToShow: e,
              wrapperId: `recently-viewed-products-${this.sectionId}`,
              section: this.section,
              onComplete(t, e) {
                let i = e.container,
                  s = i.querySelector(rI),
                  r = i.querySelector("[data-recently-viewed-wrapper]"),
                  o = t.querySelectorAll(".product-item"),
                  a = s.hasAttribute(rO) ? parseInt(s.getAttribute(rO)) : 4,
                  n = !r && o.length > 0,
                  l = r && o.length >= a;
                (n || l) &&
                  (l && r.classList.remove("is-hidden"),
                  ty(s),
                  s.dispatchEvent(
                    new CustomEvent("theme:tab:check", { bubbles: !0 })
                  ),
                  o.length > 4 && s.querySelector(r9) && new eM(s));
              },
            });
          }
          constructor(t) {
            (this.section = t),
              (this.sectionId = t.id),
              (this.container = t.container),
              this.related(),
              this.recent();
          }
        })(this);
      },
    },
    sw,
  ]),
    eu("reviews", [eI, i0]);
  let rz = {},
    rN = "[data-slide]",
    rW = "is-selected",
    rU = "flickity-enabled",
    r0 = "data-slide-index";
  eu("logos", [
    {
      onLoad() {
        rz[this.id] = new (class {
          initSlideshowText() {
            if (!this.slideshowText) return;
            this.flkty = new o(this.slideshowText, {
              fade: !0,
              autoPlay: !1,
              prevNextButtons: !1,
              cellAlign: "left",
              contain: !0,
              pageDots: !1,
              wrapAround: !1,
              selectedAttraction: 0.2,
              friction: 0.6,
              draggable: !1,
              accessibility: !1,
              on: {
                ready: () => this.sliderAccessibility(),
                change: () => this.sliderAccessibility(),
              },
            });
            let t = this.slideshowText.querySelectorAll(rN);
            if (t.length) {
              let e = -1;
              t.forEach((t) => {
                let i = parseFloat(
                  getComputedStyle(t, null).height.replace("px", "")
                );
                i > e && (e = i);
              }),
                t.forEach((t) => {
                  let i = parseFloat(
                    getComputedStyle(t, null).height.replace("px", "")
                  );
                  if (i < e) {
                    let s = Math.ceil((e - i) / 2);
                    t.style.margin = `${s}px 0`;
                  }
                });
            }
          }
          sliderAccessibility() {
            let t = this.slideshowText.querySelectorAll(
              `${rN} a, ${rN} button`
            );
            t.length &&
              t.forEach((t) => {
                let e = t.closest(rN);
                if (e) {
                  let i = e.classList.contains(rW) ? 0 : -1;
                  t.setAttribute("tabindex", i);
                }
              });
          }
          initSlideshowNav() {
            this.slideshowNav &&
              ((this.logoSlides =
                this.slideshowNav.querySelectorAll("[data-slide-index]")),
              this.logoSlides.length &&
                this.logoSlides.forEach((t) => {
                  t.addEventListener("click", (e) => {
                    e.preventDefault();
                    let i = parseInt(t.getAttribute(r0)),
                      s = this.slideshowNav.classList.contains(rU);
                    if ((this.flkty && this.flkty.select(i), s))
                      this.flktyNav.select(i),
                        this.slideshowNav.classList.contains(rW) ||
                          this.flktyNav.playPlayer();
                    else {
                      let r = this.slideshowNav.querySelector(`.${rW}`);
                      r && r.classList.remove(rW), t.classList.add(rW);
                    }
                  });
                }),
              this.setSlideshowNavState(),
              document.addEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          setSlideshowNavState() {
            let t = this.slideshowNav.querySelectorAll(rN),
              e = 200 * t.length,
              i = this.slideshowNav.classList.contains(rU);
            if (e > b()) {
              if (!i) {
                let s = this.slideshowNav.querySelector(`.${rW}`);
                s && s.classList.remove(rW),
                  t[0].classList.add(rW),
                  (this.flktyNav = new r(this.slideshowNav, {
                    autoPlay: 4e3,
                    prevNextButtons: !1,
                    contain: !1,
                    pageDots: !1,
                    wrapAround: !0,
                    watchCSS: !0,
                    selectedAttraction: 0.05,
                    friction: 0.8,
                    initialIndex: 0,
                  })),
                  this.flkty &&
                    (this.flkty.select(0),
                    this.flktyNav.on("change", (t) => this.flkty.select(t)));
              }
            } else
              i &&
                (this.flktyNav.destroy(),
                t[0].classList.add(rW),
                this.flkty && this.flkty.select(0));
          }
          onBlockSelect(t) {
            if (!this.slideshowNav) return;
            let e = this.slideshowNav.querySelector(
                `[data-slide="${t.detail.blockId}"]`
              ),
              i = parseInt(e.getAttribute(r0));
            this.slideshowNav.classList.contains(rU)
              ? (this.flktyNav.select(i),
                this.flktyNav.stopPlayer(),
                this.slideshowNav.classList.add(rW))
              : e.dispatchEvent(new Event("click"));
          }
          onBlockDeselect() {
            this.slideshowNav &&
              this.slideshowNav.classList.contains(rU) &&
              (this.flktyNav.playPlayer(),
              this.slideshowNav.classList.remove(rW));
          }
          onUnload() {
            this.slideshowNav &&
              (this.slideshowNav.classList.contains(rU) &&
                this.flktyNav.destroy(),
              this.flkty && this.flkty.destroy(),
              document.removeEventListener(
                "theme:resize",
                this.setSlideshowNavStateOnResize
              ));
          }
          constructor(t) {
            (this.container = t.container),
              (this.slideshowNav = this.container.querySelector(
                "[data-slider-logos]"
              )),
              (this.slideshowText =
                this.container.querySelector("[data-slider-text]")),
              (this.setSlideshowNavStateOnResize = () =>
                this.setSlideshowNavState()),
              (this.flkty = null),
              (this.flktyNav = null),
              this.initSlideshowText(),
              this.initSlideshowNav();
          }
        })(this);
      },
      onUnload(t) {
        rz[this.id].onUnload(t);
      },
      onBlockSelect(t) {
        rz[this.id].onBlockSelect(t);
      },
      onBlockDeselect(t) {
        rz[this.id].onBlockDeselect(t);
      },
    },
    i0,
  ]);
  let rV = "data-video-play",
    rj = class extends HTMLElement {
      connectedCallback() {
        var t;
        (this.videoPlay = this.querySelectorAll(`[${rV}]`)),
          null === (t = this.videoPlay) ||
            void 0 === t ||
            t.forEach((t) => {
              t.addEventListener("click", (t) => {
                let e = t.currentTarget;
                if ("" !== e.getAttribute(rV).trim()) {
                  t.preventDefault();
                  let i = [{ html: e.getAttribute(rV) }];
                  new rA(i), (window.accessibility.lastElement = e);
                }
              });
            });
      }
      constructor() {
        super();
      }
    },
    r3 = class extends HTMLElement {
      connectedCallback() {
        (this.videoId = this.getAttribute("data-video-id")),
          (this.videoTemplate = this.querySelector("[data-video-template]")),
          (this.video = null),
          this.videoId &&
            (this.addEventListener(
              "touchstart",
              () => {
                var t;
                null === (t = this.video) || void 0 === t || t.play();
              },
              { passive: !0 }
            ),
            this.renderVideo());
      }
      renderVideo() {
        (this.videoTemplateObserver = new IntersectionObserver(
          (t, e) => {
            t.forEach((t) => {
              if (t.isIntersecting) {
                let i = this.videoTemplate.innerHTML;
                (this.innerHTML = i),
                  this.classList.remove("is-loading"),
                  (this.video = this.querySelector("video")),
                  this.observeVideoPlayToggle(),
                  e.unobserve(t.target);
              }
            });
          },
          {
            root: null,
            rootMargin: "300px",
            threshold: [0, 0.1, 0.25, 0.5, 0.75, 1],
          }
        )),
          this.videoTemplateObserver.observe(this);
      }
      observeVideoPlayToggle() {
        this.video &&
          ((this.videoPlayObserver = new IntersectionObserver(
            (t) => {
              t.forEach((t) => {
                let e = t.isIntersecting;
                e && "function" == typeof this.video.play && this.video.play(),
                  e ||
                    "function" != typeof this.video.pause ||
                    this.video.pause();
              });
            },
            { rootMargin: "0px", threshold: [0, 1] }
          )),
          this.videoPlayObserver.observe(this.video));
      }
      disconnectedCallback() {
        this.videoTemplateObserver && this.videoTemplateObserver.disconnect(),
          this.videoPlayObserver && this.videoPlayObserver.disconnect();
      }
      constructor() {
        super();
      }
    };
  eu("featured-video", [eA]),
    customElements.get("video-background") ||
      customElements.define("video-background", r3),
    customElements.get("video-popup") ||
      customElements.define("video-popup", rj),
    eu("slideshow", [eI, eA]);
  let r1 = "data-start-position",
    r2 = {},
    rX = {
      onLoad() {
        (r2[this.id] = []),
          this.container
            .querySelectorAll("[data-images-holder]")
            .forEach((t) => {
              r2[this.id].push(
                new (class {
                  init() {
                    this.changeValues(),
                      this.imagesButton.addEventListener(
                        "mousedown",
                        this.onStartEvent
                      ),
                      this.imagesButton.addEventListener(
                        "touchstart",
                        this.onStartEvent,
                        { passive: !0 }
                      );
                  }
                  changeValues(t) {
                    let e = this.imagesHolder.offsetWidth,
                      i = this.imagesButton.offsetWidth;
                    if (
                      (!t ||
                        (t &&
                          "touchmove" !== t.type &&
                          "mousemove" !== t.type)) &&
                      ((this.imageElement.style.width = `${e}px`),
                      (this.imageHolder.style.width =
                        100 - parseInt(this.startPosition) + "%"),
                      0 !== this.startPosition)
                    ) {
                      let s = (e * parseInt(this.startPosition)) / 100;
                      this.x = s - i / 2;
                    }
                    this.x > e - i
                      ? (this.x = e - i)
                      : this.x < 0 && (this.x = 0),
                      (this.imagesButton.style.left = (this.x / e) * 100 + "%"),
                      (this.imageHolder.style.width =
                        100 - ((this.x + i / 2) / e) * 100 + "%");
                  }
                  onStart(t) {
                    t.preventDefault();
                    let e = t;
                    t.touches && (e = t.touches[0]),
                      (this.x = this.imagesButton.offsetLeft),
                      (this.startX = e.pageX - this.x),
                      this.imagesHolder.addEventListener(
                        "mousemove",
                        this.onMoveEvent
                      ),
                      this.imagesHolder.addEventListener(
                        "mouseup",
                        this.onStopEvent
                      ),
                      this.imagesHolder.addEventListener(
                        "touchmove",
                        this.onMoveEvent
                      ),
                      this.imagesHolder.addEventListener(
                        "touchend",
                        this.onStopEvent
                      );
                  }
                  onMove(t) {
                    let e = t;
                    t.touches && (e = t.touches[0]),
                      (this.x = e.pageX - this.startX),
                      this.changeValues(t);
                  }
                  onStop(t) {
                    this.imagesHolder.removeEventListener(
                      "mousemove",
                      this.onMoveEvent
                    ),
                      this.imagesHolder.removeEventListener(
                        "mouseup",
                        this.onStopEvent
                      ),
                      this.imagesHolder.removeEventListener(
                        "touchmove",
                        this.onMoveEvent
                      ),
                      this.imagesHolder.removeEventListener(
                        "touchend",
                        this.onStopEvent
                      );
                  }
                  onUnload() {
                    this.changeValuesEvent &&
                      document.removeEventListener(
                        "theme:resize",
                        this.changeValuesEvent
                      );
                  }
                  constructor(t) {
                    (this.imagesHolder = t),
                      this.imagesHolder &&
                        ((this.imageHolder = this.imagesHolder.querySelector(
                          "[data-image-holder]"
                        )),
                        (this.imageElement = this.imagesHolder.querySelector(
                          "[data-image-element]"
                        )),
                        (this.imagesButton = this.imagesHolder.querySelector(
                          "[data-images-button]"
                        )),
                        (this.startPosition = this.imagesHolder.hasAttribute(r1)
                          ? this.imagesHolder.getAttribute(r1)
                          : 0),
                        (this.startX = 0),
                        (this.x = 0),
                        (this.changeValuesEvent = (t) => this.changeValues(t)),
                        (this.onMoveEvent = (t) => this.onMove(t)),
                        (this.onStopEvent = (t) => this.onStop(t)),
                        (this.onStartEvent = (t) => this.onStart(t)),
                        this.init(),
                        document.addEventListener(
                          "theme:resize",
                          this.changeValuesEvent
                        ));
                  }
                })(t)
              );
            });
      },
      onUnload() {
        r2[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    };
  eu("custom-content", [eI, eA, rX, eU]),
    customElements.get("video-background") ||
      customElements.define("video-background", r3),
    customElements.get("video-popup") ||
      customElements.define("video-popup", rj);
  var r4 = {};
  function rQ(t) {
    return r4[t];
  }
  (r4.basic = []),
    (r4.light = [
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { lightness: "64" },
          { hue: "#ff0000" },
        ],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#bdbdbd" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
      },
      {
        featureType: "landscape.natural.landcover",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "landscape.natural.terrain",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry.fill",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ lightness: "100" }],
      },
      {
        featureType: "poi.park",
        elementType: "all",
        stylers: [{ visibility: "on" }],
      },
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
      },
      {
        featureType: "poi.park",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: "-100" }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [
          { lightness: "25" },
          { gamma: "1.06" },
          { saturation: "-100" },
        ],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ gamma: "10.00" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [
          { visibility: "simplified" },
          { weight: "0.01" },
          { lightness: "39" },
        ],
      },
      {
        featureType: "road.local",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#cfe5ee" }, { visibility: "on" }],
      },
    ]),
    (r4.white_label = [
      {
        featureType: "all",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ gamma: "3.86" }, { lightness: "100" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cccccc" }],
      },
      {
        featureType: "landscape",
        elementType: "all",
        stylers: [{ color: "#f2f2f2" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road",
        elementType: "all",
        stylers: [{ saturation: -100 }, { lightness: 45 }],
      },
      {
        featureType: "road.highway",
        elementType: "all",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0" }],
      },
      {
        featureType: "road.arterial",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels.text",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "water",
        elementType: "all",
        stylers: [{ color: "#e4e4e4" }, { visibility: "on" }],
      },
    ]),
    (r4.dark_label = [
      {
        featureType: "all",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "all",
        elementType: "labels.text.fill",
        stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
      },
      {
        featureType: "all",
        elementType: "labels.text.stroke",
        stylers: [
          { visibility: "on" },
          { color: "#000000" },
          { lightness: 16 },
        ],
      },
      {
        featureType: "all",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "administrative",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
      },
      {
        featureType: "administrative",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
      },
      {
        featureType: "administrative",
        elementType: "labels.text.stroke",
        stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
      },
      {
        featureType: "landscape",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 20 }],
      },
      {
        featureType: "landscape",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 21 }],
      },
      {
        featureType: "road",
        elementType: "labels",
        stylers: [{ visibility: "simplified" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.fill",
        stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
      },
      {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
      },
      {
        featureType: "road.highway",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 18 }],
      },
      {
        featureType: "road.arterial",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 16 }],
      },
      {
        featureType: "road.local",
        elementType: "geometry.stroke",
        stylers: [{ weight: "0.01" }],
      },
      {
        featureType: "road.local",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "all",
        stylers: [{ visibility: "off" }],
      },
      {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 19 }],
      },
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#000000" }, { lightness: 17 }],
      },
    ]),
    (window.theme.allMaps = window.theme.allMaps || {});
  let r5 = window.theme.allMaps;
  (window.theme.mapAPI = window.theme.mapAPI || null),
    eu("map", {
      onLoad() {
        r5[this.id] = new (class {
          initMaps() {
            (function (t) {
              if (null === window.theme.mapAPI) {
                let e = `https://maps.googleapis.com/maps/api/js?key=${t}`;
                window.theme.mapAPI = rf({ url: e });
              }
              return window.theme.mapAPI;
            })(this.key)
              .then(() => {
                var t;
                return "true" === this.enableCorrection &&
                  "" !== this.lat &&
                  "" !== this.long
                  ? new google.maps.LatLng(this.lat, this.long)
                  : ((t = this.address),
                    new Promise((e, i) => {
                      new google.maps.Geocoder().geocode(
                        { address: t },
                        function (t, s) {
                          "OK" == s
                            ? e({
                                lat: t[0].geometry.location.lat(),
                                lng: t[0].geometry.location.lng(),
                              })
                            : i(s);
                        }
                      );
                    }));
              })
              .then((t) => {
                var e, i, s, r, o;
                let a = {
                    zoom: parseInt(this.zoomString, 10),
                    styles: r4[(e = this.styleString)],
                    center: t,
                    draggable: !0,
                    clickableIcons: !1,
                    scrollwheel: !1,
                    zoomControl: !1,
                    disableDefaultUI: !0,
                  },
                  n =
                    ((i = this.mapContainer),
                    (s = a),
                    (o = (r = new google.maps.Map(i, s)).getCenter()),
                    new google.maps.Marker({ map: r, position: o }),
                    google.maps.event.addDomListener(
                      window,
                      "resize",
                      function () {
                        google.maps.event.trigger(r, "resize"), r.setCenter(o);
                      }
                    ),
                    r);
                return n;
              })
              .then((t) => {
                (this.map = t), (r5[this.id] = t);
              })
              .catch((t) => {
                console.log("Failed to load Google Map"), console.log(t);
              });
          }
          unload() {
            void 0 !== window.google &&
              google.maps.event.clearListeners(this.map, "resize");
          }
          constructor(t) {
            (this.container = t.container),
              (this.mapContainer = this.container.querySelector(
                "[data-map-container]"
              )),
              (this.key = this.container.getAttribute("data-api-key")),
              (this.styleString =
                this.container.getAttribute("data-style") || ""),
              (this.zoomString =
                this.container.getAttribute("data-zoom") || 14),
              (this.address = this.container.getAttribute("data-address")),
              (this.enableCorrection = this.container.getAttribute(
                "data-latlong-correction"
              )),
              (this.lat = this.container.getAttribute("data-lat")),
              (this.long = this.container.getAttribute("data-long")),
              this.key && this.initMaps();
          }
        })(this);
      },
      onUnload() {
        "function" == typeof r5[this.id].unload && r5[this.id].unload();
      },
    });
  let r6 = (t, e = null) => {
      (t.style.opacity = 1),
        (function i() {
          (t.style.opacity -= 0.1) < 0
            ? (t.style.display = "none")
            : requestAnimationFrame(i),
            0 === parseFloat(t.style.opacity) && "function" == typeof e && e();
        })();
    },
    rJ = "[data-tracking-consent]",
    rY = "[data-close-modal]",
    r7 = "[data-newsletter-form]",
    rG = "data-cookie-name",
    rK = "data-target-referrer",
    rZ = "hidden",
    ot = "has-value",
    oe = "cart-bar-visible",
    oi = "is-visible",
    os = "has-success",
    or = "selected",
    oo = "has-block-selected",
    oa = {},
    on = class {
      always() {
        ty(this.element, null, this.callback);
      }
      delayed(t = 10) {
        setTimeout(() => {
          ty(this.element, null, this.callback);
        }, 1e3 * t);
      }
      idle() {
        let t = 0,
          e = [
            "mousemove",
            "mousedown",
            "click",
            "touchmove",
            "touchstart",
            "touchend",
            "keydown",
            "keypress",
          ],
          i = ["load", "resize", "scroll"],
          s = () => {
            (t = setTimeout(() => {
              (t = 0), ty(this.element, null, this.callback);
            }, 6e4)),
              e.forEach((t) => {
                document.addEventListener(t, r);
              }),
              i.forEach((t) => {
                window.addEventListener(t, r);
              });
          },
          r = () => {
            t && clearTimeout(t),
              e.forEach((t) => {
                document.removeEventListener(t, r);
              }),
              i.forEach((t) => {
                window.removeEventListener(t, r);
              }),
              s();
          };
        s();
      }
      bottom() {
        document.addEventListener("theme:scroll", this.showPopupOnScrollEvent);
      }
      showPopupOnScroll() {
        window.scrollY + window.innerHeight >= document.body.clientHeight &&
          (ty(this.element, null, this.callback),
          document.removeEventListener(
            "theme:scroll",
            this.showPopupOnScrollEvent
          ));
      }
      onUnload() {
        document.removeEventListener(
          "theme:scroll",
          this.showPopupOnScrollEvent
        );
      }
      constructor(t, e, i = null) {
        if (
          ((this.element = e),
          (this.delay = t.getAttribute("data-popup-delay")),
          (this.isSubmitted =
            -1 !== window.location.href.indexOf("accepts_marketing") ||
            -1 !== window.location.href.indexOf("customer_posted=true")),
          (this.callback = i),
          (this.showPopupOnScrollEvent = () => this.showPopupOnScroll()),
          ("always" === this.delay || this.isSubmitted) && this.always(),
          this.delay && this.delay.includes("delayed") && !this.isSubmitted)
        ) {
          let s = this.delay.includes("_")
            ? parseInt(this.delay.split("_")[1])
            : 10;
          this.delayed(s);
        }
        "bottom" !== this.delay || this.isSubmitted || this.bottom(),
          "idle" !== this.delay || this.isSubmitted || this.idle();
      }
    },
    ol = class {
      init() {
        -1 !== this.locationPath.indexOf(this.el.getAttribute(rK)) ||
          window.Shopify.designMode ||
          this.el.parentNode.removeChild(this.el);
      }
      constructor(t) {
        if (
          ((this.el = t),
          (this.locationPath = location.href),
          !this.el.hasAttribute(rK))
        )
          return !1;
        this.init();
      }
    };
  eu("popups", [
    {
      onLoad() {
        (oa[this.id] = []),
          this.container.querySelectorAll("[data-large-promo]").forEach((t) => {
            oa[this.id].push(
              new (class {
                init() {
                  let t = !1 !== this.cookie.read(),
                    e = this.popup.classList.contains("mobile"),
                    i = this.popup.classList.contains("desktop"),
                    s = !E(),
                    r = !0;
                  ((e && !s) || (i && s)) && (r = !1),
                    r
                      ? (t && !window.Shopify.designMode) ||
                        (window.Shopify.designMode ||
                          new on(this.popup, this.modal, () =>
                            this.scrollLock()
                          ),
                        this.form &&
                          this.form.classList.contains(os) &&
                          this.checkForSuccess(),
                        this.initClosers())
                      : this.scrollUnlock();
                }
                checkForSuccess() {
                  ty(this.modal, null, () => this.scrollLock()),
                    this.cookie.write();
                }
                initClosers() {
                  this.close.addEventListener(
                    "click",
                    this.closeModal.bind(this)
                  ),
                    this.underlay.addEventListener(
                      "click",
                      this.closeModal.bind(this)
                    );
                }
                closeModal(t) {
                  t.preventDefault(),
                    r6(this.modal),
                    this.cookie.write(),
                    this.scrollUnlock();
                }
                scrollLock() {
                  "none" !== window.getComputedStyle(this.popup).display &&
                    (this.a11y.trapFocus(this.modal),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:lock", { bubbles: !0 })
                    ));
                }
                scrollUnlock() {
                  this.a11y.removeTrapFocus(),
                    document.dispatchEvent(
                      new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                    );
                }
                onBlockSelect(t) {
                  this.popup.contains(t.target) &&
                    (ty(this.modal, null, () => this.scrollLock()),
                    this.popup.classList.add(or),
                    this.popup.parentNode.classList.add(oo));
                }
                onBlockDeselect(t) {
                  this.popup.contains(t.target) &&
                    (r6(this.modal),
                    this.scrollUnlock(),
                    this.popup.classList.remove(or),
                    this.popup.parentNode.classList.remove(oo));
                }
                constructor(t) {
                  (this.popup = t),
                    (this.modal = this.popup.querySelector(
                      "[data-large-promo-inner]"
                    )),
                    (this.close = this.popup.querySelector(rY)),
                    (this.underlay = this.popup.querySelector(
                      "[data-modal-underlay]"
                    )),
                    (this.form = this.popup.querySelector(r7)),
                    (this.cookie = new eO(
                      this.popup.getAttribute(rG),
                      "user_has_closed"
                    )),
                    (this.isTargeted = new ol(this.popup)),
                    (this.a11y = z),
                    this.init();
                }
              })(t)
            );
          }),
          this.container.querySelectorAll(rJ).forEach((t) => {
            oa[this.id].push(
              new (class {
                init() {
                  this.showPopup && ty(this.modal), this.clickEvents();
                }
                clickEvents() {
                  this.acceptButton.addEventListener("click", (t) => {
                    t.preventDefault(),
                      window.Shopify.customerPrivacy.setTrackingConsent(
                        !0,
                        () => r6(this.modal)
                      ),
                      document.documentElement.style.setProperty(
                        "--cookie-bar-height",
                        "0px"
                      );
                  }),
                    document.addEventListener(
                      "trackingConsentAccepted",
                      () => {}
                    );
                }
                onBlockSelect(t) {
                  this.popup.contains(t.target) &&
                    this.showPopup &&
                    (ty(this.modal),
                    this.popup.classList.add(or),
                    this.popup.parentNode.classList.add(oo));
                }
                onBlockDeselect(t) {
                  this.popup.contains(t.target) &&
                    (r6(this.modal),
                    this.popup.classList.remove(or),
                    this.popup.parentNode.classList.remove(oo));
                }
                constructor(t) {
                  (this.popup = t),
                    (this.modal = document.querySelector(rJ)),
                    (this.acceptButton = this.modal.querySelector(
                      "[data-confirm-cookies]"
                    )),
                    (this.enable =
                      "true" === this.modal.getAttribute("data-enable")),
                    (this.showPopup = !1),
                    window.Shopify.loadFeatures(
                      [{ name: "consent-tracking-api", version: "0.1" }],
                      (t) => {
                        if (t) throw t;
                        let e =
                            window.Shopify.customerPrivacy.userCanBeTracked(),
                          i =
                            window.Shopify.customerPrivacy.getTrackingConsent();
                        (this.showPopup =
                          !e && "no_interaction" === i && this.enable),
                          window.Shopify.designMode && (this.showPopup = !0),
                          this.init();
                      }
                    );
                }
              })(t)
            );
          }),
          this.container.querySelectorAll("[data-newsletter]").forEach((t) => {
            oa[this.id].push(
              new (class {
                init() {
                  let t = !1 !== this.cookie.read(),
                    e =
                      -1 !==
                      window.location.search.indexOf("?customer_posted=true"),
                    i = [...this.holder.classList]
                      .toString()
                      .includes("bottom");
                  e && (this.delay = 0),
                    (t && !window.Shopify.designMode) ||
                      (this.show(),
                      this.form.classList.contains(os) &&
                        this.checkForSuccess()),
                    i && this.observeCartBar();
                }
                show() {
                  window.Shopify.designMode
                    ? ty(this.holder)
                    : new on(this.popup, this.holder),
                    this.showForm(),
                    this.inputField(),
                    this.closePopup();
                }
                checkForSuccess() {
                  ty(this.holder), this.cookie.write();
                }
                observeCartBar() {
                  if (
                    ((this.cartBar = document.getElementById("cart-bar")),
                    !this.cartBar)
                  )
                    return;
                  let t = this.cartBar.classList.contains(oi);
                  document.body.classList.toggle(oe, t),
                    (this.observer = new MutationObserver((e) => {
                      for (let i of e)
                        "attributes" === i.type &&
                          ((t = i.target.classList.contains(oi)),
                          document.body.classList.toggle(oe, t));
                    })),
                    this.observer.observe(this.cartBar, {
                      attributes: !0,
                      childList: !1,
                      subtree: !1,
                    });
                }
                showForm() {
                  this.heading.addEventListener("click", (t) => {
                    t.preventDefault(),
                      this.heading.classList.add(rZ),
                      this.form.classList.remove(rZ),
                      this.newsletterField.focus();
                  }),
                    this.heading.addEventListener("keyup", (t) => {
                      "Enter" === t.code &&
                        this.heading.dispatchEvent(new Event("click"));
                    });
                }
                closePopup() {
                  this.close.addEventListener("click", (t) => {
                    t.preventDefault(), r6(this.holder), this.cookie.write();
                  });
                }
                inputField() {
                  let t = () => {
                    this.resetClassTimer && clearTimeout(this.resetClassTimer),
                      "" !== this.newsletterField.value &&
                        this.holder.classList.add(ot);
                  };
                  this.newsletterField.addEventListener("input", t),
                    this.newsletterField.addEventListener("focus", t),
                    this.newsletterField.addEventListener("focusout", () => {
                      this.resetClassTimer &&
                        clearTimeout(this.resetClassTimer),
                        (this.resetClassTimer = setTimeout(() => {
                          this.holder.classList.remove(ot);
                        }, 2e3));
                    });
                }
                onBlockSelect(t) {
                  this.popup.contains(t.target) &&
                    (ty(this.holder),
                    this.popup.classList.add(or),
                    this.popup.parentNode.classList.add(oo));
                }
                onBlockDeselect(t) {
                  this.popup.contains(t.target) &&
                    (r6(this.holder),
                    this.popup.classList.remove(or),
                    this.popup.parentNode.classList.remove(oo));
                }
                onUnload() {
                  this.observer && this.observer.disconnect();
                }
                constructor(t) {
                  (this.popup = t),
                    (this.holder = this.popup.querySelector(
                      "[data-newsletter-holder]"
                    )),
                    (this.close = this.popup.querySelector(
                      "[data-newsletter-close]"
                    )),
                    (this.heading = this.popup.querySelector(
                      "[data-newsletter-heading]"
                    )),
                    (this.newsletterField = this.popup.querySelector(
                      "[data-newsletter-field]"
                    )),
                    (this.cookie = new eO(
                      this.popup.getAttribute(rG),
                      "newsletter_is_closed"
                    )),
                    (this.form = this.popup.querySelector(r7)),
                    (this.isTargeted = new ol(this.popup)),
                    (this.resetClassTimer = 0),
                    this.init();
                }
              })(t)
            );
          }),
          this.container.querySelectorAll("[data-promo-text]").forEach((t) => {
            oa[this.id].push(
              new (class {
                init() {
                  (!1 === this.cookie.read() || window.Shopify.designMode) &&
                    (window.Shopify.designMode
                      ? ty(this.popup)
                      : new on(this.popup, this.popup),
                    this.clickEvents());
                }
                clickEvents() {
                  this.close.addEventListener("click", (t) => {
                    t.preventDefault(), r6(this.popup), this.cookie.write();
                  });
                }
                onBlockSelect(t) {
                  this.popup.contains(t.target) &&
                    (ty(this.popup),
                    this.popup.classList.add(or),
                    this.popup.parentNode.classList.add(oo));
                }
                onBlockDeselect(t) {
                  this.popup.contains(t.target) &&
                    (r6(this.popup),
                    this.popup.classList.remove(or),
                    this.popup.parentNode.classList.remove(oo));
                }
                constructor(t) {
                  (this.popup = t),
                    (this.close = this.popup.querySelector(rY)),
                    (this.cookie = new eO(
                      this.popup.getAttribute(rG),
                      "user_has_closed"
                    )),
                    (this.isTargeted = new ol(this.popup)),
                    this.init();
                }
              })(t)
            );
          });
      },
      onBlockSelect(t) {
        oa[this.id].forEach((e) => {
          "function" == typeof e.onBlockSelect && e.onBlockSelect(t);
        });
      },
      onBlockDeselect(t) {
        oa[this.id].forEach((e) => {
          "function" == typeof e.onBlockDeselect && e.onBlockDeselect(t);
        });
      },
      onUnload() {
        oa[this.id].forEach((t) => {
          "function" == typeof t.onUnload && t.onUnload();
        });
      },
    },
    eU,
  ]);
  let oh = "is-open";
  eu("password-template", {
    onLoad() {
      new (class {
        init() {
          this.passwordLogin.length &&
            this.modal &&
            this.modalBody &&
            (this.passwordLogin.forEach((t) => {
              t.addEventListener("click", (t) => {
                t.preventDefault(), this.openModal();
              });
            }),
            this.closeButtons.length &&
              this.closeButtons.forEach((t) => {
                t.addEventListener("click", (t) => {
                  t.preventDefault(), this.closeModal();
                });
              }),
            this.loginErrors && this.openModal());
        }
        openModal() {
          ty(this.modal, "block", () => {
            this.modal.classList.add(oh);
          }),
            this.scrollLock();
        }
        closeModal() {
          r6(this.modal), this.modal.classList.remove(oh), this.scrollUnlock();
        }
        scrollLock() {
          "none" !== window.getComputedStyle(this.modal).display &&
            (this.a11y.trapFocus(this.modal),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:lock", { bubbles: !0 })
            ));
        }
        scrollUnlock() {
          this.a11y.removeTrapFocus(),
            document.dispatchEvent(
              new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
            );
        }
        constructor(t) {
          (this.container = t.container),
            (this.passwordLogin = this.container.querySelectorAll(
              "[data-password-login]"
            )),
            (this.modal = this.container.querySelector(
              "[data-password-modal]"
            )),
            (this.modalBody =
              this.container.querySelector("[data-modal-body]")),
            (this.closeButtons =
              this.container.querySelectorAll("[data-modal-close]")),
            (this.a11y = z),
            (this.loginErrors = this.container.querySelector(
              "#login_form .errors"
            )),
            this.init();
        }
      })(this);
    },
  }),
    eu("list-collections", [eI, i0]),
    eu("columns", [i0, eI]),
    eu("newsletter", eU),
    eu("before-after", [rX]);
  let oc = "data-tooltip-stop-mouseenter",
    od = {},
    ou = "is-selected",
    op = "data-scroll-spy",
    om = "data-scroll-spy-mobile",
    og = "data-scroll-spy-desktop",
    of = {},
    ov = {
      onLoad() {
        of[this.id] = new (class {
          init() {
            this.loopAnchors(),
              document.addEventListener("theme:resize:width", this.loopAnchors);
          }
          loopAnchors() {
            this.scrollSpyAnchors.length &&
              this.scrollSpyAnchors.forEach((t) => {
                this.toggleObserver(t);
              });
          }
          toggleObserver(t) {
            let e = this.container.querySelector(t.getAttribute(op));
            if (!e) return;
            this.observers[e.id] && this.observers[e.id].unobserve(e);
            let i = E();
            ((!i && t.hasAttribute(om)) ||
              (i && t.hasAttribute(og)) ||
              (!t.hasAttribute(og) && !t.hasAttribute(om))) &&
              this.runObserver(e);
          }
          runObserver(t) {
            let { headerHeight: e } = h(),
              i = Boolean(document.querySelector("[data-header-sticky]"));
            e = i ? e : 0;
            let s = {
              rootMargin: i ? -1 * e + "px 0px 0px 0px" : "0px",
              threshold: [0.5, 1],
            };
            (this.observers[t.id] = new IntersectionObserver((t) => {
              t.forEach((t) => {
                let i = this.container.querySelector(`[${op}].${ou}`),
                  s = this.container.querySelector(`[${op}="#${t.target.id}"]`);
                t.intersectionRatio > 0.5 &&
                  t.boundingClientRect.top - e <= t.boundingClientRect.height &&
                  (null == i || i.classList.remove(ou),
                  null == s || s.classList.add(ou));
              });
            }, s)),
              this.observers[t.id].observe(t);
          }
          onUnload() {
            document.removeEventListener(
              "theme:resize:width",
              this.loopAnchors
            ),
              this.observers.length &&
                this.observers.forEach((t) => {
                  t.disconnect();
                });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollSpyAnchors =
                this.container.querySelectorAll("[data-scroll-spy]")),
              (this.loopAnchors = this.loopAnchors.bind(this)),
              (this.observers = []),
              this.init();
          }
        })(this);
      },
      onUnload() {
        of[this.id].onUnload();
      },
    };
  eu("sidebar", [
    {
      onLoad() {
        od[this.id] = new (class {
          init() {
            this.scrollToButtons.forEach((t) => {
              t.addEventListener("click", () => {
                let e = this.container.querySelector(
                  t.getAttribute("data-scroll-to")
                );
                e && "A" !== t.tagName && this.scrollToElement(e);
              });
            });
          }
          scrollToElement(t) {
            eF(t.getBoundingClientRect().top + 1);
            let e = t.nextElementSibling.matches("details")
              ? t.nextElementSibling
              : null;
            if (e) {
              let i =
                null == e
                  ? void 0
                  : e.querySelector("[data-collapsible-trigger]");
              e.hasAttribute("open") ||
                null == i ||
                i.dispatchEvent(new Event("click"));
            }
            let s = document.querySelectorAll(`[data-tooltip]:not([${oc}])`);
            s.length &&
              s.forEach((t) => {
                t.setAttribute(oc, ""),
                  setTimeout(() => {
                    t.removeAttribute(oc);
                  }, 1e3);
              });
          }
          constructor(t) {
            (this.section = t),
              (this.container = t.container),
              (this.scrollToButtons =
                this.container.querySelectorAll("[data-scroll-to]")),
              this.scrollToButtons.length && this.init();
          }
        })(this);
      },
    },
    ov,
  ]);
  let oy = "[data-hover-target]",
    ob = "data-hover-target",
    oS = "is-visible",
    oE = "is-selected",
    oL = {};
  eu("collections-hover", [
    {
      onLoad() {
        oL[this.id] = new (class {
          init() {
            this.buttons.length &&
              this.buttons.forEach((t) => {
                t.addEventListener("mouseenter", (t) => {
                  let e = t.currentTarget.getAttribute(ob);
                  this.updateState(e);
                });
              });
          }
          updateState(t) {
            let e = this.container.querySelector(`[${ob}="${t}"]`),
              i = this.container.querySelector(`#${t}:not(.${oS})`),
              s = this.container.querySelector(`${oy}.${oE}`),
              r = this.container.querySelector(`[data-collection-image].${oS}`);
            i &&
              E() &&
              (null == r || r.classList.remove(oS),
              null == s || s.classList.remove(oE),
              i.classList.add(oS),
              e.classList.add(oE));
          }
          onBlockSelect(t) {
            this.updateState(t.target.id);
          }
          constructor(t) {
            (this.container = t.container),
              (this.buttons = this.container.querySelectorAll(oy)),
              this.init();
          }
        })(this);
      },
      onBlockSelect(t) {
        oL[this.id].onBlockSelect(t);
      },
    },
    ov,
  ]);
  let ow = "[data-header-height]",
    ok = {};
  eu("featured-product", [
    {
      onLoad() {
        ok[this.id] = new (class {
          init() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.addEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                (this.calculateHeight(),
                document.addEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                ));
          }
          calculateHorizontalPosition(t) {
            let e = t.detail.position + this.headerHeight,
              i = e + window.innerHeight,
              s = this.imagesHolder.offsetTop,
              r = this.imagesHolder.offsetHeight,
              o = s + r + this.headerHeight,
              a = r - (window.innerHeight - this.headerHeight),
              n = 0;
            (n = e >= s && i <= o ? ((e - s) / a) * 100 : e < s ? 0 : 100),
              (n *= this.images.length - 1),
              this.container.style.setProperty("--translateX", -1 * n + "%");
          }
          calculateHeight() {
            this.container.style.removeProperty("--min-height"),
              this.container.style.setProperty(
                "--min-height",
                `${
                  this.wrapper.offsetHeight + this.contentHolder.offsetHeight
                }px`
              ),
              (this.headerHeight = this.getHeaderHeight());
          }
          getHeaderHeight() {
            return document.querySelector("[data-header-sticky]") &&
              document.querySelector(ow)
              ? parseInt(
                  document.querySelector(ow).getBoundingClientRect().height
                )
              : 0;
          }
          onUnload() {
            this.horizontalScroll &&
              this.imagesHolder &&
              document.removeEventListener(
                "theme:scroll",
                this.calculateHorizontalPositionEvent
              ),
              this.wrapper &&
                this.contentHolder &&
                this.images.length &&
                document.removeEventListener(
                  "theme:resize:width",
                  this.calculateHeightEvent
                );
          }
          constructor(t) {
            (this.container = t.container),
              (this.horizontalScroll = this.container.hasAttribute(
                "data-horizontal-scroll"
              )),
              (this.images = this.container.querySelectorAll(
                "[data-featured-image]"
              )),
              (this.imagesHolder = this.container.querySelector(
                "[data-featured-aside]"
              )),
              (this.contentHolder = this.container.querySelector(
                "[data-featured-content]"
              )),
              (this.wrapper = this.container.querySelector(
                "[data-featured-wrapper]"
              )),
              (this.headerHeight = this.getHeaderHeight()),
              (this.calculateHorizontalPositionEvent = (t) =>
                this.calculateHorizontalPosition(t)),
              (this.calculateHeightEvent = () => this.calculateHeight()),
              this.init();
          }
        })(this);
      },
      onUnload(t) {
        ok[this.id].onUnload(t);
      },
    },
  ]),
    document.addEventListener("DOMContentLoaded", function () {
      ep("*");
      let t = document.querySelector("[data-scroll-top-button]");
      t &&
        (t.addEventListener("click", () => {
          window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
        }),
        document.addEventListener("theme:scroll", () => {
          t.classList.toggle(
            "is-visible",
            window.pageYOffset > window.innerHeight
          );
        })),
        window.self !== window.top &&
          document.querySelector("html").classList.add("iframe"),
        "scrollBehavior" in document.documentElement.style ||
          rf({ url: window.theme.assets.smoothscroll });
    }),
    window.navigator.cookieEnabled &&
      (document.documentElement.className =
        document.documentElement.className.replace(
          "supports-no-cookies",
          "supports-cookies"
        ));
})(
  themeVendor.ScrollLock,
  themeVendor.themeAddresses,
  themeVendor.themeCurrency,
  themeVendor.Rellax,
  themeVendor.Flickity,
  themeVendor.FlickityFade,
  themeVendor.themeImages
),
  applySlider(),
  $(document).ready(function () {
    $(".footeraccordion-header").click(function () {
      $(this).toggleClass("active"),
        $(this).next(".footeraccordion-content").slideToggle("fast"),
        $(".footeraccordion-content")
          .not($(this).next(".footeraccordion-content"))
          .slideUp("fast"),
        $(".footeraccordion-header").not(this).removeClass("active");
    });
  });
var didScroll,
  __defProp = Object.defineProperty,
  __defNormalProp = (t, e, i) =>
    e in t
      ? __defProp(t, e, {
          enumerable: !0,
          configurable: !0,
          writable: !0,
          value: i,
        })
      : (t[e] = i),
  __publicField = (t, e, i) => (
    __defNormalProp(t, "symbol" != typeof e ? e + "" : e, i), i
  );
console.log("__publicField", __publicField);
var _CartDrawerRecommendations = class extends HTMLElement {
    async connectedCallback() {
      _CartDrawerRecommendations.recommendationsCache[this.productId] ||
        (console.log("hello0000000000"),
        (_CartDrawerRecommendations.recommendationsCache[this.productId] =
          fetch(
            `${window.themeVariables.routes.productRecommendationsUrl}?product_id=${this.productId}&limit=10&section_id=${this.sectionId}`
          )));
      let t = await _CartDrawerRecommendations.recommendationsCache[
        this.productId
      ];
      console.log("response", t);
      let e = document.createElement("div");
      e.innerHTML = await t.clone().text();
      let i = e.querySelector("cart-drawer-recommendations");
      i && i.hasChildNodes()
        ? (this.innerHTML = i.innerHTML)
        : (this.hidden = !0);
    }
    get productId() {
      return this.getAttribute("product-id");
    }
    get sectionId() {
      return this.getAttribute("section-id");
    }
  },
  CartDrawerRecommendations = _CartDrawerRecommendations;
__publicField(CartDrawerRecommendations, "recommendationsCache", {}),
  window.customElements.define(
    "cart-drawer-recommendations",
    CartDrawerRecommendations
  );
var lastScrollTop = 0,
  delta = 0,
  // navbarHeightMain = $(".header__wrapper").outerHeight(),
  // navbarHeight = navbarHeightMain + 100 ;
  navbarHeight = $(".header__wrapper").outerHeight();
console.log(navbarHeight, "navbarHeight----------------------------------");

console.log(lastScrollTop, "lastScrollTop----------------------------------");
// function hasScrolled() {
//   var t = $(this).scrollTop() ;
//   // console.log(t,"t----------------------------------");

//   Math.abs(lastScrollTop - t) <= delta || (t > lastScrollTop && t > navbarHeight
//       ? $(".header__wrapper").removeClass("js__header__stuck").addClass("nav-up")
//       : t + $(window).height() < $(document).height() &&
//         $(".header__wrapper").removeClass("nav-up").addClass("js__header__stuck"),
//     0 == t &&
//       ($(".header__wrapper").removeClass("js__header__stuck"),
//       console.log("st", t)),
//     (lastScrollTop = t));
// }
function hasScrolled() {
  var t = $(this).scrollTop();
  // Check if the difference between current and last scroll is greater than delta
  if (Math.abs(lastScrollTop - t) > delta) {
    if (t > lastScrollTop && t > navbarHeight) {
      // Scrolling down and past the header height + offset
      $(".header__wrapper").removeClass("js__header__stuck").addClass("nav-up");
      console.log("Scrolling down past navbarHeight + offset");
    } else if (t + $(window).height() < $(document).height()) {
      // Scrolling up and not at the bottom of the page
      $(".header__wrapper").removeClass("nav-up").addClass("js__header__stuck");
      console.log("Scrolling up, applying sticky");
    }

    // Reset header class when scrolled back to within 36px from the top
    if (t <= 36) {
      $(".header__wrapper").removeClass("js__header__stuck");
      console.log("Within 36px from the top, removing sticky");
    }

    // Update last scroll position
    lastScrollTop = t;
  }
}
$(window).scroll(function (t) {
  didScroll = !0;
}),
  setInterval(function () {
    didScroll && (hasScrolled(), (didScroll = !1));
  }, 100);
// ,
// }, 250),
$(document).ready(function () {
  $(".navlink").hover(
    function () {
      $(this).addClass("active");
    },
    function () {
      $(this).removeClass("active");
    }
  );
});
